// ./src/autoGenerated/latestAllStudentOrgs.ts
//
// AUTO-GENERATED on 2024-09-23T01:17:24.348Z. DO NOT MODIFY.
// For details see "@scripts/genStudentOrgs/".

// Type imports.
import type { StudentOrg } from "@src/schemas/StudentOrg";

export const latestAllStudentOrgs: StudentOrg[] =
[
  {
    "name": "The Alliance of Students with Disabilities for Inclusion, Networking, and Transition Opportunities in STEM at The Ohio State University",
    "purposeStatement": "The Alliance of Students with Disabilities for Inclusion, Networking, and Transition Opportunities in STEM at The Ohio State University (TAP...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "1 Day For The K.I.A., Inc.",
    "purposeStatement": "1 Day for the K.I.A.’s purpose is to raise awareness and commemorate fallen military service members. 1 Day for the K.I.A. accomplishes our ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "1825 at Ohio State",
    "purposeStatement": "To help students at The Ohio State University come to faith, and grow in their walks with the Lord. To see God change people through spiritu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "The 2nd and 7 Foundation Medical Branch",
    "purposeStatement": "The mission of the 2nd and 7 Foundation Medical Branch at the Ohio State University College of Medicine is to promote literacy and healthy h...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "3D Dance Team",
    "purposeStatement": "Our organization will provide a creative outlet for aspiring dancers. We strive to expose our members as well as our audiences to the art of...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "4 Paws For Ability at Ohio State",
    "purposeStatement": "We work as a college branch of 4 Paws for Ability to train obedience and socialize service dogs in training on campus. Our parent organizati...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "4-Wall Handball Club",
    "purposeStatement": "This organization is dedicated to the growth and development of the sport of handball for all ages and skill levels in order to better promo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "412 Teens",
    "purposeStatement": "412 at Ohio State is a non-denominational student Christian Organization seeking o provide a spiritual environment for students desiring to ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "5210! Healthy LifeStars",
    "purposeStatement": "To increase efforts toward improving childhood nutrition and physical activity and preventing the onset of Type II Diabetes in the youth of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Sports and Recreation"
    ]
  },
  {
    "name": "614college",
    "purposeStatement": "We are unapologetically and radically obsessed with Jesus. Come find out why",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "8-Bit Buckeyes",
    "purposeStatement": "The primary goal of 8-Bit Buckeyes is to create a fun, inclusive environment that connects members of the OSU community through playing loca...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation",
      "Technology"
    ]
  },
  {
    "name": "8th Floor Improv Comedy Group",
    "purposeStatement": "To provide Ohio State - and all of Columbus - with a unique brand of comedic entertainment, focusing on long-form improv comedy.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "A Kid Again at Ohio State",
    "purposeStatement": "The Ohio State A Kid Again Club is a student organization that was created to serve the local Columbus chapter of A Kid Again.  A Kid Again ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "A Moment Of Magic at Ohio State",
    "purposeStatement": "A Moment of Magic's purpose is to instill happiness and hope in children who have disabilities or medical vulnerabilities. A Moment of Magic...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "The Academic Team at The Ohio State University",
    "purposeStatement": "The Academic Team is the official Quizbowl Organization for OSU. Quizbowl, also known as Academic Challenge, Quick Recall, In The Know, or N...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Academy of General Dentistry Student Chapter at The Ohio State University College of Dentistry",
    "purposeStatement": "AGD’s mission is to “advance general dentistry and oral health through quality continuing education and advocacy.” Through this mission, AGD...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Accessible Prosthetics Initiative",
    "purposeStatement": "To increase accessibility to open-source prosthetic devices in underserved communities through education, networking, and device distributio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Technology"
    ]
  },
  {
    "name": "Accounting Association",
    "purposeStatement": "The mission of the Accounting Association is to provide an environment that allows for the development and enhancement of skills necessary f...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Ace Space at The Ohio State University",
    "purposeStatement": "Ace Space at The Ohio State University helps provide students with a-spec identities a safe place to form community and find resources, and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "ACLU of Ohio Action Team at Ohio State",
    "purposeStatement": "The ACLU of Ohio OSU Action Team exists to engage the student body in organizing, building power, and mobilizing for true social justice and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Actuarial Club at Ohio State",
    "purposeStatement": "ACOS is a student organization with the primary goal of providing students with valuable networking opportunities that may lead to internshi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Adaptive Sports and Wellness Student Group",
    "purposeStatement": "The Adaptive Sports and Wellness Student Group (ASWSG) aims to increase the awareness and involvement of The Ohio State University students ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Sports and Recreation"
    ]
  },
  {
    "name": "ADEA Chapter for Students, Residents and Fellows at The Ohio State University",
    "purposeStatement": "The American Dental Education Association (ADEA) is The Voice of Dental Education. Our mission is to lead institutions and individuals in th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Adopt-A-School",
    "purposeStatement": "Adopt-A-School is a student organization in which its volunteers tutor students at the nearby Graham Elementary and Middle School. As tutors...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Advocates For Children",
    "purposeStatement": "To promote and support quality advocacy for children while enabling law students to network with institutions and professionals serving the ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Advocates for Inclusion and Diversity through Education",
    "purposeStatement": "AIDE is a student organization that seeks to educate The Ohio State University community through initiatives that promote inclusive dialogue...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Advocates for Trauma-Informed Care",
    "purposeStatement": "To advance medical student's ability to provide trauma-informed care to survivors of sexual violence, including sexual assault and intimate ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Advocates for Women of the World",
    "purposeStatement": "Our mission is to advocate for global gender equality by spreading awareness of and taking action against issues faced by people marginalize...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "African American Heritage Festival",
    "purposeStatement": "The purpose of the Annual African American Heritage Festival at The Ohio State University is to create a venue of celebration, education, an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "African Youth League",
    "purposeStatement": "To make the greater Ohio State community aware of the African Youth League. To foster an inclusive and conducive environment where individua...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Age-Friendly Service Association",
    "purposeStatement": "Creating an intergenerational bridge between college students and the older adult population in Columbus to reform stigma around aging. We w...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Agent-7 Dance and Performance Club",
    "purposeStatement": "Our purpose is to create a space where enthusiasts of K-pop, J-pop, and C-pop can share their love for music, dance, and acting. Through our...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "The Agribusiness Club",
    "purposeStatement": "The purpose of this organization shall be: (a) To stimulate interest in and to provide information on the profession of agribusiness, and in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Agricultural Communication, Education, and Leadership - Graduate Student Association",
    "purposeStatement": "The ACEL Graduate Student Association strives to extend opportunities to graduate students with the primary goal of development.  The organi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Agricultural Communicators of Tomorrow",
    "purposeStatement": "The purposes of this organization shall be: Be a club where students who are interested in Agricultural Communications, whether that is thei...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College"
    ]
  },
  {
    "name": "Agricultural Education Society",
    "purposeStatement": "Practicing skills important to how people interact and learn about food, agriculture, and the environment.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Agricultural Systems Management Club",
    "purposeStatement": "The Agricultural Systems Management (ASM) Club strives to bring together ASM students and other interested students in the College of Food, ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Agricultural, Environmental, and Development Economics Graduate Student Association",
    "purposeStatement": "To foster a greater sense of community and support within the AEDE Graduate program by providing a variety of social and educational opportu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Ahmadiyya Muslim Students Association",
    "purposeStatement": "To spread the message of the International Ahmadiyya Muslim Community through activities and events, based on the motto, “Love for all, hatr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Aikido Club at Ohio State",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Albanians at The Ohio State University",
    "purposeStatement": "To bring together Ohio State students of Albanian/Kosovar background and those interested in learning about Albania and Kosovo. We want to c...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "The Alexander Hamilton Society at The Ohio State University",
    "purposeStatement": "The Alexander Hamilton Society (AHS) is an independent, non-partisan, not-for-profit organization dedicated to promoting constructive discus...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "All About Anesthesia",
    "purposeStatement": "This organization will consist of a group of medical student leaders who are dedicated to anesthesia care, pain management, and critical ca...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "All Girl Cheer Team - Sport Club",
    "purposeStatement": "The All Girl competitive cheerleading program is designed to serve the individual athlete's interests through practice, competition, and rec...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Allied Scholars for Animal Protection at Ohio State",
    "purposeStatement": "Allied Scholars for Animal Protection at Ohio State seeks to build the student vegan community and empower those students to become effectiv...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Alpha Alpha Alpha First-Generation Honor Society",
    "purposeStatement": "The purpose of this organization shall be to recognize academic achievements in first-generation college students, create enthusiasm for sch...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Alpha Chi Omega",
    "purposeStatement": "The purpose of Alpha Chi Omega Fraternity is “to encourage the spirit of true sisterhood, to develop through personal effort a high moral an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Alpha Epsilon Delta",
    "purposeStatement": "We are the Ohio Alpha chapter of Alpha Epsilon Delta, a national pre-professional health honorary society dedicated to preparing students fo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Alpha Epsilon Phi",
    "purposeStatement": "Alpha Epsilon Phi is a national sorority dedicated to helping women become the best they can be. We prize individuality, encouraging each me...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Governance Organizations"
    ]
  },
  {
    "name": "Alpha Eta Rho (Omicron Sigma Upsilon Chapter)",
    "purposeStatement": "-To further the cause of aviation in all of its branches. -To instill in the public mind a confidence in aviation and its safety -To promote...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Alpha Gamma Delta",
    "purposeStatement": "Alpha Gamma Delta Purpose  To gain understanding that wisdom may be vouchsafed to me. To develop and prize health and vigor of body. To cult...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Alpha Gamma Rho",
    "purposeStatement": "To be the premier fraternity shaping tomorrow’s leaders, improving one’s social, educational and professional skills, while developing a lif...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Alpha Gamma Sigma",
    "purposeStatement": "Alpha Gamma Sigma is a fraternity of agricultural heritage preparing men for life by:   coming together as scholars,   living as brothers,  ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Alpha Kappa Alpha Sorority, Incorporated",
    "purposeStatement": "The purpose of Alpha Kappa Alpha Sorority, Incorporated is to cultivate and encourage high scholastic and ethical standards, to promote unit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Alpha Lambda Delta",
    "purposeStatement": "Alpha Lambda Delta / Phi Eta Sigma (ALDPES) is Ohio State's Freshman Class Honorary. Our mission is to engage our members around our three c...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Alpha Lambda Mu at Ohio State",
    "purposeStatement": "Our mission is to connect, build, and sustain a lifelong brotherhood as the first Muslim-interest fraternity in America through excellence i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Ethnic/Cultural",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Alpha Omega Alpha Honor Medical Society",
    "purposeStatement": "The purpose of AOA is to honor excellence in medicine by recognizing those \"worthy to serve the suffering\".",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College"
    ]
  },
  {
    "name": "Alpha Omega Dental Fraternity Psi Chapter",
    "purposeStatement": "To build a community of likeminded dental professionals and students who are committed to help each other thrive professionally and socially...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Alpha Phi Alpha Fraternity Inc., Kappa Chapter",
    "purposeStatement": "Alpha Phi Alpha Fraternity Inc., develops leaders, promotes brotherhood and academic excellence while providing service and advocacy for our...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Alpha Phi Omega",
    "purposeStatement": "Alpha Phi Omega at Ohio State is a National Co-ed Fraternity devoted to leadership, friendship, and service. It is the VISION of Alpha Phi O...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Alpha Phi Sorority",
    "purposeStatement": "The purpose of this chapter is the promotion of growth in character, of unity of feeling, of sisterly affection and of social communion amon...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Alpha Psi Lambda",
    "purposeStatement": "Alpha Psi Lambda is OSU's first and only Co-Ed Latinx Fraternity. We were founded here in 1985 and have grown to become a National Organizat...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Special Interest",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Alpha Rho Chi Demetrios Chapter",
    "purposeStatement": "The objectives of this chapter are to organize and unite, for educational and professional development purposes, the students of architectur...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Alpha Sigma Phi Fraternity",
    "purposeStatement": "The purpose of the national fraternity is: \"To Better the Man, through the creation and perpetuation of brotherhood founded upon the values ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Alpha Sigma Upsilon",
    "purposeStatement": "This sorority was created not only as a social organization, but also as a means to recognize individuals worthy of honor, with interests in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Alpha Xi Delta Sorority",
    "purposeStatement": "Alpha Xi Delta's vision is \"Inspiring women to realize their potential.\"  Therefore, we dedicate ourselves to helping our members maximize t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Alpha Zeta Partners",
    "purposeStatement": "The purpose of the fraternity of Alpha Zeta is to bind together a group of men and women interested in the continued advancement of agricult...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Alternative Investment Club",
    "purposeStatement": "To provide students with a platform to learn about and explore investment opportunities beyond traditional options like stocks, bonds, and m...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Alumni Advancement Ambassadors",
    "purposeStatement": "We offer this program to students of the College of Arts and Sciences. Our goal is to provide students with professional development opportu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Amateur Radio and RF Club at The Ohio State University (W8LT)",
    "purposeStatement": "To encourage the amateur radio hobby and hands on Radio Frequency (RF) projects among students, to promote the use of good engineering pract...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "The Amateur Radio Organization for Undergraduate Student Entertainment",
    "purposeStatement": "To retain freedom of expression as a necessary function of quality entertainment, and maintain a respectful metadiscourse within an increasi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "American Association of Pharmaceutical Scientists Student Chapter at The Ohio State University",
    "purposeStatement": "The primary purpose of AAPS is to serve its membership, the pharmaceutical sciences as a whole, the biomedical and biotechnological communit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "American Association of Psychiatric Pharmacists",
    "purposeStatement": "Students dedicated to expanding awareness of psychiatric and neurologic pharmacy while promoting and advocating for the mental health of our...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "American Association of Public Health Dentistry - The Ohio State Student",
    "purposeStatement": "The purpose of this organization is to increase knowledge about the Dental Public Health specialty as well as increase oral health awareness...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "American Association of University Women at The Ohio State University",
    "purposeStatement": "To advance equity for women and girls through advocacy, education, and philanthropy, and to provide a supportive space at the Ohio State Uni...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The American Cancer Society Buckeye Chapter",
    "purposeStatement": "Our goal as ACS at The Ohio State Unviersity is to lead the fight for a world free from the the pain and suffering from cancer. With partner...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "The American Chemical Society Buckeye Chapter",
    "purposeStatement": "The purpose of the American Chemical Society Buckeye Chapter is to help students foster their interest in science by providing exposure to c...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "American Choral Directors Association at Ohio State",
    "purposeStatement": "Educate members and future choral music educators on topics and resources related to the field of choral music education, and connect them w...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "American Civil Liberties Union: Moritz Chapter at The Ohio State University",
    "purposeStatement": "The purpose of ACLU at Moritz is to raise awareness of, and foster discussion related to, our civil liberties, civil rights, and legal devel...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "American Conservation Coalition",
    "purposeStatement": "The American Conservation Coalition is changing the narrative on environmental discussions through promoting a mix of market-based, pro-busi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "American Constitution Society",
    "purposeStatement": "ACS is committed to fostering a progressive vision of the law on issues across the policy spectrum, including access to the courts; nondiscr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "The American Enterprise Institute at The Ohio State University",
    "purposeStatement": "The AEI OSU Chapter is an academic campus organization stemming from the DC think tank, the American Enterprise Institute, which aims to “de...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Governance Organizations",
      "Academic/College"
    ]
  },
  {
    "name": "The American Foundry Society Buckeye Student Chapter",
    "purposeStatement": "To provide and promote knowledge and experience in the metalcasting industry and to cultivate relationships between industry leaders, facult...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "American Institute of Aeronautics and Astronautics",
    "purposeStatement": "The objective of the American Institute of Aeronautics and Astronautics at The Ohio State University ( AIAA) is to promote education and adv...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "American Institute of Chemical Engineers",
    "purposeStatement": "Our mission is to serve the William G. Lowrie Department of Chemical and Biomolecular Engineering by engaging students with professional dev...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "American Marketing Association at Ohio State",
    "purposeStatement": "We are the only marketing student organization on OSU’s campus devoted to inspiring members to find their passion in marketing! We are dedic...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "American Medical Women's Association",
    "purposeStatement": "To bring together those in medicine and health-related fields to advocate for women's health and wellness initiatives, and to support member...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "American Muslim Medical Student Association",
    "purposeStatement": "American Muslim Medical Student Association (AMMSA) is an organization that aims to address important issues relevant to Muslim medical stud...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "American Nuclear Society Student Section",
    "purposeStatement": "The ANS Student Section aims to promote and raise awareness about Nuclear Science and Technology by sharing resources, networking, and engag...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "American Optometric Student Association",
    "purposeStatement": "The purpose of AOSA is to enhance awareness among students of current issues in optometry as well as to promote community service in the for...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "American Pharmacists Association Academy of Student Pharmacists",
    "purposeStatement": "We the members of the Academy of Students of Pharmacy hereby associate ourselves to: A.\tUphold the aims and aid in furthering the objectives...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Governance Organizations"
    ]
  },
  {
    "name": "The American Red Cross at Ohio State",
    "purposeStatement": "The purpose of the American Red Cross at Ohio State is to bring together a diverse, selfless group of leaders and volunteers to alleviate hu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "American Society for Microbiology Student Chapter at The Ohio State University",
    "purposeStatement": "The purpose of this organization is to promote a closer scientific relationship among persons interested in microbiology, to cultivate socia...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "American Society of Agricultural and Biological Engineers",
    "purposeStatement": "The American Society of Agricultural and Biological Engineers is an educational and professional organization dedicated to the advancement o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "The American Society of Biomechanics Chapter at The Ohio State University",
    "purposeStatement": "1.\tCreate, Connect, and improve research opportunities in Biomechanics for members. 2.\tProvide a community with resources to aid students wh...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "American Society of Civil Engineers Ohio State Student Chapter",
    "purposeStatement": "The object of this society shall be to afford an opportunity for the members of the Civil Engineering Department to become acquainted, to pr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "American Society of Consultant Pharmacists Student Chapter",
    "purposeStatement": "To provide a forum for pharmacy students to be able to become well-informed about pharmacists' roles in providing care to older adults and i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "American Society of Mechanical Engineers",
    "purposeStatement": "ASME OSU is The Ohio State University Student Section of the American Society of Mechanical Engineers. Our mission is to 1) Promote science ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "American String Teachers Association at Ohio State",
    "purposeStatement": "The American String Teachers Association promotes excellence in string and orchestra teaching and playing. ASTA pursues its mission through:...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "American Student Dental Association",
    "purposeStatement": "The American Student Dental Association is a national student-run organization that protects and advances the rights, interests, and welfare...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Governance Organizations"
    ]
  },
  {
    "name": "American Welding Society at The Ohio State University",
    "purposeStatement": "The AWS provides enhancements to welding education, professional development, and social activities to its members as well as interested ind...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Amnesty International",
    "purposeStatement": "We work to protect people wherever justice, freedom, truth, and dignity are denied. Amnesty International is a global movement of millions o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "AMPP® International Student Section at The Ohio State University",
    "purposeStatement": "The AMPP® International Student Section at The Ohio State University aims to utilize connections with AMPP® International and the local AMPP...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Anatomy Memorial Service Committee",
    "purposeStatement": "Our purpose is to organize and execute an annual memorial service for the families of individuals who have selflessly donated to the body do...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Anesthesiology Interest Group",
    "purposeStatement": "To increase the opportunities for students at The Ohio State University to better learn about and prepare for a career in the field of anest...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Anesthesiology Ultrasound Community of Practice Interest Group",
    "purposeStatement": "The Anesthesiology Ultrasound Community of Practice Interest Group is a group of medical student leaders who are dedicated to expanding acad...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Animal Science Community Alliance",
    "purposeStatement": "The purpose of the Animal Science Community Alliance shall be to:   -Recruit animal and meat science majors by enthusiastically representing...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Animal Sciences Graduate Student Association",
    "purposeStatement": "We the members of ASGSA hereby associate ourselves to promote fellowship and communication of information and ideas among all students inter...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Animal Welfare and Behavior Club",
    "purposeStatement": "To educate and promote animal welfare science to the University and greater community.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Animation Club at The Ohio State University",
    "purposeStatement": "To sponsor educational workshops, collaborate on creative projects, and enjoy animation in its limitless forms.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Technology"
    ]
  },
  {
    "name": "Antique Research Club",
    "purposeStatement": "The Antique Research Club is a club that aims to learn, research and educate others about antiques.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Creative and Performing Arts",
      "Technology"
    ]
  },
  {
    "name": "Applied Ethics and Technology at Ohio State",
    "purposeStatement": "This organization will engage in projects to bring public awareness to ethical issues. Initially, this will be done by creating a community ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Technology"
    ]
  },
  {
    "name": "Arab American Association of Engineers and Architects",
    "purposeStatement": "To support Arab-American students in the College of Engineering and Knowlton School of Architecture by fostering an encouraging community de...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Arab Business Society",
    "purposeStatement": "The Arab Business Society aims to provide educational & professional development opportunities to Fisher students at different points in the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Arab Dental Society",
    "purposeStatement": "The Arab Dental Society (hereafter referred to as ADS) of the OSU College of Dentistry (OSUCoD) is a professional student organization that ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Arab Medical Society",
    "purposeStatement": "The Arab Medical Society (AMS) provides an inclusive space for MENA-identifying students at The Ohio State University (OSU) seeking to promo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Arab Student Union",
    "purposeStatement": "The Arab Student Union seeks to create and maintain an Arab environment for the benefit of Arab students and interested members of the commu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "The Archery Club - Sport Club",
    "purposeStatement": "To promote and encourage the education and interest of the sport of archery at The Ohio State University.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Arena",
    "purposeStatement": "The Arena exists to form self-centered and individualistic boys who lack purpose or direction into men who lay their lives down to build som...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Social Fraternities/Sororities",
      "Special Interest"
    ]
  },
  {
    "name": "The Armed Forces Club at The Ohio State University College of Dentistry",
    "purposeStatement": "The Armed Forces Club at The Ohio State University College of Dentistry seeks to promote oral health in the Columbus community, to welcome n...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Armwrestlers at The Ohio State University",
    "purposeStatement": "Armwrestlers at The Ohio State University is a collection of students who want to get stronger together. The sport of armwrestling is growin...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Army ROTC Cadet Service Corps",
    "purposeStatement": "To organize fundraising events and social functions for the Army ROTC program at The Ohio State University.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Governance Organizations",
      "Technology"
    ]
  },
  {
    "name": "Arnold Air Society - General Curtis E. LeMay Squadron",
    "purposeStatement": "Arnold Air Society is primarily a professional, honorary, service organization advocating the support of aerospace power.  Additionally, the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Art & Resilience | Wexner Center for the Arts",
    "purposeStatement": "Interested in joining an Art & Resilience Student org?Interested in building community at the intersections of Art & Resilience? If you have...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Awareness/Activism",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Art and Sketchbook Club",
    "purposeStatement": "The purpose of this sketchbook club is to bring students together to share their creative skills and ideas. Art and sketchbook club is a clu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Art Club",
    "purposeStatement": "To create and facilitate the feeling of communal acceptance while exposing the OSU community to the wonders of art.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Art in Dentistry",
    "purposeStatement": "Arts in Dentistry's purpose is to be a creative outlet for dental students, to be a connection to artistic projects and community service, a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Art of Freedom Dabke Troupe at The Ohio State University",
    "purposeStatement": "Our purpose is to showcase the Middle Eastern Culture for the students at The Ohio State University through Dabke. Dabke is a traditional Le...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Artificial Intelligence Club",
    "purposeStatement": "Our purpose is to facilitate discussion, learning, and interest in the field of artificial intelligence, organize AI experts and researchers...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Artificial Intelligence Robotics Club",
    "purposeStatement": "The AI Robotics Club at The Ohio State University plans to advance artificial intelligence, robotics education, and autonomous systems by bu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Arts and Sciences Student Council",
    "purposeStatement": "Our primary purpose is to provide a link between the students and faculty of the Colleges of the Arts and Sciences.  This is achieved throug...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations"
    ]
  },
  {
    "name": "Arts Priori",
    "purposeStatement": "Arts Priori aims to promote and provide representative, academic, professional, administrative and social services specifically for the grad...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Ascend Pan-Asian Leaders at The Ohio State University",
    "purposeStatement": "Ascend OSU’s vision is to accomplish our mission and goal through events and interactions provided by Ascend to build up a bridge for Ascend...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Asian American Advocacy Alliance",
    "purposeStatement": "The Asian American Advocacy Alliance is a non-partisan student organization that is dedicated to advocating for and advancing Asian American...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Asian American Association",
    "purposeStatement": "The Asian American Association at The Ohio State University is a student organization that, since its inception in the early 1970’s, has ser...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Asian American InterVarsity Christian Fellowship at Ohio State",
    "purposeStatement": "In response to God's love, grace and truth: The Purpose of Asian American InterVarsity Christian Fellowship is to establish and advance at c...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Asian Business Student Association",
    "purposeStatement": "The Asian Business Student Association was established to provide its members and other students in the College of Business and the universi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Asian Pacific American Law Students Association",
    "purposeStatement": "Advocate the issues concerning Asian American law students at the Ohio State University. Establish a growing and working rapport with people...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Asian Pacific American Medical Student Association",
    "purposeStatement": "APAMSA is a national organization that aims to address those issues important to Asian- American medical students. One part of our mission i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Asian Pacific Islander Desi American Cohort Mentorship Program",
    "purposeStatement": "APIDA Cohort is an Asian/Asian American student organization that focuses on helping first-year and transfer students integrate to the Ohio ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Asian Pacific Student Dental Association",
    "purposeStatement": "The Asian Pacific Student Dental Association is a student-run organization which aims to serve as the collective voice of the OSU College of...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Ask A Muslim",
    "purposeStatement": "AAM-OSU’s aim is to eradicate misconceptions about Islam, to show a good example of a Muslim’s demeanor, and to show a good example of Islam...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Associated Press Sports Editors",
    "purposeStatement": "An APSE student chapter at Ohio State fosters the professional development of aspiring sports journalists. By offering workshops, seminars, ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Association for Future Healthcare Executives",
    "purposeStatement": "The Association of Future Healthcare Executives at The Ohio State University is committed to the following objectives.  a. To promote an env...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Association for India's Development",
    "purposeStatement": "Association for India's Development (AID) is a 501(C)(3) voluntary non-profit organization committed to promoting sustainable, equitable and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Association for Women in Mathematics Student Chapter at The Ohio State University",
    "purposeStatement": "The Association for Women in Mathematics Student Chapter at OSU is organized and operated for educational and scientific purposes. These inc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Association of Computing Machinery Committee on Women in Computing",
    "purposeStatement": "The mission of ACM-W is to support, celebrate, and advocate for the full engagement of women in all aspects of the computing field, engaging...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Association of Educational Psychology, Philosophy, and History of Education Scholars",
    "purposeStatement": "The purpose of the Association of Educational Psychology and Philosophy Scholars is to: 1.\tPromote scholarship in education and its dissemin...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Association of Future Nurse Researchers",
    "purposeStatement": "The purpose of the Association of Future Nurse Researchers is to provide a collaborative and safe environment where Doctor of Philosophy in ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Association of Latino Professionals for America (ALPFA)",
    "purposeStatement": "The following are the goals and purposes of the ALPFA Student Chapter at The Ohio State University:  Our mission is to empower and develop L...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College"
    ]
  },
  {
    "name": "Association of Women Dentists",
    "purposeStatement": "A predoctoral chapter of the AWD. The mission of the AWD is to be the recognized resource for connecting and enriching the lives of women de...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Association of Women Surgeons",
    "purposeStatement": "The Association of Women Surgeons is dedicated to the mission of inspiring and supporting women in all stages of medical training and to ins...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Astronomical Society",
    "purposeStatement": "We provide an academic and social connection between students and faculty within the astronomy department, and promote academic and professi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Athletic Training Club at The Ohio State University",
    "purposeStatement": "OSU Athletic Training club is a student run organization focused on enhancing our profession, serving the community, and fostering the needs...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Autism Speaks U at The Ohio State University",
    "purposeStatement": "The Ohio State University Student Chapter furthers the mission of Autism Speaks by engaging the campus community (faculty, staff and student...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Autistic Students Union at The Ohio State University",
    "purposeStatement": "Our purpose, as the Autistic Students Union at the Ohio State University, is to uplift autistic voices at the Ohio State University. We are ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The AutoDrive Challenge Team at The Ohio State University",
    "purposeStatement": "Ever wonder how an Autonomous Vehicle works? How engineers ensure that the vehicle makes the right decisions? Want to get exposure into this...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Aviation Management Organization/AAAE",
    "purposeStatement": "The Aviation Management Organization is the Student Chapter of AAAE and enhances the aviation education experience for all students. We prov...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Aviation Student Advocacy and Peer Support Organization at The Ohio State University",
    "purposeStatement": "The Aviation Student Advocacy & Peer Support Organization at The Ohio State University is committed to helping students navigate Ohio State'...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Axiologists at Ohio State",
    "purposeStatement": "The purpose of the Axiologists at Ohio State is to create a forum for dialogue amongst advanced undergraduate and graduate students on topic...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Backburner Sketch Comedy Group",
    "purposeStatement": "Our purpose is to bring laughter to The Ohio State University by developing a community around sketch comedy within the university and to im...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Bad Movie Club at Ohio State",
    "purposeStatement": "To watch, enjoy, and laugh at “bad movies”, as well as discuss what makes a movie bad and whether it should be considered art or not",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Bad Singers Karaoke Club",
    "purposeStatement": "Bad Singers Club is dedicated to creating a stress-free environment for singers of all skill levels.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Baha'i Campus Association",
    "purposeStatement": "To promote unity through cultural diversity on the Ohio State Campus and Columbus Area by advocating the ideals of the Baha'i Faith, includi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual"
    ]
  },
  {
    "name": "The Baja SAE Team at The Ohio State University",
    "purposeStatement": "To design, build, test, and compete a single-seat off-road vehicle annually in accordance with the rules set forth by the Society of Automot...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Baker Leadership Team",
    "purposeStatement": "To offer opportunities for involvement and leadership development to the residents of Baker Hall. The Baker Hall Council will represent the ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College"
    ]
  },
  {
    "name": "Baltic Club at The Ohio State University",
    "purposeStatement": "To preserve, promote, and educate about Baltic heritage, culture, traditions, and lifestyle.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Bangladesh Graduate Student Association",
    "purposeStatement": "The purpose of the organization is to connect Bangladeshi graduate students with information, resources, and facilitate social and cultural ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Bangladeshi Student Association",
    "purposeStatement": "The purpose of the Bangladesh Student Association is to expose the rich culture and strong heritage of Bangladesh to community of OSU and Co...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Creative and Performing Arts",
      "Academic/College"
    ]
  },
  {
    "name": "Barrett-Nosker-Jones Community Council",
    "purposeStatement": "To plan events for the Barrett-Nosker-Jones residents and create community within the complex. We work for the betterment of each individual...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations"
    ]
  },
  {
    "name": "Baseball - Sport Club",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Academic/College"
    ]
  },
  {
    "name": "Basketball Therapy Club",
    "purposeStatement": "The purpose of Basketball Therapy Club is simple - to offer basketball lovers a way to escape from the stresses of everyday life through the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Bass Fishing Club of The Ohio State University",
    "purposeStatement": "The purpose of the Bass Fishing Club of OSU is to bring students together to enjoy the sport of bass fishing.  This club will be affiliated ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Battery Challenge Team at The Ohio State University",
    "purposeStatement": "To engage students in designing, building, and manufacturing a battery pack for a battery electric vehicle. The educational mission aims for...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Be the Match on Campus",
    "purposeStatement": "The purpose of this organization shall be to fundraise, to be able to conduct regular marrow donor registry drives, and contribute to the Na...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Beach Volleyball - Coed - Sport Club",
    "purposeStatement": "The coed beach volleyball club is designed to promote health, wellness, teamwork, and completive play. Participation in this program would p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "The Bee Club at The Ohio State University",
    "purposeStatement": "To raise awareness and teach Ohio State students of the importance of bees in the environment, as well as the integral role honey bees play ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Begonia Dance Society",
    "purposeStatement": "The inception of our organization stems from a profound desire to rejuvenate and celebrate the rich tapestry of Chinese cultural heritage th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Bennett Graduate Research Society",
    "purposeStatement": "\"The purpose of the Bennett Society is to promote and recognize excellence in graduate research and education, create a community of graduat...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Best Buddies International",
    "purposeStatement": "Best Buddies is a non-profit organization dedicated to promoting inclusion and friendships between individuals with and without Intellectual...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Beta Alpha Psi",
    "purposeStatement": "The purpose of Beta Alpha Psi is to recognize outstanding academic achievements in the field of accounting, to promote the study and practic...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "Beta Sigma Kappa International Optometric Honor Society",
    "purposeStatement": "To stimulate scientific attainment, academic excellence, evidence based clinical treatment and the ethical practice of optometry; and to pro...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "Beta Sigma Psi",
    "purposeStatement": "Our purpose is to provide an environment in which the Christian college man can grow spiritually, scholastically, and socially in the contex...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Beta Theta Pi",
    "purposeStatement": "To Develop Men of Principle for a Principled Life.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Big Buckeye Lil' Buckeye",
    "purposeStatement": "Big Buckeye Lil’ Buckeye is a liaison between The Ohio State University student body and the after-school program, Healthy Asian Youth (HAY)...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Big Data and Analytics Association",
    "purposeStatement": "We aim to inspire students to think analytically, empower them through hands on training, and connect them to potential employers.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Bike Club",
    "purposeStatement": "Bike Club is committed to encouraging the campus community to ride bikes for fun and/or for commuting, educating cyclists on bicycle mainten...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Billiards Club",
    "purposeStatement": "The OSU billiards club aims to help pool players at Ohio State meet and form teams to compete with nearby schools. Also, to give beginners a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "The Bioethics Society",
    "purposeStatement": "The purpose of The Bioethics Society is to expose The Ohio State University students, faculty, and staff, to issues in bioethics, including,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Biology Club",
    "purposeStatement": "To foster a vibrant community within the diverse realm of biology, promoting interdisciplinary collaboration. We aim to provide both mentors...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Biomedical Engineering Graduate Student Association",
    "purposeStatement": "To address the academic, service, social, professional, and post-graduate interests of the Graduate Student body in the Biomedical Engineeri...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Biomedical Engineering Society",
    "purposeStatement": "1. Promote the profession of biomedical engineering through study, research, and discussion of the various fields of biomedical engineering....",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Technology"
    ]
  },
  {
    "name": "Biomedical Science Major Student Organization",
    "purposeStatement": "The purpose of the Biomedical Science Major Student Organization is to provide support to all students enrolled in the Biomedical Science Ma...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Biomedical Sciences Graduate Program – Communication & Relations Organization",
    "purposeStatement": "The main goal of the BSGP-CRO is to provide support to all students enrolled in the Biomedical Sciences Graduate Program (BSGP) at The Ohio ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Biomedical Sciences Graduate Student Organization",
    "purposeStatement": "The main goal of BSGO is to support all students enrolled in the Biomedical Sciences Graduate Program at The Ohio State University. It will ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Governance Organizations",
      "Special Interest"
    ]
  },
  {
    "name": "Biophysics Student Organization",
    "purposeStatement": "The Biophysics Student Organization strives to foster a sense of community among the students of The Ohio State University Biophysics Gradua...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Black Authors and Readers",
    "purposeStatement": "To give students (General body members or all of those involved) a mental break from academic stress (Mental health Awareness). To give repr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Black Dance Association",
    "purposeStatement": "Our mission is to promote excellence in Black dance education amongst the black students on OSU campus, create lifelong networks, fruitful r...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Black Graduate and Professional Student Caucus",
    "purposeStatement": "The purpose of the Black Graduate and Professional Student Caucus at The Ohio State University is to promote academic, cultural, service, an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Black Law Student Association",
    "purposeStatement": "The purpose of this Association shall be to utilize the collective resources to: Articulate and promote the professional needs and goals of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Black MBA Association",
    "purposeStatement": "The mission of the Black MBA Association is to build leaders that shape business and the community through diversity and inclusion by bringi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Black Mental Health Coalition",
    "purposeStatement": "To allow Black students in higher education to be able to engage in conversation on the stigma of mental health that affects the community.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Black Outdoors Club",
    "purposeStatement": "The purpose and objectives of this organization are to:   Expose members of the black student body to various outdoor recreational activitie...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Black Performing Arts Collective",
    "purposeStatement": "The Black Performing Arts Collective’s (BPAC) purpose is to unite, engage, and uplift Black Ohio State students interested in Theatre and th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "The Black Queer Coalition",
    "purposeStatement": "Our purpose is to create a safe space for Black OSU students who are a part of the LGBTQIA+ community. We want to provide a place for black ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Black Scholars Connect",
    "purposeStatement": "To create a safe environment for students to learn about Black history. To learn about the way historical events affect modern times and the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Black Student Association",
    "purposeStatement": "The Black Student Association provides a safe space for Black students to fellowship and build community at The Ohio State University.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Black Students In Pharmacy",
    "purposeStatement": "Recent studies show that African American women account for less than 3% of doctors in the U.S but account for over 12% of the national pati...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Black Students in Psychology & Neuroscience",
    "purposeStatement": "Black Students in Psychology & Neuroscience (BSPN) is a community created and led by Black Students in the psychology and neuroscience depar...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Black X Bold Magazine",
    "purposeStatement": "Black x Bold is Ohio State’s only black magazine, the first of its kind in years. Established to bring a voice to the Black community at Ohi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Block O",
    "purposeStatement": "Block O is the Official Student Section of Ohio State Athletics. We actively strive to support our student-athletes on the field while servi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Blockchain Technology Club at Ohio State",
    "purposeStatement": "The purpose of the Blockchain Technology Club is to educate students on how blockchains work as well as their applications in the real world...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Bluefish Swim School",
    "purposeStatement": "Bluefish Swim School is for students to volunteer as swim instructors with children with developmental disabilities in the pool, providing a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Sports and Recreation",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Blueprints for Pangaea at The Ohio State University",
    "purposeStatement": "Blueprints For Pangaea (B4P) is a 501(c)(3) not-for-profit medical surplus recovery organization (MSRO) that provides sustainable solutions ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Board to Death",
    "purposeStatement": "Board to Death seeks to be OSU's premier board game club by providing access to and a location for the hobby. Students from all different ba...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Body Sense",
    "purposeStatement": "Our purpose is to advocate for a more inclusive Body Positivity Movement by exploring the intersectionality of identity and our relationship...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Bodybuilding at The Ohio State University",
    "purposeStatement": "BOSU focuses on creating a casual, friendly environment for students to explore and learn about the sport of bodybuilding, gain experience f...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Bonsai Club at The Ohio State University",
    "purposeStatement": "To educate OSU students and the public about bonsai trees and horticulture. This club will serve as a resource to those interested in learni...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "The Boo Radley Society",
    "purposeStatement": "Our purpose is to maintain a positive atmosphere everywhere we go, spread smiles, and perform random acts of kindness/acts of service to the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Bookeye Book Club",
    "purposeStatement": "Reading is our hobby! As a club, we will select the book we want to read and through bimonthly meetings come together to discuss our thought...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "BookTok at The Ohio State University",
    "purposeStatement": "To bring together those with similar reading interests made popular through the social media platform, TikTok, and post our own reviews of t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Botany Club",
    "purposeStatement": "Botany club is a space for students to gather and share interest in the botanical sciences. We are dedicated to promoting stewardship of Ohi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Boxing Club at Ohio State - Sport Club",
    "purposeStatement": "Boxing Club seeks to foster a fun, welcoming environment that promotes fitness boxing, self-defense, and the value of hard work! We strive t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Bradley-Paterson/Mack-Canfield Community Council",
    "purposeStatement": "Bradley Paterson & Mack Canfield Community Council is the voice for all Bradley Paterson & Mack Canfield residents. BPMC is the monetary and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations"
    ]
  },
  {
    "name": "Branches Tutoring Club",
    "purposeStatement": "The purpose of Branches is for college students to tutor elementary students. Through this, we hope to help kids struggling in math, science...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Brazilian Students Association",
    "purposeStatement": "The Brazilian Student Association – BRASA – is an organization created by students of The Ohio State University. The mission of this associa...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Bread Club",
    "purposeStatement": "The Bread Club at The Ohio State University is a social and culinary organization that promotes both bread and non bread related baking and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Break and Make",
    "purposeStatement": "Students come together to break objects and then remake them into something better/different using creative thinking, reverse engineering, a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Special Interest"
    ]
  },
  {
    "name": "Breathe Hope",
    "purposeStatement": "Breathe Hope is an organization with goals to raise awareness on campus and around Columbus about Cystic Fibrosis, volunteer at events for t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Bridges International Student Ministry at Ohio State",
    "purposeStatement": "Meeting time & location, Friday evenings at 7:00 PM at The Ohio Union  Organization dues: none  Motto: \"Helping International Students, Scho...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Bridging Gaps at Ohio State",
    "purposeStatement": "Connecting college students with a senior citizen community in Columbus to combat the epidemic of loneliness. Putting a smile on the faces o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Brighter Smile Foundation",
    "purposeStatement": "The Brighter Smile Foundation works to ensure that basic dental care products and education are accessible to everyone, irrespective of thei...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "BSR- Spin Doctors",
    "purposeStatement": "Team Buckeye Student Riders - Spin Doctors is the Ohio State University College of Medicine's official Team Buckeye student peloton for Pelo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Buck That! A Cappella",
    "purposeStatement": "Buck That! is established for the expressed purpose of developing, promoting, and teaching musicianship through the use of all-male identify...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Buck-I-SERV",
    "purposeStatement": "Buck-I-SERV is a cohort program involving between 10 and 15 students who work closely with Center for Student Leadership and Service in the ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Buck-I-Watch",
    "purposeStatement": "Buck-I-Watch aims to create and grow a community for Ohio State sports fans by hosting socially responsible Buckeye football and basketball ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Bucket & Dipper Junior Class Honorary",
    "purposeStatement": "Bucket and Dipper Junior Class Honorary is comprised of 30 members dedicated to scholarship, leadership, and service.  These qualities exten...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The Bucket List Club",
    "purposeStatement": "The Bucket List Club is a student-run organization at OSU committed to empower students to live a fulfilling life by checking off one item ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Community Service/Service Learning",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Buckeye Air Traffic Control Association",
    "purposeStatement": "Our purpose is to spread awareness and network within the Air Traffic Control community. We want to give Ohio State students the opportunity...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Buckeye Alliance for Columbus Migrants and Refugees",
    "purposeStatement": "Our mission at Buckeye Alliance for Columbus Migrants and Refugees (BAMR) is to provide marginalized refugee families with bimonthly meals o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Buckeye Assembly for Men in Nursing",
    "purposeStatement": "The purpose of BAMN shall be to provide opportunities for networking and mentoring, to promote men’s health, to assist pre-nursing and inter...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Buckeye Badminton Club - Sport Club",
    "purposeStatement": "The purposes of the Buckeye Badminton Club are:  (A) To promote the game and sport of badminton   (1) by holding regular practices and scrim...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Beatbox",
    "purposeStatement": "Buckeye Beatbox aims to cultivate an engaging and collaborative space for individuals passionate about beatboxing. Our primary goal is to nu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Beauties",
    "purposeStatement": "Create a group of likeminded individuals with a shared passion for beauty, and discover how to be their most confident version of themselves...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Community Service/Service Learning",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Buckeye Bengalis",
    "purposeStatement": "We are a group of OSU students, alumni, friends and supporters, who are unified by our passion for bengali (an Indian language) cultural con...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Buckeye Bhairavi",
    "purposeStatement": "This organization promotes the awareness and appreciation of Indian Classical Music and Culture among all members of The Ohio State Universi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Buckeye Bhangra",
    "purposeStatement": "Buckeye Bhangra, a dance group at the Ohio State University, strives to learn and present traditional Punjabi Bhangra dances of the region o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Creative and Performing Arts",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Buckeye Bible Study",
    "purposeStatement": "Buckeye Bible Study is a place for students to express their views on life's deeper questions while being able to engage other's worldview a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Buckeye Biochemistry Program",
    "purposeStatement": "The Buckeye Biochemistry Program is a student organization whose primary purpose is to promote the advancement of its members in and out of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Buckeye Biotechnology Association",
    "purposeStatement": "The Buckeye Biotechnology Association (BBA) is a student organization at The Ohio State University for students interested in the life scien...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "The Buckeye Blanket Bash",
    "purposeStatement": "The Buckeye Blanket Bash is a yearly event in which no-sew blankets are made and donated by volunteers for the Arthur G. James Cancer Hospit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "The Buckeye Blood Club",
    "purposeStatement": "The purpose of this club shall be to spread blood donation education and provide blood donation services to the local community and students...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Buckeye Bowling Club - Sport Club",
    "purposeStatement": "To bring together students interested in competitive bowling to enhance their skills and learn more about the sport.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Brighters: Fulbright Student/Scholar Organization",
    "purposeStatement": "The mission of Buckeye Brighters is to promote the goals of the Fulbright program by increasing mutual understanding between the people of t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Broomball",
    "purposeStatement": "To teach and play broomball while building teamwork skills and a sense of community at The Ohio State University.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Buddies",
    "purposeStatement": "Buckeye Buddies is all about bringing people from different backgrounds together to participate in fun, authentic athletic experiences. Toge...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Buckeye Bunnies at The Ohio State University",
    "purposeStatement": "Providing opportunities for members to learn about the rabbit industry, rabbit professionals, and careers involving rabbits, all while devel...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Buckeye Campaign Against Suicide",
    "purposeStatement": "This organization is dedicated to eliminating the stigma around mental illness and suicide prevention. Our major goals are to inform student...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism"
    ]
  },
  {
    "name": "Buckeye Capital Investors",
    "purposeStatement": "Buckeye Capital Investors is the preeminent student investment club at The Ohio State University, established in 2005 with the goal of devel...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Capture",
    "purposeStatement": "The purpose of Buckeye Capture is to assemble a team of photographers dedicated to providing a high-quality photography and videography serv...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Buckeye Catholics",
    "purposeStatement": "We are a welcoming community for faith, fellowship, and service at The Ohio State University. We foster an atmosphere within which all can d...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Buckeye COD",
    "purposeStatement": "BuckeyeCOD is an organization founded to cultivate a competitive and passionate community for those interested in the video game series, Cal...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Sports and Recreation",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Buckeye Current",
    "purposeStatement": "Buckeye Current is the electric motorcycle racing team at OSU. The team builds two-wheeled electric racing vehicles for professional competi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Dairy Club",
    "purposeStatement": "1.  To promote and stimulate cooperation and friendship between members of the club, the faculty, and active men and women in their respecti...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Buckeye Distressed Investing & Restructuring Club",
    "purposeStatement": "This organization’s primary intent is to introduce the concept of distressed debt and credit investing, as well as restructuring to undergra...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "The Buckeye Entertainment Project",
    "purposeStatement": "The Buckeye Entertainment Project's purpose is to fulfill a vital need for uplifting and compassionate outreach within our community. Our or...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Buckeye Execution Brotherhood",
    "purposeStatement": "Empowering Excellence, Nurturing Leadership: The Ohio State University's Buckeye Executive Brotherhood (BEB) is dedicated to cultivating a s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Buckeye Exploratarium Club",
    "purposeStatement": "To transform the Arne Slettebak planetarium at OSU into an educational tool outside of the field of astronomy by producing educational shows...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Buckeye Food Alliance",
    "purposeStatement": "Understanding the impact of hunger on educational achievement, we provide access to healthy food to the Ohio State community in order to red...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Furs",
    "purposeStatement": "We are the fluffiest part of campus! Our focus is to bring those interested in anthropomorphic animals together, and support each other in o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Buckeye Fusion",
    "purposeStatement": "To unite South Asian cultures and young women through various styles of dance that tell a powerful, and meaningful story.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Buckeye Gaming Collective",
    "purposeStatement": "The purpose of this organization shall be to provide an engaging environment for both students and community members to participate in recre...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation",
      "Technology",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Buckeye Imagine Cup",
    "purposeStatement": "The purpose of The Buckeye Imagine Cup(BIC) club is to create a student organization that will gather students who want to gain new skills, ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Buckeye Innovation Society",
    "purposeStatement": "The mission of the Buckeye Innovation Society (BIS) is to provide innovative tools, opportunities, and connections to prepare students for s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Buckeye Language Exchange",
    "purposeStatement": "The goal of Buckeye Language Exchange is to promote fluency and interest in foreign languages. This organization will achieve this by matchi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Leaders in Healthcare",
    "purposeStatement": "Buckeye Leaders in Healthcare aims to provide students with educational opportunities related to becoming leaders in the healthcare field. F...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Med Mentors",
    "purposeStatement": "Buckeye Med Mentors is a student-led organization that aims to create a network of aspiring healthcare professionals between medical student...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Mela",
    "purposeStatement": "Buckeye Mela serves as the Ohio State University’s premiere Bhangra and Fusion intercollegiate dance competition, bringing together hundreds...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Buckeye Mudder Club",
    "purposeStatement": "The Buckeye Mudder Club will enhance the mental and physical toughness of Buckeyes through the completion of obstacle course races (OCR) whi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Officials Association",
    "purposeStatement": "Our association serves to better our members through advanced training and by providing opportunities to improve their officiating skills in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Buckeye Olympics",
    "purposeStatement": "Buckeye Olympics is an organization focused on athletic competition in a variety of sports for Ohio State students with intellectual and dev...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Buckeye Operations Management Society",
    "purposeStatement": "Buckeye Operations Management Society (BOMS) strives to be an active and respected part of student life at The Ohio State University’s Fishe...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Parasitology Club",
    "purposeStatement": "The Buckeye Parasitology Club is affiliated with the American Association of Veterinary Parasitologists (AAVP).  The aim of our organization...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "The Buckeye Philharmonic Orchestra",
    "purposeStatement": "The Buckeye Philharmonic is created to serve the community of The Ohio State University by providing an outlet for orchestral musicians who ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Pickleball Club - Sport Club",
    "purposeStatement": "Our purpose is to grow the sport of pickleball and to develop our member's skill sets.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Buckeye Pokémon League",
    "purposeStatement": "Our purpose is to give students and community members who share a common interest in Pokémon the opportunity to interact with one another, p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Professional Advancement and Development",
    "purposeStatement": "Buckeye Professional Advancement and Development (BPAD) is a professional development organization founded to develop Ohio State students ac...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Buckeye Puppetry Club",
    "purposeStatement": "The purpose of the Buckeye Puppet Club shall be to develop puppeteering skills, entertain students of The Ohio State University and surround...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Buckeye Roundnet Club",
    "purposeStatement": "Buckeye Roundnet Club offers opportunities for people to play with each other as well as people to learn the game. We will be hosting introd...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Rover Team",
    "purposeStatement": "To design and construct an efficient and competitive rover vehicle in order to compete in the international NASA racing competition. This ve...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Technology",
      "Academic/College"
    ]
  },
  {
    "name": "Buckeye Shadowing Club",
    "purposeStatement": "The purpose of Buckeye Shadowing Club is to provide and facilitate shadowing opportunities for all pre-health students at The Ohio State Uni...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Solar Racing",
    "purposeStatement": "Buckeye Solar Racing is a student-run organization that designs, builds, and races solar electric vehicles. Our goal is to provide students ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "The Buckeye Space Launch Initiative",
    "purposeStatement": "The Buckeye Space Launch Initiative (BSLI) is an interdisciplinary organization of ambitious students who own a shared vision of student-led...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Spectrum",
    "purposeStatement": "The purpose for beginning Buckeye Spectrum is to create a welcoming space for LGBTQIA+ Student Athletes and Allies of all racial and gender ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Buckeye Squash Club - Sport Club",
    "purposeStatement": "Buckeye Squash Club seeks to provide the skills, knowledge and community through which OSU students and faculty can explore the game of Squa...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Standup Comedy Club",
    "purposeStatement": "The purpose of Buckeye Standup Comedy Club is to develop comedic talent, entertain the students of The Ohio State University and surrounding...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye State of Mind",
    "purposeStatement": "Student-athletes face different obstacles than students on campus causing them to need different resources. This organization helps to creat...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Buckeye Student Nurses Association",
    "purposeStatement": "The purpose of BSNA is to organize, represent, and mentor students preparing for BSN degrees at Ohio State University; to promote the profes...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The Buckeye Student Sales Network",
    "purposeStatement": "The Buckeye Student Sales Network (BSSN) is dedicated to empowering Ohio State students of any major to refine their sales acumen while deve...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Table Tennis Club - Sport Club",
    "purposeStatement": "This program is designed to serve individual interests in different sports and recreational activities. Participation in the program enhance...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Buckeye Trombone Association at The Ohio State University",
    "purposeStatement": "The Buckeye Trombone Association provides a direct community for those who play trombone at The Ohio State University. We strive to improve ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Twirl - Sport Club",
    "purposeStatement": "To present the opportunity for students who have previously twirled to continue, and foster friendships  leadership, organizational and crea...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Undergraduate Consulting Club",
    "purposeStatement": "Our purpose is to educate students regarding the opportunities available in the field of consulting as well as provide them with the tools n...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Buckeye Ventures",
    "purposeStatement": "Buckeye Ventures is a multidisciplinary project-based club where members are educated about venture capital and private equity. Students gai...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeye Vertical",
    "purposeStatement": "Buckeye Vertical (BV) is an interdisciplinary group of Ohio State University students exploring Advanced Air Mobility (AAM), Urban Air Mobil...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Buckeye Y.A. Reading Group",
    "purposeStatement": "The purpose of this organization is threefold. First and foremost, it invites students from different backgrounds to join social conversatio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Special Interest",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "BuckeyeFridge™",
    "purposeStatement": "To help alleviate food insecurity for the students and local residents at Ohio State University by providing free access to a community refr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeyes 4 Greyhounds and K9s",
    "purposeStatement": "Promote greyhound welfare and rehabilitate injured racing dogs while providing education in canine medicine.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Buckeyes Against Alzheimer's",
    "purposeStatement": "The purpose of the Buckeyes Against Alzheimer's organization is to spread awareness about Alzheimer's Disease and its prevention, to educate...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Buckeyes Against Cancer",
    "purposeStatement": "Buckeyes Against Cancer is an organization that meets to compose care packages, crafts, and other donations to be delivered to hospital pati...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Buckeyes First Student Organization",
    "purposeStatement": "The Buckeyes First student organization is intended for first-generation college students. We will meet regularly throughout the year, discu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Buckeyes for Accessibility",
    "purposeStatement": "Buckeyes for Accessibility (B4A) is the oldest and largest disability student-run organization at The Ohio State University. B4A has a long ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeyes for Baking",
    "purposeStatement": "The purpose of Buckeyes for Baking is to bring together students at The Ohio State University through a common love of food. To fulfill this...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeyes for Canines",
    "purposeStatement": "Buckeyes for Canines is an Ohio State University based service group dedicated to assisting dogs and the organizations that protect them. BK...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeyes for Christ",
    "purposeStatement": "Buckeyes For Christ is a Student Organization lead by student members of  the Fishinger Road Church of Christ to promote the Gospel, serve o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Buckeyes for Harm Reduction",
    "purposeStatement": "Buckeyes for Harm Reduction is a grassroots student organization that aims to provide support to those affected by  the opioid epidemic/over...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Buckeyes for HIV/AIDS Advocacy",
    "purposeStatement": "Buckeyes for HIV/AIDS Advocacy is a student organization that aims to raise awareness of the HIV/AIDS epidemic at the local, state, national...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeyes for Israel",
    "purposeStatement": "Buckeye for Israel is The Ohio State University’s pro-Israel advocacy group on campus. We are a bipartisan and non-discriminatory organizati...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeyes for Ohio Military Kids",
    "purposeStatement": "The purpose of this club shall be to educate both the Ohio State and Columbus community on various volunteer activities and social events th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeyes for Public Health",
    "purposeStatement": "Buckeyes for Public Health will serve the primary purpose of promoting all aspects of public health by empowering Ohio State University stud...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Buckeyes For Recovery",
    "purposeStatement": "Buckeyes For Recovery is a student organization committed to supporting recovery on campus. We aim towards this commitment by encouraging fu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Buckeyes for Ronald McDonald House Charities",
    "purposeStatement": "Buckeyes for Ronald McDonald House Charities (BRMHC) is an Ohio State student-led organization dedicated to supporting the Ronald McDonald H...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Buckeyes for Save a Child's Heart",
    "purposeStatement": "The fundamental purpose of our organization is fundraising and advocating for the international non-profit organization Save A Child’s Heart...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Buckeyes for Seniors",
    "purposeStatement": "To bring joy to residents in memory care facilities through games, crafts and other activities as well as raise money for Alzheimer disease ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeyes for Special Hockey",
    "purposeStatement": "At Buckeyes for Special Hockey, our mission is to unite students with varying medical and sports interests to make a positive impact on the ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Buckeyes For Voting Rights",
    "purposeStatement": "To register young buckeyes to vote, engage civically, and educate students on how to vote in different elections all while they learn to bec...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Buckeyes for WHEP",
    "purposeStatement": "WHEP at Ohio State aims to support WHEP (Women's Health Education Program) through fundraising, donation drives, and mentorship for moms. In...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeyes on Tap",
    "purposeStatement": "The purpose of Buckeyes On Tap is to share and spread the love of tap dance throughout the OSU community through teaching, performance, and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Buckeyes Racial/Ethnic Equity Awareness Centered in Healthcare",
    "purposeStatement": "Buckeyes Racial Equity Awareness Centered In Healthcare facilitates conversations on racial disparities in healthcare through education and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Awareness/Activism",
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Buckeyes Raising Awareness in Neuroscience",
    "purposeStatement": "To provide support to those affected by neurological injuries and illnesses while focusing on increasing awareness in all things neuroscienc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Buckeyes Shuffled",
    "purposeStatement": "Buckeyes Shuffled is an organization which celebrates diverse cultures, exploring their unique differences and shared similarities. We embra...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Buckeyes Without Borders",
    "purposeStatement": "Buckeyes Without Borders strives to foster global health awareness and teach OSU healthcare students the benefits of an interdisciplinary he...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "BuckeyeThon",
    "purposeStatement": "The mission of BuckeyeThon is to create awareness and raise funds for children with cancer. As an official program of the Office of Student ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "BuckiPAC",
    "purposeStatement": "BuckiPAC's purpose is to bring awareness to the OSU campus about the politics surrounding Israel in a bipartisan way",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism"
    ]
  },
  {
    "name": "Bullet Journaling Club",
    "purposeStatement": "Our purpose is to create a welcoming environment for members to express their emotions and relieve stress through bullet journaling. We aim ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Burmese Student Association at The Ohio State University",
    "purposeStatement": "Burmese Student Association is an ethnic/ cultural club that invites all students to come celebrate Burmese traditions, food, and cultural e...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Business Builders - The Premier Entrepreneurship Club | The Ohio State University",
    "purposeStatement": "Business Builders is the premier Entrepreneurship Club at OSU. Business Builders brings together Ohio State students interested in \"Business...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Business For Good",
    "purposeStatement": "Business For Good, formerly Alleviating Poverty Through Entrepreneurship (APTE), is a student organization at Ohio State University explorin...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Business Law Society",
    "purposeStatement": "(a)\tTo provide students, who are interested in, inter alia, corporate, tax, real estate finance, economics, bankruptcy, and/or antitrust law...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Business of Entertainment Club",
    "purposeStatement": "To explore the field of entertainment by integrating the arts, media, and business fields. Perfect for anyone interested in film, music, dan...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Business of Retail Association",
    "purposeStatement": "Business of Retail Association aims to bridge the gap between Ohio State students and Retail Companies through developing a group of analyti...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Calisthenics Club at Ohio State",
    "purposeStatement": "We aim to help students stay physically active by implementing calisthenics/body weight exercises. They are fun and friendly to beginners! N...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Camp Kesem at The Ohio State University",
    "purposeStatement": "To provide kids whose parents have or have had cancer with a summer camp experience that gives them a chance to be kids and to allow college...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Campus EMS at The Ohio State University",
    "purposeStatement": "As a member of the National Collegiate Emergency Medical Services Foundation (NCEMSF), Campus EMS at The Ohio State University seeks to impr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Campus Girl Scouts at The Ohio State University",
    "purposeStatement": "Campus Girl Scouts at The Ohio State University supports ?the Girl Scout mission of building girls of courage, confidence, and character. We...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Governance Organizations"
    ]
  },
  {
    "name": "Campus Ministry International",
    "purposeStatement": "Ohio State CMI strives to provide a space for Apostolic students to build a community and grow deeper in the Bible while discovering God's p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Campus Outreach",
    "purposeStatement": "A non-denominational college ministry that provides opportunities for students to investigate and grow in their faith, as well as equipping ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Special Interest"
    ]
  },
  {
    "name": "Car Club at Ohio State",
    "purposeStatement": "To promote fun automotive related activities for car loving students in a safe and legal manner. We host weekly meetings catered to those wh...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "The Cardiology Interest Group",
    "purposeStatement": "The Cardiology Interest Group provides medical students and other interested professional students with a comprehensive view of the field of...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Cardiothoracic Surgery Interest Group",
    "purposeStatement": "To help medical students interested in cardiothoracic surgery to explore all aspects of cardiothoracic surgery by providing career informati...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Caribbean Student Association",
    "purposeStatement": "Caribbean Student Association's purpose is to educate, showcase, and celebrate the diverse cultures of the Caribbean with the greater Columb...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Casual Soccer Club at The Ohio State University",
    "purposeStatement": "The casual soccer club exists to create a welcoming environment for students new to the game and opportunities to play and watch soccer for ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Casual Sports & Service Club",
    "purposeStatement": "The purpose of the Casual Sports & Service Club is to provide a platform for individuals interested in participating in various recreational...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Cats and Crafts",
    "purposeStatement": "The Cats and Crafts club at The Ohio State University is to provide a welcoming and inclusive community for cat lovers to come together and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The CCBS Student Organization",
    "purposeStatement": "The purpose of Consilience: The CCBS Student Organization is to create a forum for interdisciplinary dialogue amongst undergraduate, graduat...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "CELLOHIO",
    "purposeStatement": "We are an ensemble of Ohio State students and cellists who hope to engage our peers and the greater community through diverse programming an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Academic/College",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Center for Anarchist Theory",
    "purposeStatement": "We aim to provide a platform that grants both graduate and undergraduate students the opportunity to further participate in an academic, int...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Center for Cognitive and Behavioral Brain Imaging Student Organization",
    "purposeStatement": "The purpose of this organization is to foster a community of students at The Ohio State University interested in learning and sharing knowle...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology",
      "Special Interest"
    ]
  },
  {
    "name": "Central Ohio Flute Association at The Ohio State University",
    "purposeStatement": "The purpose of the Central Ohio Flute Association at The Ohio State University is to promote music within the arts community and to provide ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Central Ohio Revolutionary Socialists",
    "purposeStatement": "CORS is an organization that aims to bring together students interested in left/progressive politics, including issues of civil rights, gend...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Central Ohio Student Advocates for the Arts",
    "purposeStatement": "COSAA will educate students about legislation and policy affecting the arts at the local, state, and national levels. Acting as a conduit, w...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Centurion Drill Team",
    "purposeStatement": "The Centurion Drill Team mission is to train and educate Air Force cadets on drill and ceremonies while promoting professional officer devel...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "CEO @ Ohio State",
    "purposeStatement": "Inspire OSU students to seek out leadership positions by inviting the Chief Executive Officer of large companies to present their story and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "CHAARG at The Ohio State University",
    "purposeStatement": "OSU CHAARG will provide opportunities for students to learn more about health and fitness. Students will be welcomed from different backgrou...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Chamber Music Club",
    "purposeStatement": "Chamber Music Club is created at OSU to provide instrumental students with the opportunity to play and learn about ensemble music in smaller...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Chemical Biology Student Group",
    "purposeStatement": "The purpose of this organization is to provide opportunities to bring together individuals working in the broad area of Chemical Biology at ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Chemical Engineering Car Project Team",
    "purposeStatement": "To design and build a small shoe-box sized car for regional and national competitions against other universities.  The car is to be powered ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Chemical Engineering Graduate Council",
    "purposeStatement": "To foster the professional and personal development of past, present, and future graduate students of the Chemical Engineering program at Th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "The Chemistry and Biochemistry Club",
    "purposeStatement": "The Chemistry and Biochemistry Club helps provide science students with assistance in furthering not only their education, but also their ex...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "ChemTALKS",
    "purposeStatement": "ChemTALKS is a student-run organization devoted to planning the Mack lecture and providing opportunities for students to interact with estab...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Chess Club at The Ohio State University",
    "purposeStatement": "The purpose of our club is to create opportunities for students at The Ohio State University to connect through chess.  This will include we...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Chi Alpha Christian Fellowship",
    "purposeStatement": "The purpose of this organization shall be to lead students of The Ohio State University to a saving relationship with Jesus Christ, and to h...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Chi Epsilon at The Ohio State University",
    "purposeStatement": "By recognizing outstanding students and graduates for their scholarship, character, practicality and sociability, Chi Epsilon seeks to foste...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "Chi Epsilon Pi at The Ohio State University",
    "purposeStatement": "Chi Epsilon Pi is a national honor society for outstanding students in the field of atmospheric sciences. The purpose of the society is main...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College"
    ]
  },
  {
    "name": "Chi Omega- Zeta Alpha Fraternity",
    "purposeStatement": "Chi Omega is an intergenerational women's organization forever committed to our founding purposes: Friendship, Personal integrity, Service t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Chi Sigma Iota",
    "purposeStatement": "Chi Sigma Iota is an honorary society for graduate students and professionals in the field of counselor education. Chi Sigma Iota promotes s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Child and Adolescent Psychiatry Student Interest Group",
    "purposeStatement": "The purpose of the Child and Adolescent Psychiatry Student Interest Group (CAPSIG) is to garner interest in the dynamic field of Child and A...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Chimes Junior Class Honorary",
    "purposeStatement": "The Chimes Junior Class Honorary is an organization of exceptional junior class men and women committed to upholding the principles of schol...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "China Entrepreneur Network at Ohio State",
    "purposeStatement": "The China Entrepreneur Network (CEN) is a globally connected network of organizations that focus on promoting social innovation and entrepre...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Chinese American Student Association",
    "purposeStatement": "The purpose of this organization is to promote Chinese culture and awareness between students, the university, and the community. It aims to...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Chinese Anime Fans Association",
    "purposeStatement": "CAFA is a space designed for Anime fans who like Moe anime, cosplay, mobile game (Genshin, fgo for example),  touhou, vtuber and all the oth...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Chinese Buckeyes Football Club",
    "purposeStatement": "Chinese Buckeyes Football Club is an organization with students from China who love playing football (soccer). Since there are so many Chine...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Chinese Christian Fellowship",
    "purposeStatement": "This club is intended to provide seekers with a group of Christians who genuinely love the Lord, would like to know Him and his words more, ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Chinese Fitness Association",
    "purposeStatement": "Create an environment where we can communicate and share healthy and science-based fitness and diet.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Chinese Folk Music Orchestra",
    "purposeStatement": "The purpose of CFMO is to create a welcoming community for anyone interested in playing traditional Chinese orchestra music. Additionally, C...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Chinese Gaming Club",
    "purposeStatement": "Publicize the spirit of E-sports, so that people who are interested in E-sports can participate  in it.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Chinese in Humanities and Social disciplines",
    "purposeStatement": "Chinese in Humanities and Social disciplines(CHS) is an organization dedicated to students' academic, intellectual, practical, professional,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Chinese Students and Scholars Society",
    "purposeStatement": "Chinese Students & Scholars Society aimes at promoting the diversity of the Ohio State University.  The initial goal of CSSS is to build a b...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Sports and Recreation",
      "Governance Organizations"
    ]
  },
  {
    "name": "Chinese Transfer Students Association",
    "purposeStatement": "The purpose of the Chinese Transfer Students Association is to enable Chinese transfer students to adjust to studying abroad as quickly as p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Chinese Women's Basketball Club",
    "purposeStatement": "Chinese Women's Basketball Club is an organization designed to provide opportunities for students interested in basketball. We aim to build ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Christian Dental Association",
    "purposeStatement": "Christian Medical and Dental Associations exist to glorify God -- by motivating, educating and equipping Christian healthcare professionals ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Christian Graduate Student Alliance",
    "purposeStatement": "Graduate students working together for spiritual development, academic excellence and Christian witness.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Christian Legal Society",
    "purposeStatement": "The mission of the Chapter is to maintain a vibrant Christian Law Fellowship on the School's campus which enables its members, individually ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Academic/College"
    ]
  },
  {
    "name": "Christian Medical and Dental Association, Medical Student Chapter",
    "purposeStatement": "CMDA exists to educate, encourage and unite medical students who have interests in Christian ethics and faith in their medical practice.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Academic/College"
    ]
  },
  {
    "name": "Christian Veterinary Fellowship",
    "purposeStatement": "Christian Veterinary Fellowship (CVF) is a student chapter of Christian Veterinary Mission. Our purpose is to enhance our relationships with...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Academic/College"
    ]
  },
  {
    "name": "Christians on Campus",
    "purposeStatement": "The purpose of this organization is to provide students at the Ohio State University a warm, mutual, spiritual, loving, people-oriented, Chr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Chrysalis: Undergraduate Students for Entomology",
    "purposeStatement": "Chrysalis was created by OSU undergraduates for OSU undergraduates who are enthusiastic about entomology (the study of insects) and want to ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Cinéseries",
    "purposeStatement": "Cinéseries is a student-lead group that organizes monthly screening series in collaboration with the Wexner Center for the Arts. We aim to o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Circle K International at The Ohio State University",
    "purposeStatement": "The purpose of the Circle K International Club at The Ohio State University shall be to foster community through club activities that uphold...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Citation Needed",
    "purposeStatement": "Citation Needed is an organization that provides students with modern communications skills in order to effectively communicate science, agr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Citizens' Climate Lobby at The Ohio State University",
    "purposeStatement": "The goal of CCL, and therefore the goal of CCL at The Ohio State University, is to build the political will to enact climate legislation tha...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "City and Regional Planning Student Association",
    "purposeStatement": "The objectives and purpose of the City and Regional Planning Student Association are to encourage extracurricular interaction between studen...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Civil Alliance at The Ohio State University",
    "purposeStatement": "Our goal is to give pre-law students the opportunity to create change within our surrounding community, get experience in the law field, and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Civil, Environmental and Geodetic Engineering Graduate Student Association",
    "purposeStatement": "CEGA represents graduate students in the department of Civil, Environmental and Geodetic Engineering (CEGE) at The Ohio State University (OS...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "The ClariNetwork Association at Ohio State",
    "purposeStatement": "The ClariNetwork Association at Ohio State is an association of Ohio State students created for any educational purpose to support the visio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Classics Club",
    "purposeStatement": "Our organization's purpose is to provide a structured community for classics majors and those interested in classics to connect.  The goals ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Classics Coffee Hour at The Ohio State University",
    "purposeStatement": "The Coffee Hour was founded by graduate students in 2016 to provide interested students with an informal venue for discussing current issues...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Clinical Psychology Book Club",
    "purposeStatement": "The purpose of this organization is to invite students with an interest in clinical psychology to join conversations regarding the state of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "The Club Dance Team - Sport Club",
    "purposeStatement": "The purpose of The Club Dance Team at Ohio State is to compete at local competitions, perform at University sponsored and local Columbus eve...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Club Football - Sport Club",
    "purposeStatement": "The purpose of this club is to provide a fun but competitive and organized atmosphere for students who wish to continue their career in foot...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Club Swimming at Ohio State - Sport Club",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Club Yu-Gi-Ohio",
    "purposeStatement": "Hey there! Thanks for stopping and reading. We are Club Yu-Gi-Ohio! and we meet once a week, Fridays at 5:30 in the Enarson basement to play...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation",
      "Technology"
    ]
  },
  {
    "name": "Coalition of Occupational Therapy Advocates for Diversity - Ohio State Chapter",
    "purposeStatement": "We are future occupational therapy practitioners and allies who are passionate about working towards a common goal of diversity and inclusio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Ethnic/Cultural",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Code 4 Community",
    "purposeStatement": "Code 4 Community at The Ohio State University seeks to use programming to demonstrate and implement the benefits of computer science in the ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Technology"
    ]
  },
  {
    "name": "Cognitive Science Club at The Ohio State University",
    "purposeStatement": "The organization will promote the learning and exploration of cognitive science. We will enrich students with new cognitive science developm...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Collaborative Software Development Club",
    "purposeStatement": "This organization will provide a platform for students to collaborate on software projects independent of the OSU curriculum for the purpose...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Special Interest"
    ]
  },
  {
    "name": "College Democrats at The Ohio State University",
    "purposeStatement": "The College Democrats on the campus of The Ohio State University are dedicated to promoting the ideals of the Democratic Party and to provid...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest",
      "Governance Organizations"
    ]
  },
  {
    "name": "College Mentors for Kids",
    "purposeStatement": "The mission of College Mentors for Kids is to motivate children and communities to achieve their potential by fostering inspiration to trans...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "College of Dentistry Student Government Association",
    "purposeStatement": "The Ohio State University College of Dentistry Student Government Association is comprised of executive officers elected by the student body...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations"
    ]
  },
  {
    "name": "College of Dentistry Student Government Association D1 Year",
    "purposeStatement": "The student government association at OSU’s College of Dentistry aims to serve the student body through being liaisons between faculty and s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Governance Organizations"
    ]
  },
  {
    "name": "College of Dentistry Student Government Association Year 2",
    "purposeStatement": "The student government association at OSU's The Class of 2025 Student Government Association at The Ohio State University College of Dentist...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations"
    ]
  },
  {
    "name": "College of Dentistry Student Government Association Year 3",
    "purposeStatement": "The student government association at OSU's The Class of 2025 Student Government Association at The Ohio State University College of Dentist...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College"
    ]
  },
  {
    "name": "College of Dentistry Student Government Association Year 4",
    "purposeStatement": "The student government association at OSU's College of Dentistry aims to fairly and accurately represent the class of 2023, maintain a helpf...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College"
    ]
  },
  {
    "name": "College of Dentistry Student Research Group",
    "purposeStatement": "The Student Research Group of the OSU College of Dentistry is devoted to furthering the quality and quantity of representation of the Colleg...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "College of Engineering Ambassador Program",
    "purposeStatement": "It shall be the purpose of this organization to promote the betterment and growth of the College of Engineering at The Ohio State University...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "College of Food, Agricultural, and Environmental Sciences Study Abroad Voyagers",
    "purposeStatement": "The Study Abroad Voyagers’ purpose is to promote Education Abroad in the College of Food, Agricultural, and Environmental Sciences. We inten...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "College of Food, Agricultural, and Evironmental Sciences Student Council",
    "purposeStatement": "The purpose of this organization shall be:  To communicate, as a representative body, the interests of CFAES Undergraduate students concerni...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Governance Organizations"
    ]
  },
  {
    "name": "College of Medicine Basketball at The Ohio State University",
    "purposeStatement": "The purpose of the College of Medicine Basketball at OSU group is to give an opportunity for medical students to destress from schoolwork an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Sports and Recreation"
    ]
  },
  {
    "name": "College of Medicine Football Club at The Ohio State University",
    "purposeStatement": "The College of Medicine Football Club at The Ohio State University was established to offer OSUCOM students a physical outlet to the mental ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Sports and Recreation"
    ]
  },
  {
    "name": "College of Medicine Running Club at The Ohio State University",
    "purposeStatement": "The OSU College of Medicine Running Club aims to provide medical students and faculty the opportunity to connect and foster relationships th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Sports and Recreation"
    ]
  },
  {
    "name": "College of Medicine Student Council at The Ohio State University",
    "purposeStatement": "Our purpose is to assist students at the College of Medicine in having a voice in their curriculum, provide a vehicle to administer changes,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College"
    ]
  },
  {
    "name": "College of Medicine Wellness Team",
    "purposeStatement": "To guide and assist medical students to create balance in mind, body, and spirit through activities that promote health and wellness.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "College of Pharmacy Class of 2026",
    "purposeStatement": "To present opinions on behalf of the College of Pharmacy student body in response to administrative and academic policies. To promote inclus...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "College of Pharmacy Student Council",
    "purposeStatement": "Pharmacy Council serves as the 'umbrella' organization for PharmD students and organizations in the College of Pharmacy. Pharmacy Council is...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College"
    ]
  },
  {
    "name": "College of Veterinary Medicine Class of 2025 Student Government",
    "purposeStatement": "The CVM Class of 2025 Student Government serves to enrich and support the veterinary school experience for the members of the Class of 2025.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "College of Veterinary Medicine Class of 2027",
    "purposeStatement": "The Veterinary College Class of 2027 Student Government will represent and support the OSU CVM Class of 2027 throughout all 4 years in the p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "College Republicans",
    "purposeStatement": "The College Republicans join together to help elect Republican candidates, support the Republican agenda, and become the future leaders of t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Collegiate 4-H at The Ohio State University",
    "purposeStatement": "The purpose of Collegiate 4-H is to maintain and increase interest in 4-H and to provide opportunities to develop leadership, wholesome recr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Collegiate Council on World Affairs",
    "purposeStatement": "To provide a forum and community for members to engage in world affairs while learning about diplomacy, international politics, and cultures...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Collegiate Farm Bureau at The Ohio State University",
    "purposeStatement": "The purpose of this organization shall be: i.\tTo provide support to students who are engaged in the field of agriculture; ii.\tTo serve as a ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "ColorStack at Ohio State",
    "purposeStatement": "ColorStack at Ohio State University is a chapter of the ColorStack National non-profit organization. It has the mission to increase the entr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Columbus Blue Jackets Club",
    "purposeStatement": "The Blue Jackets Club is designed to build greater unity and camaraderie amongst Columbus Blue Jackets fans, as well as all hockey fans. Thi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "The Columbus Crew Club at The Ohio State University",
    "purposeStatement": "The Columbus Crew Club at The Ohio State University serves as the Columbus Crew supporters group for students at The Ohio State University. ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Columbus Free Clinic Medical and Social Wellness Fellowship",
    "purposeStatement": "Students will have the opportunity to be an undergraduate fellow at the Columbus Free Clinic (CFC). Undergraduate fellows gain clinical expe...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Combat Robotics at Ohio State",
    "purposeStatement": "Combat Robotics at Ohio State (CROS) was established to create a close-knit and welcoming community revolving around fighting robots. The or...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Comic Book Club at Ohio State",
    "purposeStatement": "Comic Book Club is a group that functions like a traditional book club, but with a focus on graphic novels and long-form comics! Members wil...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Commercial Vocal Music Club",
    "purposeStatement": "Our mission is to create and cultivate a community of students interested in exploring, perfecting, and showcasing the art of commercial voc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "The Common Cents Investment Group",
    "purposeStatement": "The Common Cents Investment Group is the Fisher College of Business's foremost student-led investment organization and is open to students i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Community Enrichment Through Astronomy",
    "purposeStatement": "CETA’s mission is to take astronomy to the people. We aim to provide students with a platform for informally developing science communicatio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Technology",
      "Special Interest"
    ]
  },
  {
    "name": "Community of Appalachian Student Leaders",
    "purposeStatement": "To bring together students from the Appalachian regions in order to provide opportunities and allow room for individuals to grow academicall...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Comparative Studies Graduate Student Group",
    "purposeStatement": "CSGSG is a graduate student organization that provides intellectual, academic, professional, social, and emotional support to all graduate s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Competitive Programming Club",
    "purposeStatement": "To be the CPC student chapter at OSU and to train students to compete in the East Central Regional Competition (ECNA) and the International ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology",
      "Special Interest"
    ]
  },
  {
    "name": "Concrete Canoe Team",
    "purposeStatement": "The purpose of The Ohio State University Concrete Canoe Team is to design and construct a canoe made of concrete in order to submit it for j...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Sports and Recreation"
    ]
  },
  {
    "name": "CONNECT",
    "purposeStatement": "The purpose of this organization shall be to encourage and empower young people to develop their leadership and professional skills, civic e...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Conscious Ohio State",
    "purposeStatement": "By using methods such as mantra meditation, discussion on relevant spiritual topics, musical accompaniment and the partaking of Consciously-...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Religious/Spiritual",
      "Special Interest"
    ]
  },
  {
    "name": "Construction Systems Management Club of Ohio State",
    "purposeStatement": "To promote student's knowledge and interest in the construction field, integrate students into the construction industry by creating opportu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Contact Lens Advancement Society",
    "purposeStatement": "To provide students with contact lens knowledge, hands-on experiences, and networking opportunities.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Cook Book Club",
    "purposeStatement": "Our purpose is to help people's knowledge and love for cooking and baking expand through community encouragement.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Community Service/Service Learning",
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Cook with Communities",
    "purposeStatement": "CWC aims to improve nutrition in underserved communities through the use of interactive nutritional education, hands-on cooking classes, and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "The Cooking Club",
    "purposeStatement": "The Cooking Club aims to provide OSU student's with the opportunity to learn and share new recipes while getting a chance to learn about the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Coptic Club",
    "purposeStatement": "To create a community where Copts and interested parties can gather to learn about Coptic Orthodoxy and the culture and history of Egypt in ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Cornhole Club",
    "purposeStatement": "To have fun with friends while playing the eventful game of Cornhole",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Cosmetics Club at The Ohio State University",
    "purposeStatement": "To provide skills in creating one’s own homemade cosmetics, cosmetics usage, and knowledge of cosmetics. To come together and share ideas ab...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Council of Black Students in Administration",
    "purposeStatement": "Our mission is to Inspire, Enable and Support minority students to become better professionals.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Council of Graduate Students",
    "purposeStatement": "The Council of Graduate Students (CGS) is the representative body for all students enrolled in graduate programs at The Ohio State Universit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Council of Graduate Women in Computer Science",
    "purposeStatement": "In GWCS, we aim to promote and diversify the graduate program in computer science by encouraging more female undergrads to pursue a graduate...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Council on Minority Political Affairs",
    "purposeStatement": "The purpose of COMPA is to create a space that caters towards the advancement and full and equal representation of minority students in the ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Counselors for Social Justice at The Ohio State University",
    "purposeStatement": "Counselors for Social Justice works to promote social justice in our society through confronting oppressive systems of power and privilege t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Crazy Cool Crochet Club",
    "purposeStatement": "Create a space for people to explore their creativity and appreciate the art of garment making through crochet.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The Creative Wellness Project",
    "purposeStatement": "The Creative Wellness Project is a student-led initiative striving to engage students in the active re-imagination of what wellness looks li...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Crew Club - Sport Club",
    "purposeStatement": "The Ohio State Crew Club seeks to promote the fundamentals of rowing, as well as the principles of sportsmanship, teamwork, and good health ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Cricket - Sport Club",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Criminal Justice and Re-entry Initiative",
    "purposeStatement": "Our purpose is to create a space for students of OSU interested in criminal justice & reentry services to have an avenue by which to channel...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "CRIS Community Connectors at Ohio State",
    "purposeStatement": "CRIS Community Connectors at Ohio State aims to establish a campus presence for the Community Refugee and Immigration Services, a non-profit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "The Crohn's and Colitis Foundation at The Ohio State University",
    "purposeStatement": "The Crohn's and Colitis Foundation at The Ohio State University shall spread awareness about Inflammatory Bowel Diseases (IBD), such as Croh...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Crops and Soils Club",
    "purposeStatement": "Fostering a community of growth and learning in the realm of learning about crops and soils.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "CrossSports",
    "purposeStatement": "CrossSports’ purpose is to come alongside, resource, and encourage athletes' and coaches' growth in Christ. We will help Ohio State student-...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Crosswalk Outreach to the Homeless",
    "purposeStatement": "Crosswalk Outreach to the Homeless strives to give friendship, aid, and camaraderie to our brothers and sisters living on the streets of Col...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Cru at Ohio State",
    "purposeStatement": "Cru at Ohio State is an interdenominational student Christian organization seeking to provide a spiritual environment for students desiring ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Crucible Organization",
    "purposeStatement": "To develop a versatile skillset in entrepreneurial students intrigued by startups, bolstered by practical experience, that is vital for thri...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "CSCA at Ohio State",
    "purposeStatement": "CSCA at Ohio State is the student organization of visual communication designers at The Ohio State University Department of Design. The orga...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "CSE/CIS Peer Mentors",
    "purposeStatement": "CSE/CIS Peer Mentors is an organization to provide Computer Science & Engineering (CSE) and Computer Information Science (CIS) upperclassmen...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "CTRL + Paint",
    "purposeStatement": "CTRL + Paint is a traditional oil painting and digital art club. Our club provides oil painting resources such as paints, brushes, canvases,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Culinary Association",
    "purposeStatement": "Experience and explore culture, nutrition, and healthy living through collaborative events around food.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Culinary Medicine",
    "purposeStatement": "Culinary Medicine aims to increase the knowledge of future healthcare professionals about food preparation and nutrition in relation to thei...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Cultivate Columbus",
    "purposeStatement": "We seek to connect Ohio State students and the larger Columbus community with the resources to start and maintain sustainable, organic commu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Cultivating Change at Ohio State",
    "purposeStatement": "The Ohio State University chapter of Cultivating Change aims to provide a safe, inclusive network for students who are interested in food, a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Cultural Awareness, Representation, and Education",
    "purposeStatement": "Cultural Awareness, Representation, and Education (CARE) seeks to enhance medical training by bolstering cultural competency among the next ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Cultural Awareness, Respect, and Equity Rx",
    "purposeStatement": "CARE Rx is a student run organization that is committed to promoting an academically enriching and supportive environment, allowing all stud...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Cultures and Travel Club",
    "purposeStatement": "Cultures and Travel Club was created to bring people together to celebrate unique festivals, holidays and traditions with the local and inte...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The CVM Animal Behavior & Welfare Club at The Ohio State University",
    "purposeStatement": "Our mission is to educate veterinary students with the most up to date information on animal behavior and welfare and how to incorporate tha...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Cyber Security Club",
    "purposeStatement": "Our purpose is to promote cyber and information security across the university community, teach the different tools used in both defensive a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Cycling - Sport Club",
    "purposeStatement": "The Ohio State University Cycling team is a group of collegiate riders across multiple cycling disciplines that exist to support and develop...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Daebak",
    "purposeStatement": "Daebak is a vocal performance group that focuses on advocating the education and appreciation of different Asian cultures through music. Wit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Dance Coalition at The Ohio State University",
    "purposeStatement": "The purpose of this organization is to show how various dance forms from different cultures can merge.  Dancers will learn and combine eleme...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Dance Connection",
    "purposeStatement": "Dance Connection is a multi-genre dance organization at Ohio State that provides performance opportunities to students and community members...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Dance Irregulars",
    "purposeStatement": "The purpose of Dance Irregulars is to provide a dance community that can teach and encourage hip-hop and jazz dance workshops to dancers of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Dance of the Soul from China",
    "purposeStatement": "\"Dance is the art of the Soul.\" People from different culture, with different technical skill levels, can all dance together if he/she has t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Dancers in Graduate School",
    "purposeStatement": "We aim to provide resources and funding for creative and scholarly research, performances, and presentations. We also will provide a platfor...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "DanceSport at The Ohio State University - Sport Club",
    "purposeStatement": "The primary purpose of DanceSport at OSU - Competition Team is to promote the appreciation and recognition of ballroom dancing as a positive...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "The Daphne Project",
    "purposeStatement": "Our purpose is to educate older adults in the local Columbus community on health risks and preventative strategies in an interactive format....",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "The Deaf-Hearing Club at The Ohio State University",
    "purposeStatement": "To bring together people of all ages and all levels of fluency in American Sign Language, within and outside of The Ohio State University, t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Decision Psychology",
    "purposeStatement": "Decision Psychology is Graduate Student interest group for students with an interest in decision making.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Delight College Ministries",
    "purposeStatement": "The heart of Delight Ministries is to provide an environment for women to vulnerably share about how Christ has been at work in their lives....",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Delta Chi Fraternity at The Ohio State University",
    "purposeStatement": "To promote friendship, develop character, advance justice, and assist in the acquisition of a sound education.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Delta Gamma",
    "purposeStatement": "Delta Gamma offers to women of all ages a rich heritage, a continuity based on sound and tested principles of personal integrity, personal r...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Delta Omega Kappa",
    "purposeStatement": "The objectives of the sorority are to bring together students in medically related majors, to provide them with the knowledge, motivation, a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Delta Phi Lambda Sorority, Inc.",
    "purposeStatement": "Delta Phi Lambda Sorority, Inc.advocates Asian awareness, empowers women leaders through its values-based programs, and forges Everlasting S...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Delta Phi Omega Sorority, Inc.",
    "purposeStatement": "The organization will host academic, service, social and cultural events. The purpose of the organization is to empower women and promote So...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Delta Sigma Delta Dental Fraternity",
    "purposeStatement": "An international dental fraternity that brings together the leaders of the profession to further excellence in the ethical, professional and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Delta Sigma Phi",
    "purposeStatement": "The Delta Sigma Phi Fraternity in convention assembled declares and affirms the following principles:  That the belief in God is essential t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Delta Sigma Pi",
    "purposeStatement": "Delta Sigma Pi is a professional fraternity organized to foster the study of business in universities; to encourage scholarship, social acti...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Delta Sigma Theta Sorority, Inc.",
    "purposeStatement": "Delta Sigma Theta Sorority, Inc. is an organization of college-educated women committed to the constructive development of its members, and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Delta Tau Delta Fraternity,  Beta Phi Chapter",
    "purposeStatement": "The Beta Phi chapter of Delta Tau Delta International Fraternity is dedicated to the continual ascension towards greatness and superiority a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Honoraries/Honor Societies",
      "Academic/College"
    ]
  },
  {
    "name": "Delta Theta Sigma Agricultural Fraternity",
    "purposeStatement": "We the Members of Delta Theta Sigma Fraternity,  In order to promote agriculture, to secure a higher degree of scholarship, to foster the sp...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Special Interest"
    ]
  },
  {
    "name": "Delta Zeta",
    "purposeStatement": "The purpose of this sorority shall be to unite its members in the bonds of sincere and lasting friendship, to stimulate one another in the p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Dental Anesthesia Club for Students",
    "purposeStatement": "DACS is centered on on in-office medical emergency management with supplemental discussions of sedation within dentistry.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Dental Diners & Dives",
    "purposeStatement": "Dental Diners and Dives aims to increase the knowledge of future healthcare professionals about food preparation and nutrition in relation t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Dental Entrepreneur Society at The Ohio State University College of Dentistry",
    "purposeStatement": "Dental Entrepreneur Society at The Ohio State University is established to provide educational and networking opportunities to dental studen...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Dental Esthetics Club at Ohio State",
    "purposeStatement": "The Dental Esthetics Club focuses on utilizing multi-disciplinary considerations and techniques to achieve exceptional patient esthetic outc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Dental Hygiene Senior Class Student Organization",
    "purposeStatement": "A group of student leaders that advocate for the Dental Hygiene Senior Class.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Dental Pride Alliance",
    "purposeStatement": "The Dental Pride Alliance (hereafter referred to as DPA) of The Ohio State University College of Dentistry (OSUCoD) is a professional studen...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Department of East Asian Languages and Literatures Undergraduate Student Organization",
    "purposeStatement": "Cultivating a greater sense of community and belonging amongst DEALL Undergraduate students, professors, and undergraduates interested in Ea...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Dermatology Interest Group",
    "purposeStatement": "The dermatology interest group will provide all medical students with the opportunity to learn more about the field of dermatology and conne...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Dermatology Ultrasound Community of Practice",
    "purposeStatement": "The purpose of the Dermatology COP is to foster increased interest in both Dermatology and Ultrasound. The utility of ultrasound is rapidly ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Design for 90",
    "purposeStatement": "Design for 90 aims to provide students with an opportunity to be involved in a collaborative learning environment and put to use their skill...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Design ThinkTank",
    "purposeStatement": "At Design ThinkTank, our mission is to expose a diverse group of students to the creative problem solving framework of Design Thinking and e...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Design/Build/Fly",
    "purposeStatement": "Design/Build/Fly's goal is to compete in the annual AIAA Design/Build/Fly competition by to creating a radio controlled electric aircraft.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Dhadkan",
    "purposeStatement": "To provide a South Asian A Cappella group that expresses their Asian American culture through music.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "The Diabetes Link",
    "purposeStatement": "The College Diabetes Network’s mission is to provide innovative peer-based programs which connect and empower students and young professiona...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Diagnostic Radiology Interest Group",
    "purposeStatement": "The purpose of the Diagnostic Radiology Interest Group is to provide students in the OSU College of Medicine with an avenue to explore the m...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Diamond Grove Scholars",
    "purposeStatement": "Diamond Grove Scholars' mission is to create a place for all students in space. We are here for students K-Ph.D. and we welcome any and all ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Digital Art Club",
    "purposeStatement": "Digital Art Club is an organization committed to building a stronger art community by engaging in the members’ academic and professional int...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Technology",
      "Academic/College"
    ]
  },
  {
    "name": "Disability Advocacy Coalition - Medicine",
    "purposeStatement": "The purpose of Disability Advocacy Coalition – Medicine (DAC-Med) is three-fold: 1) to increase inclusion in the field of medicine concernin...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Disability Studies Graduate Student Association",
    "purposeStatement": "This organization is for those graduate students who are completing the interdisciplinary specialization in disability studies or who are in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Disc Golf Club at Ohio State",
    "purposeStatement": "Disc Golf Club at Ohio State promotes the sport of disc golf on campus and provides a disc golf community for students. The club is open to ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Disc With Docs",
    "purposeStatement": "To provide OSU healthcare students an avenue to stay active and learn about ultimate frisbee. We will also provide a way to network with hea...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Disciples on Campus",
    "purposeStatement": "To help people gain an understanding of Jesus and Christianity as well as apply those principles through serving, fellowship, bible studies,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Dispute Resolution and Youth",
    "purposeStatement": "DRY seeks to provide Moritz students with the opportunity to gain more experience in dispute resolution and interaction with the local commu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Diversty Devlopers at The Ohio State University",
    "purposeStatement": "Our club is dedicated to ensuring computer science is accessible to all, particularly marginalized groups such as women, racial minorities, ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "DJ Club at Ohio State",
    "purposeStatement": "Founded in the spring of 2018, the purpose of DJ Club at Ohio State is to connect and educate DJ’s. We will host workshops to teach beginner...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "The Doctor of Optometry Private Practice Club",
    "purposeStatement": "The Doctor of Optometry Private Practice Club prepares optometry students to apply optometric education in the pursuit of building successfu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Doctoral Student Organization in Social Work",
    "purposeStatement": "To provide resources to prepare Doctoral students to successfully matriculate through their Social Work programs, and to do intentional prog...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Doctorate of Physical Therapy Program at Ohio State",
    "purposeStatement": "The mission of the Physical Therapy Division of The Ohio State University is to represent its members and to advance the profession of physi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Doctors Without Borders/Medecins Sans Frontieres Friends of MSF Chapter at The Ohio State University",
    "purposeStatement": "To raise money for and spread awareness about Doctors Without Borders' mission of delivering emergency aid to people affected by armed confl...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "The Dodgeball Syndicate - Sport Club",
    "purposeStatement": "The OSU Dodgeball Syndicate forms a group atmosphere that improves its player’s abilities to, communicate as a team, perform in a pressured ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Dr. J.H. Bias Black Affinity Group",
    "purposeStatement": "The Dr. J.H. Bias Black Affinity Group hopes to strengthen and empower the Black community and foster diversity and inclusion of all student...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Dragon Phoenix Wushu - Sport Club",
    "purposeStatement": "Modern wushu is contemporary and competitive form of Chinese Kung Fu encompassing choreographed forms, traditional kung fu techniques/styles...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Ducks Unlimited at The Ohio State University",
    "purposeStatement": "Ducks Unlimited at The Ohio State University gives students the opportunity to participate and volunteer in an organization designed to cons...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Community Service/Service Learning",
      "Sports and Recreation",
      "Awareness/Activism"
    ]
  },
  {
    "name": "E-Bike Buckeyes at The Ohio State University",
    "purposeStatement": "The E-Bike Buckeyes design, build, and test E-Bikes and promote and discuss sustainable urban development of our cities and transportation i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "East Asian Student Union",
    "purposeStatement": "East Asian Student Union or EASU is a foundation where American and international students of East Asian region freely voice out for themsel...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Echo Chinese Student Organization",
    "purposeStatement": "Echo Chinese Student Organization (Echo) is a nonprofit registered student organization at the Ohio State University established by enthusia...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Governance Organizations",
      "Academic/College"
    ]
  },
  {
    "name": "Eco-Peace",
    "purposeStatement": "Eco-Peace is an Ohio State club that represents the standard of excellence that students feel toward the love of the Earth and their campus...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "EcoCAR Challenge Team at The Ohio State University",
    "purposeStatement": "The EcoCAR Team at the Ohio State University is a group of undergraduate and graduate students who convert a GM donated vehicle into a hybri...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Ecological Engineering Society",
    "purposeStatement": "To educate ourselves and others about ecological engineering and its potential uses, to develop our potential as ecological engineers throug...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Economics Graduate Student Society",
    "purposeStatement": "The purpose of the Society is to foster community among graduate students of the Economics department, facilitate student-faculty-staff rela...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations",
      "Special Interest"
    ]
  },
  {
    "name": "EcoSpace Columbus",
    "purposeStatement": "Eco Space is a student run organization with the goal of acting as a \"mini environmental protection agency\" within the Columbus area and bey...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning",
      "Technology"
    ]
  },
  {
    "name": "Educational Philosophy, History, and Policy Graduate Student Group",
    "purposeStatement": "The purpose of EPHP is to bring together graduate students who major, or are professionally interested, in philosophy of education, history ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Edward S. \"Beanie\" Drake Student Leader Endowment Fund",
    "purposeStatement": "The purpose of this scholarship is to provide funds that enable deserving students to participate in campus activities when need might other...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "EERI Ohio State University Student Chapter",
    "purposeStatement": "The purpose of forming an Earthquake Engineering Research Institute (EERI) chapter is to promote awareness, education, and research in earth...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Effective Altruism at Ohio State",
    "purposeStatement": "Effective Altruism at Ohio State aims to promote effective altruism in all its forms, including encouraging increased charitable donations a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Technology"
    ]
  },
  {
    "name": "The Egality Coalition at The Ohio State University",
    "purposeStatement": "The purpose of this organization is to promote equity and justice in public policy. These ideas center around strong workers’ rights, public...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism"
    ]
  },
  {
    "name": "Egyptian Student Association at The Ohio State University",
    "purposeStatement": "The Egyptian Student Association is devoted to creating and maintaining an environment beneficial to the interests of primarily its members ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Electronics Club",
    "purposeStatement": "The purpose of the Electronics Club is to: A)\tTo promote education in the field of electronics B)\tTo stimulate interest in the field of elec...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Elohist Bible Study",
    "purposeStatement": "Elohist Bible Study Club aims to deliver comfort and warmheartedness of Mother to all students across campus.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Emergency Medicine Interest Group",
    "purposeStatement": "The Emergency Medicine Interest Group is a group for medical students with a special interest in emergency medicine.  The EMIG will provide ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Emergency Medicine Ultrasound Community of Practice",
    "purposeStatement": "The Emergency Medicine Ultrasound Community of Practice hopes to unite medical students, residents, fellows, and faculty within a single Com...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "EMIC: Graduate Student Interest Group for Expressive Culture",
    "purposeStatement": "EMIC exists as a scholarly and social interest group for students involved in the study of expressive culture at the Ohio State University w...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Empower Mentoring",
    "purposeStatement": "Empower Mentoring expands economic opportunity in the United States by equipping urban youth to believe in themselves, navigate the financia...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Empower Sports at The Ohio State University",
    "purposeStatement": "Empower Sports at The Ohio State University’s mission is to harness the power of competition and teamwork in sports to build the self-confid...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Empower Through Health at The Ohio State University",
    "purposeStatement": "To improve healthcare access to a vulnerable population by strengthening local healthcare capacity and addressing root causes of poor mental...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "EmpowHER",
    "purposeStatement": "We strive to provide girls and nonbinary students the opportunity to lead and thrive, providing them the tools to become change-makers in th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "ENCompass: Empowering Neighborhoods of Columbus",
    "purposeStatement": "1. To cultivate interdisciplinary student leadership through volunteer immersion experiences in the Columbus community. 2. To empower indivi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Technology"
    ]
  },
  {
    "name": "Endo Club",
    "purposeStatement": "To provide an informative, fun and relaxed setting for Ohio State's dental/hygiene students interested in endodontics. We plan to meet Thurs...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Energy and Environmental Law Society",
    "purposeStatement": "The purposes of the Energy and Environmental Law Society shall be:  (1) To promote awareness of legal, policy, and regulatory issues that af...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Governance Organizations"
    ]
  },
  {
    "name": "Engineers for a Sustainable World",
    "purposeStatement": "A world in which engineering fosters environmental, social, and economic sustainability to improve both the quality of life and the conditio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Technology",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Engineers for Community Service",
    "purposeStatement": "We are a student organization at The Ohio State University, promoting life-long professionalism via educational experiences in the uses of e...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Engineers Without Borders at The Ohio State University",
    "purposeStatement": "Engineers Without Borders (EWB) is an international organization that applies engineering solutions to aid in the development of underprivil...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Engineers' Council",
    "purposeStatement": "Serving as Ohio State's Engineering Student Organization Governance Body, the Engineers' Council represents the voice of the Students to Col...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations",
      "Technology"
    ]
  },
  {
    "name": "English Graduate Organization",
    "purposeStatement": "The English Graduate Organization (EGO) is the graduate student association that assures and expedites student involvement in English Depart...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "English Undergraduate Organization",
    "purposeStatement": "The English Undergraduate Organization seeks to connect and support undergraduate students majoring or minoring in English at The Ohio State...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Enlighten Anti-Human Trafficking",
    "purposeStatement": "Enlighten mobilizes students to confront human trafficking and create a culture of compassion through on-campus awareness, direct community ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "ENT Interest Group",
    "purposeStatement": "To promote and expose students to the field of Otolaryngology (ENT) through conferences, volunteerism, and discussion.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Entomology Graduate Student Association",
    "purposeStatement": "EGSA provides graduate students affiliated with The Ohio State University (OSU) Department of Entomology with various opportunities related ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Environmental Science Graduate Program Student Association",
    "purposeStatement": "The Environmental Science Graduate Program Student Association (ESGP-SA) works to foster community and professional development in the ESGP....",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Epigenetics Group at Ohio State/NCH",
    "purposeStatement": "We the members of CEG at Ohio State hereby associate ourselves to: A.\tProvide for the members a voice in matters affecting them in the Ohio ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Epsilon Psi Epsilon",
    "purposeStatement": "The fraternity shall be known as Epsilon Psi Epsilon Fraternity, and shall have for its objectives the pursuit and cultivation of the practi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College"
    ]
  },
  {
    "name": "Epsilon Tau Pi Brotherhood of Eagle Scouts",
    "purposeStatement": "We are dedicated to upholding the high ideals of the Eagle rank. These include the ideals of Honor, Loyalty, and Courage, as well as service...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Equestrian Club, Hunt Seat - Sport Club",
    "purposeStatement": "To provide any interested student, regardless of skill level, the opportunity to work with, ride, and show horses in a fun and affordable en...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Eritrean Student Association",
    "purposeStatement": "The purpose of  ESA is to meet the educational, social, and cultural needs of Eritrean students at The Ohio State University and in the grea...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Eta Kappa Nu",
    "purposeStatement": "To acknowledge the achievements of outstanding juniors, seniors, graduates, and faculty in Electrical and Computer Engineering, and to provi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "ETHER CRUSH",
    "purposeStatement": "ETHER CRUSH's purpose is to create music and perform as a professional band for a long-lasting career, all while telling a meaningful story ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Evans Scholars, Theta Chapter at Ohio State",
    "purposeStatement": "The Ohio State Evans Scholars are committed to excelling scholastically. Our goals are to remain the top scholarship house among the many st...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Special Interest",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Evolution and Ecology Club",
    "purposeStatement": "The purpose of Evolution and Ecology Club is to enhance the academic experience of Ohio State University students, faculty, and staff with i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Exercise and Nutrition Journal Club",
    "purposeStatement": "The purpose of this group is to create an inclusive academic space to facilitate discussion of topics relating to exercise and nutrition in ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Exercise is Medicine - On Campus Club @ The Ohio State University",
    "purposeStatement": "EIM-OC's purpose is to promote physical activity as a vital sign of health. We encourage faculty, staff and students to work together to imp...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Exercise Science Club",
    "purposeStatement": "The Exercise Science Club at the Ohio State University will provide opportunities for extra-curricular and professional enhancement of the E...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Existentialism Society at Ohio State",
    "purposeStatement": "Well-known continental philosophers to date have explored existentialism based on phenomenology. Based on a general understanding of this, w...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Exotic Animals in Private Practice",
    "purposeStatement": "Our club is designated to specifically give veterinary students exposure and experience in the field of exotic animals in private practice. ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "EYE Advocates in Diversity",
    "purposeStatement": "The purpose of EYEAID is to provide a space for pre-optometry students of color at The Ohio State University to connect and support one anot...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Eyes on Health",
    "purposeStatement": "Eyes on Health aims to better ourselves and the communities we serve through outreach, service, and education with a focus on health and vis...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "THE F1 Paddock",
    "purposeStatement": "F1 OSU provides a space for Formula One fans to congregate and watch races together while engaging in conversation revolving around the moto...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Fabulous Unique Neighborhood Community Council",
    "purposeStatement": "To create an inclusive, respectful, and encouraging environment for residents of FUN’s jurisdiction and to offer residents opportunities for...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Governance Organizations",
      "Special Interest"
    ]
  },
  {
    "name": "Faith & Fitness",
    "purposeStatement": "Bringing glory to God through faith, fitness, and fellowship.  Our vision is to teach healthy living habits to encourage spiritual, mental, ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Faith Hope Love House of Prayer",
    "purposeStatement": "To be a body of believers who love God with all our heart, soul, mind, and strength, and love our neighbors as ourselves. We will do this by...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Creative and Performing Arts",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Faith Works Chinese Student Club",
    "purposeStatement": "a. To promote the sharing of ideas, thoughts and values through discussions over social, cultural and spiritual topics. b. To represent stud...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Falun Dafa Practice Group",
    "purposeStatement": "Falun Dafa is a self-cultivation practice based on the principles of Truthfulness, Compassion, and Tolerance. The five meditative exercises ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Family Guy Club",
    "purposeStatement": "Our club is a safe space for all fans of the great TV show, Family Guy. Whether members want to take a break from their schoolwork, get some...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Family Medicine Interest Group",
    "purposeStatement": "The purpose of the Family Medicine Interest Group (FMIG) at the Ohio State University College of Medicine is to promote the values and visio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Family Medicine Point-of-Care Ultrasound",
    "purposeStatement": "The specialty of family medicine has a wide breadth intended to provide comprehensive care to all body systems of patients of all ages, in a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Fantasy Football Club at The Ohio State University",
    "purposeStatement": "Hello and welcome to Fantasy Football Club at The Ohio State University! Our goal is to promote fantasy football within The Ohio State commu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "FarmHouse Fraternity, The Alpha Tau Zeta Chapter",
    "purposeStatement": "The object of our fraternity is to promote good fellowship, to encourage studiousness, and to inspire its members in seeking the best in the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Fashion & Retail Studies Student Ambassador Program",
    "purposeStatement": "The purpose of the Fashion & Retail Studies Student Ambassador Program is to serve as the center point of the Fashion & Retail Studies major...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "The Fashion Collective",
    "purposeStatement": "Mission Statement of The Fashion Collective and Magazine:  At The Fashion Collective, we are more than just a student organization and magaz...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "The Fashion Production Association",
    "purposeStatement": "To provide students within the Fashion and Retail Studies program in the college of Education and Human Ecology with the opportunity to publ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "The Federalist Society at The Ohio State University Moritz College of Law",
    "purposeStatement": "The Federalist Society at The Ohio State University is an organization interested in free thought and debate on the current state of the leg...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College"
    ]
  },
  {
    "name": "Fellowship of Christian Optometrists",
    "purposeStatement": "The purpose of the Fellowship of Christian Optometrists is to establish and advance at colleges and universities witnessing communities of s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Fellowship of Student Anatomists",
    "purposeStatement": "To promote and foster leadership, scholarship, and community within the Division of Anatomy.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Fem Stem",
    "purposeStatement": "Fem Stem is a branch of The Be W.I.S.E Initiative, a 501c nonprofit that has inspired 4,860+ women in STEM and has numerous chapters through...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "The Female Gaze Screening Club",
    "purposeStatement": "Our purpose is to provide a space for students who identify as a female or a gender minority to voice their thoughts and opinions about the ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Females of Chemistry Uniting Scientists",
    "purposeStatement": "FOCUS (Females of Chemistry Uniting Scientists) will be a student-run seminar series and community outreach program whose purpose is to prom...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Fencing Club - Sport Club",
    "purposeStatement": "The Ohio State University Fencing Club exists with the goal of educating students in the Olympic sport of fencing in a safe, fun and social ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Field Hockey Co-Ed - Sport Club",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Fighting Pretty at Ohio State",
    "purposeStatement": "We wish to raise awareness and fundraise for the non-profit organization Fighting Pretty. We will purchase Pretty Packages from fightingpret...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Figure Skating Club - Sport Club",
    "purposeStatement": "The purpose of this club is to unite those interested in promoting, advancing and competing in the sport of figure skating through the devel...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Film and Video Society",
    "purposeStatement": "Welcome to FVS! We meet weekly to discuss films we've been watching and new releases, as well as playing film-themed trivia. Our meetings ar...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Finance in Medicine",
    "purposeStatement": "We aim to equip medical students with the tools and resources to manage their personal finances, navigate student loan debt, and plan for th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Financial Literacy for the Youth at Ohio State",
    "purposeStatement": "The goal of Financial Literacy for the Youth (FLY) is to provide a financial wellness education to the youth of the Columbus area. We will t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "FIRST Alumni and Robotics at Ohio State",
    "purposeStatement": "The purpose of FIRST Alumni and Robotics at Ohio State (FROS) is to support the local FIRST community through mentorship and participate as ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Special Interest",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "First Year Leadership Initiative",
    "purposeStatement": "To create a year-long program for first year students, aimed at developing leadership, communication, and professional development skills an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "First-Generation Medical Student Association",
    "purposeStatement": "The First-Generation Medical Student Association is an organization which aims to provide support and guidance to first-generation medical s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "First-Generation Pre-Medical Student Association",
    "purposeStatement": "The First-Generation Pre-Medical Student Association is an organization which aims to provide guidance for first generation undergraduate st...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "First-Generation Pre-Physician Assistant Platform",
    "purposeStatement": "Representation matters, and while it is desirable by most to strive to be a flawless Pre-Physician Assistant (PA), undergraduate student, an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Technology"
    ]
  },
  {
    "name": "The Fish and Wildlife Society",
    "purposeStatement": "We aim to foster greater wildlife awareness at Ohio State. By promoting stewardship of wildlife resources and their habitats, we encourage a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation",
      "Awareness/Activism",
      "Academic/College"
    ]
  },
  {
    "name": "Fishbowl Improvisational Comedy Group",
    "purposeStatement": "Fishbowl Improvisational Comedy Group is here to bring together creative-minded students, and to explore their unique talents through improv...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Fisher Board Fellows",
    "purposeStatement": "The purpose of Fisher Board Fellows is to serve the Central Ohio community through partnerships with nonprofit organizations in the local ar...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Fisher Citizenship Program",
    "purposeStatement": "To provide an opportunity for undergraduate business students to play an active role in the Fisher community, foster student involvement, bu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Fisher College of Business Graduate Programs Veterans Association",
    "purposeStatement": "The Fisher Veterans Association is dedicated to furthering the opportunities of Fisher College of Business students who have served in the A...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Fisher Consulting & Strategy Club",
    "purposeStatement": "The mission of the Fisher Consulting & Strategy Club is to engage and serve students interested in the field of consulting and strategy, bot...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Fisher Follies",
    "purposeStatement": "Fisher Follies is a non-profit organization whose purpose is three-fold: (1) to foster a sense of community at the Fisher College of Busines...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Fisher Graduate Finance Association",
    "purposeStatement": "To serve students by educating them on diverse applications of finance, facilitate networking with finance professionals and each other, and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Fisher Graduate Networking Club",
    "purposeStatement": "The Fisher Graduate Networking Club is a networking group for Fisher Graduate students of various backgrounds and majors.  Every month, we w...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Fisher Graduate Women in Business",
    "purposeStatement": "Fisher Graduate Women in Business (FGWIB) is dedicated to supporting and empowering women, advancing gender equity in business, and creating...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Fisher Indian Student Association",
    "purposeStatement": "To position FISA to a spirited active organization that caters to the professional and social needs of Indian Students across all graduate p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Fisher Ink",
    "purposeStatement": "Fisher Ink strives to inform and unify the student body, fostering a sense of community, while enriching staff collaboration.  Fisher Ink is...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Fisher International Graduate Students Association",
    "purposeStatement": "The Fisher International Graduate Students Association primarily aims to provide a safe and welcoming environment for international graduate...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Fisher MBA Council",
    "purposeStatement": "The MBA Council is the student government for the Full-Time MBA program at the Fisher College of Business.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College"
    ]
  },
  {
    "name": "Fisher Real Estate Society - Undergraduate Chapter",
    "purposeStatement": "The Fisher Real Estate Society (FRES) is a student organization created to promote careers in the real estate industry and foster academic p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Fisher Serves",
    "purposeStatement": "Fisher Serves, a club for MBA students within the Fisher College of Business, is dedicated to fostering volunteerism by connecting students ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "FisherCares",
    "purposeStatement": "FisherCares aims to unite undergraduate students through service and involvement both on and off campus. By giving back to the community, we...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Flight Team at The Ohio State University",
    "purposeStatement": "To promote excellence in aviation and professional development in students.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Folclor Hispano",
    "purposeStatement": "Folclor Hispano, a dance group at The Ohio State University, strives to learn and present traditional folkloric dances of Spanish-speaking c...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Folklore Student Association",
    "purposeStatement": "The purpose of the organization shall be to provide intellectual, academic, professional, social and emotional support to all students affil...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Food and Nutrition Forum",
    "purposeStatement": "Our mission is to create a supportive and diverse community for nutrition students that share common interests and goals. We explore the vas...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Food Animal Club",
    "purposeStatement": "The Food Animal Club of The Ohio State University, College of Veterinary Medicine seeks to increase exposure of students to all aspects of a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Food Recovery Network at Ohio State",
    "purposeStatement": "Food Recovery Network is the largest student movement against food waste and hunger in America. The organization aims to unite OSU students ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Food Science and Technology Club",
    "purposeStatement": "To foster a close relationship among the Food Science and Technology students and the faculty at The Ohio State University, to encourage lea...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Food Science College Bowl Team for The Ohio State University",
    "purposeStatement": "The Institute of Food Technology Student Association hosts a trivia competition every year dubbed \"College Bowl.\" This is a competitive team...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Food, Agricultural and Biological Engineering Graduate Student Organization",
    "purposeStatement": "To provide an organized outlet for communication between graduate students and departmental faculty and staff. To bring together students fr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "The Forestry Forum",
    "purposeStatement": "The Forestry Forum aims to strengthen forestry professional skills and increase student exposure to education and employment opportunities i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Formula Buckeyes at The Ohio State University",
    "purposeStatement": "The Formula Buckeyes are a student project team who design, build, and compete a formula-style race car against other universities from arou...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Fountain of Life Campus Ministry, CLGI",
    "purposeStatement": "Our purpose as a smaller community within a much larger one is to not only further the gospel of Jesus Christ, but to give back in our Bucke...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Four Square Club at the Ohio State University",
    "purposeStatement": "The Four Square Club exists in order to provide an opportunity for students to engage in playing Four Square non-competitively for their own...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "French and Italian Graduate Student Association",
    "purposeStatement": "The purpose of FIGSA is:  A) to develop in its members an understanding of the organization and functioning of the Department of French and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "French Club",
    "purposeStatement": "Le Cercle Français (French Club) plans linguistic and cultural events for anyone at Ohio State who wants to learn more about France and Fran...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Fresh Start",
    "purposeStatement": "To help the homeless population in our community by fundraising for GoBags filled with essential hygiene products. These GoBags will consis...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Friendship Circle at The Ohio State University",
    "purposeStatement": "The purpose of this student-run organization is to provide Ohio State students with the opportunity to volunteer and contribute to enhancing...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "From the Page to the Bedside",
    "purposeStatement": "To offer monthly literature seminars led by a diverse group of faculty members, administrators, and peers centering around literary works th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "The Futsal Club at The Ohio State University",
    "purposeStatement": "The purpose of The Futsal Club at The Ohio State University is to increase awareness of and involvement in the sport of futsal, promote phys...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Academic/College"
    ]
  },
  {
    "name": "Future Buckeye Physician Associates",
    "purposeStatement": "FBPA is an organization founded by undergraduate students aspiring to have a future career as a Physician Associate. The club’s mission is t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Game Creation Club",
    "purposeStatement": "A student organization dedicated to providing the environment and resources for learning the process of developing video games.  Students an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts",
      "Technology"
    ]
  },
  {
    "name": "Gamma Iota Sigma",
    "purposeStatement": "Gamma Iota Sigma is an independent business fraternity that strives to promote professionalism and community.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies",
      "Special Interest"
    ]
  },
  {
    "name": "Gamma Phi Beta",
    "purposeStatement": "To inspire the highest type of womanhood.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Garden Club",
    "purposeStatement": "To spread the fun hobby of gardening and other plant related hobbies, to provide students with new plants and gardening materials, and to ex...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Generation Action",
    "purposeStatement": "A program that educates college-aged Americans about the threats to reproductive health and rights and mobilizes them in support of reproduc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "The Generation Rx Collaborative",
    "purposeStatement": "A: To enhance medication safety amongst various populations B: To combat the increasing misuse and abuse of prescription and over-the-counte...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Genetics and Genomics Interest Group",
    "purposeStatement": "The Genetics and Genomics Interest Group explores the intersection between genetics and human health. Through lectures, patient panels and o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Geography Club at Ohio State",
    "purposeStatement": "The Undergraduate Geography Club is a community for all students studying or interested in Geography. We plan to involve members in mapping ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Geography Graduate Organization",
    "purposeStatement": "The primary purpose of the Geography Graduate Organization (GGO) is to provide an open and scholarly forum for OSU geography graduate studen...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Geology Club at The Ohio State University",
    "purposeStatement": "Encouraging interest in the Earth Sciences through community, open discourse and hands-on experience via curated field trips to significant ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "German Club at The Ohio State University",
    "purposeStatement": "To promote and encourage the proficiency and enjoyment of the German Language among the Ohio State University student body and other interes...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Germanic Graduate Students Association",
    "purposeStatement": "To facilitate professional opportunities for graduate students in Germanic Languages and Literatures as well as amongst colleagues in relate...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Girl Gains",
    "purposeStatement": "Our mission is to promote female weight lifting while empowering women to feel strong and beautiful in a judgment-free community.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Girl Up At The Ohio State University",
    "purposeStatement": "At Girl Up Ohio State, our mission is to stand up and advocate for the Rights of every girl. Through activities like fundraising and storyte...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Girls Club at Ohio State",
    "purposeStatement": "A platform for all girls wanting to make a statement in the ultimate boys club - sports.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Girls Who Code: College Loops at Ohio State",
    "purposeStatement": "Girls Who Code is a national organization closing the gender gap in computer science fields. The College Loops program at OSU focuses on bui...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Technology"
    ]
  },
  {
    "name": "Girls' Lifting Organization",
    "purposeStatement": "The aim of GLO is to create a safe, supportive community for female-identifying gym-goers of all experience levels. Upon joining GLO, club m...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Give Hope Africa at The Ohio State University",
    "purposeStatement": "Give Hope Africa is a globally recognized non-profit organization whose mission is to provide basic necessities for fully orphaned children ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Give Kids a Smile",
    "purposeStatement": "Give Kids a Smile brings together volunteers two times a year to provide free comprehensive dental treatment to children in need.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "The Glass Club at The Ohio State University",
    "purposeStatement": "The Glass Club at OSU’s mission is to promote all aspects of creative work in glass across the university. Through an active visiting artist...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Glenn College Doctoral Student Organization",
    "purposeStatement": "To encourage Glenn College doctoral student involvement in research and service to the community.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Global Buckeyes",
    "purposeStatement": "- Provide an inclusive space for both international and domestic student-athletes through activities and events. - Cultivate a conducive lea...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Global Energy and Sustainability",
    "purposeStatement": "Our goal is to educate students on what different countries are doing to combat climate change through renewable energy and sustainability m...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Global Leadership Center",
    "purposeStatement": "Belong. Grow. Serve.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Global Medical Brigades",
    "purposeStatement": "At Global Medical Brigades, a nonprofit organization, we empower aspiring healthcare professionals to make a tangible impact in under-resour...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Global Outreach at The Ohio State University",
    "purposeStatement": "Global Outreach aims to educate Ohio State students on global health inequities as well as assisting members in community service to combat ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism"
    ]
  },
  {
    "name": "Go Club at The Ohio State University",
    "purposeStatement": "The purpose of the club is to provide the Ohio State University students with opportunities to learn, play, and engage with others through t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Ethnic/Cultural",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Gold Humanism Honor Society",
    "purposeStatement": "The Gold Humanism Honor Society is a national society recognizing and supporting humanistic exemplars in medicine.  The OSU chapter's goal i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Gold Key International - Optometric Senior Honorary",
    "purposeStatement": "The purpose of Gold Key is to recognize upper class students who have demonstrated outstanding professional and ethical attitudes through le...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College"
    ]
  },
  {
    "name": "Golf Team - Sport Club",
    "purposeStatement": "The Club Golf Team at The Ohio State University competes in the Ohio Valley Region of The National Collegiate Club Golf Association (NCCGA)....",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Google Developer Student Clubs at The Ohio State University",
    "purposeStatement": "The Google Developer Student Clubs (GDSC) chapter at OSU is a student-led community supported by Google for Developers, for OSU students int...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Grad CRU at the Ohio State University",
    "purposeStatement": "Grad Cru at Ohio State is an interdenominational student Christian organization seeking to provide a spiritual environment for Graduate and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "GradRoots",
    "purposeStatement": "GradRoots is committed to serving the SENR graduate student populace by advocating for their needs, informing them of school and university ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Graduate Association of Chinese Linguistics",
    "purposeStatement": "The Graduate Association of Chinese Linguistics (GACL) is a registered student organization with the goal of promoting the linguistic study ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Graduate Association of Latine and Latin American Students",
    "purposeStatement": "GALA, formerly the Latin@ Graduate & Professional Student Association (LGPSA) is the oldest Hispanic organization on campus; our tenure has ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College"
    ]
  },
  {
    "name": "Graduate Association of Mental Health Action and Advocacy",
    "purposeStatement": "The Graduate Association of Mental Health Action and Advocacy (GAMHAA), founded in 2017, is organized for the purpose of advocating for the ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Graduate Chapter of Society of Women Engineers",
    "purposeStatement": "The OSU Graduate Chapter of Society of Women Engineers consists of female engineering graduate students that represent the top leaders in OS...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Graduate Engineering Education Organization",
    "purposeStatement": "The Graduate Engineering Education Organization (GEEO) shall serve as a hub for collaboration among OSU graduate students engaged in enginee...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Graduate Evolution and Ecology Students",
    "purposeStatement": "The purpose of GEES shall be (1) to promote the professional, educational, and intellectual advancement of the graduate students in the Depa...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Graduate Music Student Association",
    "purposeStatement": "As the representative body of the graduate students enrolled at The Ohio State University School of Music, elected members will serve as the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts",
      "Governance Organizations"
    ]
  },
  {
    "name": "Graduate Muslim Club",
    "purposeStatement": "GMC intends to facilitate current and incoming Muslim graduate students and scholars comfortably accommodated to the lifestyle and culture a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Graduate Organization for Vision Science",
    "purposeStatement": "To encourage the development of graduate students in Vision Science.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Graduate Philosophy of Religion",
    "purposeStatement": "Purpose:  The purpose of Graduate Philosophy of Religion is to create a forum for dialogue amongst graduate students on the subject of philo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Graduate Planners Society",
    "purposeStatement": "The Graduate Planners Society is a student organization whose primary purpose is to promote the advancement of its members, in and out of th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Graduate Society of Nutritional Sciences",
    "purposeStatement": "Promote professionalism among graduate students in the area of nutrition. Develop unity among graduate students within the department. Provi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Graduate Student Art Club",
    "purposeStatement": "The Graduate Students Art Club is a community-building, professional development, and networking group for all Graduate Students enrolled in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Graduate Student Association for Learning Technologies",
    "purposeStatement": "The purpose of the organization is to support the academic and professional growth of graduate students in Learning Technologies. We seek to...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Graduate Student Painting Club",
    "purposeStatement": "The Graduate Student Painting Club is a social and professional forum for sharing painting practices and methods through studio visits, crit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Academic/College"
    ]
  },
  {
    "name": "Graduate Student Working Group for Foreign Language Research and Teaching",
    "purposeStatement": "We, the members of FLRT, endeavor to provide opportunities for academic and professional development. Our organization will create options f...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Graduate Students of Anthropology Association",
    "purposeStatement": "I. GSAA should keep graduate students informed of department events, committees, and decisions as well as promote graduate student interests...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Graduate Students of East Asian Languages & Literatures",
    "purposeStatement": "The purpose of our organization is to provide the graduate students of the Department of East Asian Languages & Literatures at the Ohio Stat...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "The Graduate Theatre Syndicate",
    "purposeStatement": "The purpose of The Syndicate is to provide graduate students in The Ohio State University Department of Theatre with a forum for community, ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Graduate Women in Economics",
    "purposeStatement": "Building a support network for women undertaking graduate studies in economics so that we may better identify and fight against gender bias ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Graduate Women In Science – Central Ohio",
    "purposeStatement": "GWIS aims to promote women’s voices, empower women in society at all levels of their professional development, and provide a space for women...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Graduating Class Gift Council",
    "purposeStatement": "Through the Graduating Class Gift, we strive to turn students’ affinity for Ohio State into philanthropy and establish their lifelong, phila...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Greek Cru Student Ministry",
    "purposeStatement": "GreekCru is a Christian student organization focused on being a resource for Greek Life to encourage and facilitate genuine community and co...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Greek Programming Board",
    "purposeStatement": "The Greek Programming Board is a board comprised of representatives from all four governing councils: Interfraternity Council (IFC), Multicu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Governance Organizations"
    ]
  },
  {
    "name": "GreekSide of The Navigators",
    "purposeStatement": "The purpose of GreekSide is to help university students develop a Christian worldview by: 1) networking students to create opportunities to ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Group for Attitudes and Persuasion",
    "purposeStatement": "The Group for Attitudes and Persuasion seeks to foster intellectual and scholarly discussion among those interested in better understanding ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "The Grove - A Creative Writing Community",
    "purposeStatement": "The Grove provides an environment for creative writers to participate in the presentation and discussion of individual writing projects, enc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Growth International Volunteer Excursion",
    "purposeStatement": "GIVE's mission is to inspire growth, empower global citizens, and ignite sustainable change worldwide. Ohio State GIVE is one chapter of man...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Guiding Eyes for the Blind at The Ohio State University",
    "purposeStatement": "Providing independence for men and woman who are blind or visually impaired.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Gujarati Student Association",
    "purposeStatement": "We have noticed that there is not a place for Gujarati students to experience their unique culture and get to know other 'Gujus' and decided...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Guy Talk at The Ohio State University",
    "purposeStatement": "We exist to help students at OSU to get the resources they need to help with their mental health. While focusing on men and trying to fight ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Gymnastics - Women's and Men's - Sport Club",
    "purposeStatement": "The main focus of our club is to have fun with the sport of gymnastics. We welcome people of all skill levels from gymnasts with a lifetime ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "H2O Students",
    "purposeStatement": "H2O Students seeks to help OSU students become fully devoted disciples of Jesus Christ. We pursue this goal in affiliation and cooperation w...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Habitat for Humanity Campus Chapter at The Ohio State University",
    "purposeStatement": "Habitat for Humanity Campus Chapter at The Ohio State University works to reduce substandard housing by connecting OSU students to opportuni...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Half-Asian People's Association",
    "purposeStatement": "The purpose of HAPA is to provide a space where students of partial Asian or Pacific Islander descent can meet other OSU students with simil...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Hands-Only CPR Internship at the Ohio State University Wexner Medical Center",
    "purposeStatement": "The Hands-Only CPR Internship at the Ohio State University Wexner Medical Center aims to educate the Ohio State, Columbus, and other communi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "The Happiest Club on Campus: A Disney Themed Club",
    "purposeStatement": "We hope to provide a fun environment for students to relax and enjoy all things Disney! This environment is created with the hopes that stud...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts",
      "Technology"
    ]
  },
  {
    "name": "The Happiness Campaign",
    "purposeStatement": "To leverage our unique month-long campaigns to encourage healthy habits and foster wellness within the OSU community.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Happy Hearts Club",
    "purposeStatement": "Our purpose is to match Ohio State Students with individuals who have special healthcare needs, primarily autism, developmental disabilities...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Happy Hour Club",
    "purposeStatement": "To uphold the tradition of student camaraderie with one another and the Ohio Union in the Wayne Woodrow \"Woody\" Hayes Tavern",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Special Interest"
    ]
  },
  {
    "name": "HARVEST",
    "purposeStatement": "HARVEST works to provide aid to low-income and developing communities around the world to allow for economic growth and prosperity for futur...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Health Advocates for Volunteering, Education, and Networking",
    "purposeStatement": "HAVEN's purpose is to serve as a bridge between the academic aspirations of pre-health students and the real-world healthcare, biotechnology...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Health Education And Development Services for Underprivileged Populations",
    "purposeStatement": "The Health Education Activities and Development Services for the Underprivileged Population (HEADS-UP) works with local non profits and publ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Health Information Management and Systems Organization",
    "purposeStatement": "We seek to provide a meeting ground for both HIMS and pre-HIMS students, while arranging for opportunities to pursue fundraising and communi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Health Law Society",
    "purposeStatement": "The purpose of the Health Law Society is to provide an educational, informational, social and networking resource for students interested in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Health Points: Pre-Health Connections & Volunteering",
    "purposeStatement": "To provide the means for Ohio State Undergraduate pre-health students connect to their passions through faculty, practitioners, fellowship a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Health Sciences Club",
    "purposeStatement": "The Health Sciences Club is designed to inform students about the Health Sciences Program and help undergraduate students become aware of th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Healthy Minds",
    "purposeStatement": "On the path to learning about how to live a good life. True to our motto, we have weekly social activities such as skateboarding around metr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Her Campus at The Ohio State University",
    "purposeStatement": "Her Campus at OSU, a branch of HerCampus.com, is an online magazine for the college women of Ohio State with features on Campus Life, Cultur...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Higher Education Student Personnel Association",
    "purposeStatement": "The Higher Education and Student Personnel Association serves as a bridge for the members of the HESA community. We strive to build communit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Hillel Marketing Group",
    "purposeStatement": "The purpose of the Hillel Marketing Group is to discuss and learn how to better market, advertise and promote religious and cultural events.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Hillel Student Board of Trustees",
    "purposeStatement": "The Student Board of Trustees at Hillel is a group of leaders around campus who are highly involved in the hillel community. They are self-n...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Hindi Club at Ohio State",
    "purposeStatement": "Hindi Club promotes the use of Hindi language in social contexts. The members of the club engage in cultural and social activities specific ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Hindu Youth for Unity, Virtues and Action",
    "purposeStatement": "The purpose of the organization shall be to bring awareness about Hindu Culture, Principles, and Values to The Ohio State University (OSU) c...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Hip-hop Club",
    "purposeStatement": "Hip-Hop Club is established for the purpose of allowing all Ohio State students to exercise their love for such genre of music. In this club...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Special Interest",
      "Community Service/Service Learning",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "History of Art Graduate Student Association",
    "purposeStatement": "Our mission is to provide self-governance by the graduate students of the Department of the History of Art at OSU.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "History of Art Undergraduate Society",
    "purposeStatement": "The History of Art Undergraduate Society seeks to provide a scholastic and social forum for students studying the history of art, arts manag...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Ho'ike O Hawai'i",
    "purposeStatement": "Ho'ike O Hawai'i serves to promote fellowship among students from Hawai'i and students interested in the culture of Hawai'i at Ohio State. W...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Holocaust Awareness Council",
    "purposeStatement": "Members of the HAC seek to educate the campus and Columbus community about the horrors of the Holocaust during WWII and other genocide atroc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Hong Kong Student Association",
    "purposeStatement": "Our goal is to establish a community among the students who share Cantonese heritage here at the Ohio State University and to help new Hong ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Horticulture and Crop Science Graduate Student Association",
    "purposeStatement": "The purpose of the Horticulture and Crop Science Graduate Student Association (HCS-GSA) is as follows: 1) to provide opportunities for meani...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Hospitality and Retail Management Graduate Student Association at The Ohio State University",
    "purposeStatement": "The Hospitality and Retail Management Graduate Student Association’s mission is to gather graduate, Ph.D. and Masters students in the Hospit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Hospitality Management Association",
    "purposeStatement": "The purpose of the Hospitality Management Association is to foster professional standards, promote close relationships between students and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Houston-Houck/Taylor Community Council",
    "purposeStatement": "The purpose of this organization shall be to promote participation in a democratic self-government and to create a residence hall environmen...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Human Development and Family Science Club",
    "purposeStatement": "HDFS club is dedicated to Helping new students get accustomed to the major or minor, department, and the college of education and human ecol...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Human Development and Family Science Graduate Student Organization",
    "purposeStatement": "The Human Development and Family Science Graduate Student Organization (HDFS-GSO) intends to bring graduate students together and enhance th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Human Factors and Ergonomics Society Student Chapter",
    "purposeStatement": "Human Factors and related fields aim to advance the design and development of complex systems for integration with human practitioners to ma...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Human Resources Association",
    "purposeStatement": "The Human Resources Association is dedicated to promoting the Human Resources profession and teaching fellow students its importance in ever...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Human-Animal Interactions Club",
    "purposeStatement": "The purpose of this club shall be to enlighten people (students of The Ohio State University) about the complex and varying relationships th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Humanism in Medicine",
    "purposeStatement": "Humanism in Medicine is a group of pre-health undergraduates aiming to fulfill our goal of sharpening patient-focused interpersonal and prof...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Humanity First Student Chapter",
    "purposeStatement": "The primary purpose of the Humanity First Student Organization at Ohio State is to advocate for human life by means of undertaking disaster ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "I Can Medical Mentorship",
    "purposeStatement": "An organization, partnered with Champion Middle School, a predominantly underrepresented minority, Columbus public school and Columbus City ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Ice Hockey - Women's - Sport Club",
    "purposeStatement": "The purpose of the Women’s Ice Hockey Club is as follows: (1) to promote women’s ice hockey at a competitive level; (2) to provide opportuni...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "IEEE Graduate Student Body at The Ohio State University",
    "purposeStatement": "We, the IEEE graduate student members at the Ohio State University, in order to advance the state-of-the-art of technology in our field of c...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "IEEE Undergraduate Chapter at The Ohio State University",
    "purposeStatement": "To advance global prosperity by fostering technological innovation, enabling members' careers and promoting community world-wide.  As the Oh...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "The IMA Student Chapter at The Ohio State University",
    "purposeStatement": "To assist students in studying and preparing for the CMA exam.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Immigration Law Society",
    "purposeStatement": "The Immigration Law Society is a student organization dedicated to the practice of immigration law.  Specifically, we seek to promote awaren...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Immunology Interest Group",
    "purposeStatement": "Increase student appreciation for the role of the immune system in human disease etiology and treatment. Expose interested medical students ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Imperialized Health",
    "purposeStatement": "Imperialized Health aims to learn about imperialism and colonialism, and how it has deliberately demolished public health conditions around ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Inaayat Dance Team",
    "purposeStatement": "Founded in 2016, OSU Inaayat is a premier Indian classical dance team at the Ohio State University. Inaayat, meaning grace in Hindi, strives...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Inclusion, Science, Technology, Engineering, and Mathematics Education Graduate Students",
    "purposeStatement": "STEMERs-OSU is dedicated to improving the teaching and learning of science, technology, engineering, and mathematics education through the f...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Indian Students Association",
    "purposeStatement": "ISA is a voluntary, non-profit organization with a goal of being the primary gateway that connects the Indian community at OSU. It also aims...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Indie Game Buckeyes",
    "purposeStatement": "Indie Game Buckeyes aim to provide a safe space for gamers of all kind to play, discover, and talk about hit or up-and-coming indie games to...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Indonesian Student Association",
    "purposeStatement": "The purpose shall be to develop and improve the sense of unity among the members and to promote Indonesia as a whole.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Creative and Performing Arts",
      "Governance Organizations",
      "Special Interest"
    ]
  },
  {
    "name": "Industrial Design Society of America Student Chapter",
    "purposeStatement": "The Industrial Design students at The Ohio State University have revitalized the OSU Student Chapter of the Industrial Design Society of Ame...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Industry Pharmacists Organization at The Ohio State University",
    "purposeStatement": "IPhO Student Chapters are dedicated to enhancing student pharmacists’ understanding of the pharmaceutical industry by:  \tRaising awareness o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Infectious Diseases Institute Trainee Association",
    "purposeStatement": "IDI-TA seeks to expand the interdisciplinary and diverse membership of, and advocate for, trainees within The Ohio State University Infectio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Infectious Diseases Student Interest Group",
    "purposeStatement": "The Infectious Diseases Student Interest Group (IDSIG) is a student-led interest group for College of Medicine students interested in Infect...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "INFORMS at The Ohio State University",
    "purposeStatement": "Forge intellectual connections with faculty and professionals that lead to publications, job opportunities, consulting relationships, intern...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Ingress Chinese Student Investment",
    "purposeStatement": "To provide non-business Chinese students the most fundamental knowledge about stock market investment, financial institutions' roles, and ma...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Social Fraternities/Sororities",
      "Academic/College"
    ]
  },
  {
    "name": "Inorganic Chemistry Exchange",
    "purposeStatement": "The purpose of this organization is to facilitate intellectual exchange between students of The Ohio State University, particularly those in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Inspiration Club at Ohio State",
    "purposeStatement": "An organization focused on educating and growing the cardiopulmonary care in the clinical world through service learning and collaboration.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Institute for Population Research Graduate Student Organization",
    "purposeStatement": "The Institute for Population Research Graduate Student Organization (IPRGSO) has three main goals: 1) To become an interdisciplinary group d...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Institute of Industrial & Systems Engineers",
    "purposeStatement": "To be the premier Industrial Engineering student organization committed to developing professional, academic, and social networks that openl...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Technology"
    ]
  },
  {
    "name": "Integrated Business and Engineering Honors Program",
    "purposeStatement": "The IBE Program teaches technical skills and problem solving through an interdisciplinary approach while emphasizing creativity, innovation,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "Intellectual Property Law Society",
    "purposeStatement": "It shall be the purpose of IPLS  to establish a forum for legal education and discussion that are pertinent to the field of cyber, intellect...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Inter-Professional Council",
    "purposeStatement": "We, the Inter-Professional Council being those professional students of The Ohio State University elected and appointed by our peers, with o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Interdisciplinary Graduate Film Studies Group at The Ohio State University",
    "purposeStatement": "In response to the needs of graduate students of various disciplines interested in film studies, the Ohio State University Interdisciplinary...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Interfraternity Council at Ohio State",
    "purposeStatement": "The role of the Interfraternity Council (IFC) is to govern the university affiliated social fraternities for male identified individuals at ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "The Intergalactic Science Fiction Club",
    "purposeStatement": "To gather every week to watch, discuss, and have fun with favorite movies, shows, and literary works of the Science Fiction genre. This is a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Special Interest"
    ]
  },
  {
    "name": "Internal Martial Arts and Sports Performance",
    "purposeStatement": "Teaching students seeking improvement in generating force applicable to various sporting activities a \"how to\" method via Internal Martial A...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Internal Medicine Interest Group",
    "purposeStatement": "The purposes of this organization shall be to obtain information about careers in internal medicine, promote communication among members and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Internal Medicine Ultrasound Community of Practice",
    "purposeStatement": "The Internal Medicine Community of Practice will explore applications of bedside focused ultrasound within Internal Medicine. The COP meets ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "International Business Club",
    "purposeStatement": "The International Business Club is designed to be a fun and informative group that prepares students to succeed in the global business envir...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "International City/County Management Association Student Chapter",
    "purposeStatement": "The purpose of the student chapter is to: i.\tIntroduce and integrate students to the local government management profession.  ii.\tFamiliariz...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "International Dental Service Association",
    "purposeStatement": "International Dental Service Association is a  student-run organization that plans service trips to countries outside the United States to f...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "International Exercise Association",
    "purposeStatement": "Exercise is crucial for both physical and mental health for all students particularly during academic year. One way to cope with stress is b...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "International Friendships",
    "purposeStatement": "International Friendships exists to provide friendship and hospitality for international students, scholars, and family members during their...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "International Genetically Engineered Machine Competition at The Ohio State University",
    "purposeStatement": "iGEM at the Ohio State University works throughout the year to design and realize a bioengineered organism with real-life applications in he...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "International Justice Mission at The Ohio State University",
    "purposeStatement": "IJM at The Ohio State University works to fight against injustice and oppression in the world in the following ways: praying for the IJM sta...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "International Power Volleyball Club",
    "purposeStatement": "We are dedicated to providing international students with a positive environment to enjoy and compete in the game of volleyball. We are comm...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "International Social Work Support Network",
    "purposeStatement": "The mission of ISWSN is to contribute to developing a global vision and comprehensive plan to internationalize the College’s activities, wit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "International Society of Muslim Women in Science at Ohio State",
    "purposeStatement": "The objectives of the organization will be to support, encourage, help, and strengthen the confidence of Muslim women in the field of scienc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Religious/Spiritual",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "International Students Community Service",
    "purposeStatement": "Unite international students through a passion for community service while giving back to the Ohio State and Columbus communities.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "International Tea Culture Club",
    "purposeStatement": "The goal of the International Tea Culture Club is to provide a space for students (and other individuals) to discuss the cultural, philosoph...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "International Veterinary Student Association",
    "purposeStatement": "The mission of IVSA is to benefit the animals and people of the world by harnessing the potential and dedication of veterinary students to p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Intersections",
    "purposeStatement": "Intersections is a graduate student organization based in the Department of Women's, Gender and Sexuality Studies. Its purpose is to foster ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Interventional Radiology Interest Group",
    "purposeStatement": "The Interventional Radiology Interest Group serves to educate medical students about the field of Interventional Radiology. By putting on va...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies",
      "Special Interest"
    ]
  },
  {
    "name": "Iranian Student Union",
    "purposeStatement": "The mission of the Iranian Student Union (ISU) at OSU is to establish a vibrant and supportive community for Iranian and non-Iranian student...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Iraqi Student Association",
    "purposeStatement": "The Iraqi Student Association seeks to represent the Iraqi student community in The Ohio State University; to promote and share our rich Ira...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "The Irish Dance Team at The Ohio State University",
    "purposeStatement": "The Irish Dance Team at The Ohio State University is a club meant to serve students with a prior knowledge or training in Irish Dance. We co...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "ISKCON Yoga Circle",
    "purposeStatement": "What you eat is what you become! We associate to explore a part of the widely practiced and most vibrant culture of Bhakti-yoga (called Kris...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Ethnic/Cultural",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Italian Dental Association",
    "purposeStatement": "The purpose of the Italian Dental Association is to foster a supportive and enriching environment for dental students and professionals of I...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "J2K",
    "purposeStatement": "J2K is a student dance organization open to individuals of all skill levels that primarily dances to Korean, Chinese, and Japanese pop music...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Jacob's Porch's Students",
    "purposeStatement": "Jacob's Porch is a multifaceted, multi-denominational, collaborative Christian community for college students. We are queer aligned, justice...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Japanese Graduate Studies Association at The Ohio State University",
    "purposeStatement": "We aim to provide a place for academic discussion and support for graduate-level scholars studying topics related to Japanese studies. This ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Japanese Music Club",
    "purposeStatement": "Our organization creates a space in The Ohio State University that both appreciates and promotes Japanese music. As students who are interes...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Japanese Student Organization",
    "purposeStatement": "The mission of the Japanese Student Organization is to host a variety of events where students and the local community can enjoy and learn a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Jazz Club at Ohio State",
    "purposeStatement": "The Jazz Club at Ohio State serves the greater Columbus community by achieving three goals. The first initiative is to spread awareness and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Jazz Saxophone Club",
    "purposeStatement": "To further development of jazz saxophonists at Ohio State, and provide access to world-renowned musicians and clinicians to further pedagogy...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Jesus Power NextGen Fellowship",
    "purposeStatement": "We envision now and in the future to develop matured and committed followers of Christ of both the churched and unchurched college students....",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Jewish Business Student Association",
    "purposeStatement": "JBSA strives to create numerous networking opportunities as well as have learning sessions to maximize the professional development of its m...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Jewish Law Students Association",
    "purposeStatement": "The Jewish Law Student Association (JLSA) seeks to facilitate an active and engaged Jewish community at Moritz through educational, cultural...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Jewish Medical Students Association",
    "purposeStatement": "The purpose of Jewish Medical Student Association (JMSA) is to facilitate an active and engaged Jewish community at the College of Medicine ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Jewish Women's Collective",
    "purposeStatement": "JWC seeks to connect OSU women with women in the community of all backgrounds and experiences to share goals, learn life skills, and underst...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Jews for Justice in Palestine",
    "purposeStatement": "JJP opposes anti-Jewish, anti-Muslim, and anti-Arab bigotry and oppression. JJP seeks an end to the Israeli occupation of the West Bank, Gaz...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Jews on Campus",
    "purposeStatement": "Jews on Campus reaches out to students in residence halls and primarily first-year students by introducing them to Jewish life - cultural, s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Jigsaw Club",
    "purposeStatement": "To provide a relaxing environment for students to work on jigsaw puzzles. Student life can be stressful and Jigsaw Club wants to help by cre...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Jiu Jitsu - Sport Club",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "John Glenn Civic Leadership Council",
    "purposeStatement": "The mission of the John Glenn Civic Leadership Council is to increase amongst students, faculty, staff, and others at The Ohio State Univers...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "John Glenn College of Public Affairs Student Association",
    "purposeStatement": "The John Glenn College of Public Affairs Student Association's purpose is to act as the official liaison between students, faculty, and staf...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Joint Safety Team",
    "purposeStatement": "The purpose of this organization is to promote awareness and improve laboratory safety and chemical hygiene in the Department of Chemistry a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Jordanian Student Organization",
    "purposeStatement": "The purpose of JSO at OSU is to preserve and expand a network of students and faculty, as well as to provide an atmosphere where Jordanian a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Journal of Politics & International Affairs",
    "purposeStatement": "To provide undergraduate students the opportunity to present their research to a broader audience.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College"
    ]
  },
  {
    "name": "The Journal of Undergraduate Research at Ohio State (JUROS) Editorial Board",
    "purposeStatement": "The purpose of the JUROS Editorial Board is to organize and promote The Journal of Undergraduate Research at Ohio State. The JUROS Editorial...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Judo - Sport Club",
    "purposeStatement": "The Mission of The Ohio State University Judo Club is to manage, serve, and promote the Sport of Judo in the Columbus, OH area, at all level...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "The Juggling Club at The Ohio State University",
    "purposeStatement": "To provide a forum for the exchange of juggling and related object manipulation knowledge.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Juice Undergraduate Society",
    "purposeStatement": "Our mission is to cultivate a diverse community of students who share a passion for exploring and appreciating different varieties of juice....",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Jump Rope Club at The Ohio State University - Sport Club",
    "purposeStatement": "The Jump Rope Club at The Ohio State University is a club that aims to share the sport of jump rope, promote physical fitness and bring stud...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Kannada Sangha",
    "purposeStatement": "Kannada Sangha actively works towards the preservation, promotion, and celebration of Kannadiga heritage and history. In Kannada Sangha, we ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Kappa Alpha Order",
    "purposeStatement": "Inspired by our foundational principles of Reverence, Gentility, Knowledge, Leadership, Brotherhood, and Excellence, Kappa Alpha Order seeks...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Kappa Alpha Psi Fraternity Inc.",
    "purposeStatement": "Honorable Achievement In Every Field of Human Endeavor.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Kappa Alpha Theta",
    "purposeStatement": "Yesterday, today, and tomorrow, Kappa Alpha Theta exists to nurture each member throughout her college and alumnae experience and to offer a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Kappa Delta",
    "purposeStatement": "The purpose of Kappa Delta Sorority is to promote true friendship among the college girls of our country by inculcating into their hearts an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Kappa Delta Rho",
    "purposeStatement": "Greek organization fostering the hearts of men by taking advantage of higher education through scholarship, service, philanthropy, brotherho...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Kappa Kappa Gamma Sorority",
    "purposeStatement": "To unite its members in a close bond of friendship seeking, to instill in them a spirit of mutual love and helpfullness, to the end that eac...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Kappa Kappa Psi",
    "purposeStatement": "Kappa Kappa Psi is an honorary service organization whose purposes includes serving college and university band programs through service pro...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Kappa Phi Kappa",
    "purposeStatement": "Kappa Phi Kappa exists to help unite current and future teachers and those interested in the field of education under the same principles an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Kappa Phi Lambda Sorority, Inc.",
    "purposeStatement": "We, the sisters of Kappa Phi Lambda Sorority, Incorporated, strive to strengthen Sisterhood amongst women by providing service and promoting...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Kappa Psi Pharmaceutical Fraternity, Inc.",
    "purposeStatement": "The objectives are to conduct a fraternal organization for the mutual benefit of the member; to advance the profession of Pharmacy education...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Social Fraternities/Sororities",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Karate Club at The Ohio State University - Sport Club",
    "purposeStatement": "Our club serves to teach interested community members - students, faculty members, and alumni - the skills and values of the traditional mar...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Karatedo Doshinkan at Ohio State",
    "purposeStatement": "At the Ohio State University Karatedo Doshinkan, we are committed to preserving and promoting Karatedo's profound legacy and teachings, a ma...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Kayak Club at The Ohio State University",
    "purposeStatement": "The purpose of the OSU Kayak Club is to provide students, experienced and inexperienced, with an opportunity to learn more about kayaking as...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Kedma",
    "purposeStatement": "To promote and foster community building and relationships amongst traditional Jewish students and the entire OSU campus community.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Kendo Club",
    "purposeStatement": "Kendo Club exists to allow students and members of the community to gather and participate in one of Japan's oldest martial arts - the way o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Kensho: Asian Philosophy Reading Group",
    "purposeStatement": "The purpose of the Kensho: Asian Philosophy Reading Group is to create a forum for dialogue amongst advanced undergraduate and graduate stud...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Khabar",
    "purposeStatement": "Khabar believes in self-sustaining communities who take leadership to challenge social injustices, and actively raise their voices against b...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Kinesiology Graduate Student Council",
    "purposeStatement": "The purpose of the KGSC is to cultivate an interdisciplinary community dedicated to promoting personal, professional growth and enhancing so...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Knitting and Crafting Club",
    "purposeStatement": "A group of individuals from different backgrounds who come together as friends to talk, laugh, and craft. We teach students to create with f...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Know Food Waste",
    "purposeStatement": "The KNOW: Educate the The Ohio State University community on food waste. To provide the community with the “know-hows” for reducing and re-p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Knowlton Conservation Corps",
    "purposeStatement": "The Knowlton Conservation Corps is a student organization at The Ohio State University that aims to leave a legacy of maintaining the roofto...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Knowlton Nomads",
    "purposeStatement": "Knowlton Nomads’s purpose is to enrich the (under)graduate classroom experience by using cities around the U.S. (including Columbus) as mode...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Knowlton Society",
    "purposeStatement": "The Knowlton Society’s mission is to thoughtfully engage with the student body, faculty, staff, administration, and relevant stakeholders of...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Korean Graduate Student Association",
    "purposeStatement": "The Korean Graduate Student Association (KGSA) has three main purposes. The first purpose is to assist with the US visa process and settleme...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Korean International Student Organization",
    "purposeStatement": "Main purpose of KISO is to help Korean international students adapt to overall student life at the Ohio State University. This organization ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Korean Student Association",
    "purposeStatement": "The purpose of the Korean Student Association is to promote the education and enrichment of its members and the university community with as...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Kuwaiti Students Cultural Organization",
    "purposeStatement": "The purpose of the Kuwaiti Students Cultural Organization at The Ohio State University is to provide a welcoming and inclusive community for...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Labor and Employment Law Association",
    "purposeStatement": "LELA fosters a greater understanding of the practice of labor and employment law. Moritz students have an opportunity to learn about the lat...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Lacrosse - Men's - Sport Club",
    "purposeStatement": "The Ohio State Men's Club Lacrosse team is a competitive non-varsity club team committed to providing its members with the opportunity to pa...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Lacrosse - Women's - Sport Club",
    "purposeStatement": "Our purpose is to practice and play to the best of our ability and successfully compete at the national level while also building and mainta...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Academic/College"
    ]
  },
  {
    "name": "Lambda Phi Epsilon International Fraternity, Inc.",
    "purposeStatement": "As leaders of Lambda Phi Epsilon, we advocate for the empowerment of men from all backgrounds and identities, within and outside, of the Asi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Lambda Psi Minority Engineering Honorary",
    "purposeStatement": "Lambda Psi Minority Engineering Honorary is an undergraduate honorary which targets underrepresented minorities within the College of Engine...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "Lambda Theta Alpha Latin Sorority, Incorporated",
    "purposeStatement": "Our ultimate goal is to advocate for the empowerment of Latina women and further their growth personally, academically, and professionally. ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Landacre Honor Society",
    "purposeStatement": "The Landacre Honor Society promotes excellence in medicine through academic achievement and the pursuit of scientific research.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College"
    ]
  },
  {
    "name": "Language or Logic Society",
    "purposeStatement": "The purpose of Logic Or Language Society is to create a forum for dialogue amongst graduate students on the subject of philosophy of logic a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Latine Educational Empowerment at The Ohio State University",
    "purposeStatement": "Latine Educational Empowerment seeks to inform middle and high school Latino students (in regions of Ohio that don’t receive many educationa...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Latine Student Association",
    "purposeStatement": "The Latine Student Association at The Ohio State University is dedicated to celebrating the Latine culture as well as fostering and bringing...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Latino Law Students Association",
    "purposeStatement": "The Latino Law Students Association (LLSA) is an organization dedicated to preparing its members for their professional roles in society and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Latino Medical Student Association at The Ohio State University College of Medicine",
    "purposeStatement": "LMSA @ OSUCOM, is a network of students, alumni, and health professionals whose mission is to promote the development of Latino students thr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Latinx in Vet Med",
    "purposeStatement": "By holding general body meetings and cultural events and by collaborating with other student groups, Latinx in Vet Med hopes to strengthen a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Leadership of Environmental Athletes for Sustainability",
    "purposeStatement": "The Leadership of Environmental Athletes for Sustainability (LEAFS) cohort is a platform that provides opportunities for student-athletes wh...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Leading in Global Health Together",
    "purposeStatement": "The purpose of Leading in Global Health Together (LIGHT) is to promote global health awareness and education among the Ohio State community ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism"
    ]
  },
  {
    "name": "Leighton Undergraduate Philosophy Club",
    "purposeStatement": "To provide a forum for students to discuss philosophical questions with and to hear new philosophical thoughts from professors, grad student...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Letters of Love",
    "purposeStatement": "Letters of Love is committed to spreading positivity and emotional support to children battling cancer and other serious illnesses through h...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Leukemia & Lymphoma Society Club",
    "purposeStatement": "\"This club hopes to bring together a community of Ohio State students in order to create and participate in fundraising and social opportuni...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Lighthouse",
    "purposeStatement": "Lighthouse serves as a home for a close-knit community of Christians who desire to strengthen their relationship with God and to follow Him ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Line Dancing",
    "purposeStatement": "Introduce line dancing to students and faculty at Ohio State and provide enjoyment and entertainment as well as a place to socially connect.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Links Club",
    "purposeStatement": "The Links Club seeks to bring together golfers of all backgrounds and skill levels for recreational and networking purposes.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Little Gay Book Club",
    "purposeStatement": "Our purpose is to provide a safe environment for any and all marginalized groups to congregate and discuss queer literature, while providing...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Living Art and Ecology Club",
    "purposeStatement": "It is the Living Art & Ecology club’s mission to provide a space on campus for students interested in the interdisciplinary work involving a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Creative and Performing Arts",
      "Sports and Recreation"
    ]
  },
  {
    "name": "LivingSport",
    "purposeStatement": "LivingSport is the beginning guide to LiFEsports. Our work will impact the lives of those who need it most. We strive to address the broader...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Sports and Recreation"
    ]
  },
  {
    "name": "The Logistics Association",
    "purposeStatement": "The Logistics Association is a not-for-profit professional organization which provides:   leadership in developing, defining, and understand...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "The Longboarding Club",
    "purposeStatement": "The Longboarding Club seeks to establish a network among The Ohio State University's longboarding community and to progress the skill levels...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Lotus Sangha",
    "purposeStatement": "Lotus Sangha is a student organization dedicated to practicing, learning, and spreading the teachings of Tibetan Buddhism. As an organizatio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "LovetheNations",
    "purposeStatement": "Mission: To Love OSU by encouraging a culture of prayer, supporting a tangible space to pray.  Our vision is a campus transformed. We want t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Low Vision Rehabilitation Club",
    "purposeStatement": "The purpose of this organization is to provide information to future optometrists so that each member of the Low Vision Rehabilitation Club ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Lutheran Church Missouri Synod University",
    "purposeStatement": "The Purpose of LCMSU is to offer a confessional Lutheran community for the Lutheran students, faculty, and staff of Ohio State University.  ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Special Interest"
    ]
  },
  {
    "name": "MAcc Association",
    "purposeStatement": "The purpose of the MAcc Association is to improve the student experience of everyone currently enrolled in the Master of Accounting program....",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Mad Royal Film Society",
    "purposeStatement": "We are a film/video production organization aiming to create a community that promotes creativity, collaboration, and inclusivity in an acce...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Magazines For Literacy",
    "purposeStatement": "There are over 18 million U.S. kids in poverty, including over a million homeless students. Two-thirds of children in poverty have ZERO book...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Magic the Gathering at The Ohio State University",
    "purposeStatement": "We strive to offer an environment on campus where students with an interest in the card game Magic: the Gathering can come and meet others w...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Magical Moments Foundation, a Chapter at the Ohio State University",
    "purposeStatement": "We strive to promote inclusivity, educate our community about children with facial differences, and create meaningful professional developme...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The Main Menu Project",
    "purposeStatement": "The Main Menu Project is dedicated to making our community more accessible for individuals who are visually impaired.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Majors & minors",
    "purposeStatement": "To provide musical entertainment to the Ohio State and Columbus communities and offer a fun and creative outlet to any and all students acro...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Malayalee Society",
    "purposeStatement": "The organization's purpose is to unite individuals from various backgrounds to educate and celebrate Malayalee and Keralite cultures",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Malaysian Students Association",
    "purposeStatement": "The Malaysian Students Association aims to represent the Malaysian student community in The Ohio State University; To promote Malaysia's uni...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College"
    ]
  },
  {
    "name": "Manga Student Association",
    "purposeStatement": "Dedicated to fostering interest and knowledge of the Japanese art form known as manga, this organization will seek to provide for individual...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Manna",
    "purposeStatement": "Manna is the Asian-American campus ministry branch of the Columbus Chinese Christian Church, striving to understand the Word of God in order...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "MannMukti at The Ohio State University",
    "purposeStatement": "Our mission is to encourage healthy, open dialogue of South Asian mental health issues in an effort to remove stigma, improve awareness and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "March of Dimes at Ohio State",
    "purposeStatement": "Premature birth (birth before 37 weeks of pregnancy) and its complications are the #1 cause of death of babies in the United States. Our mis...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Materials Science and Engineering Club",
    "purposeStatement": "The Materials Science and Engineering Club (MSE Club) is dedicated to promoting Materials Science to interested students in the College of E...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Mathematics Graduate Student Association",
    "purposeStatement": "The purpose of the MGSA is to provide graduate students in the Department of Mathematics the opportunity to interact with each other and pre...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "MD Camp at The Ohio State University",
    "purposeStatement": "M.D. Camp aims at increasing the number of physicians who are underrepresented in medicine and who elect to practice in underserved areas. T...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College"
    ]
  },
  {
    "name": "Meat Science Club",
    "purposeStatement": "To promote the meat industry through educational and industrial experiences by means of interaction with professors, leaders of the industry...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Mechanical, Aerospace, and Nuclear Engineering Graduate Student Association",
    "purposeStatement": "Our mission is to create a group that advises, assists, supports, and socially involves graduate students in the Department of Mechanical En...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Technology"
    ]
  },
  {
    "name": "Med Students for Life",
    "purposeStatement": "We provide a forum for pro-life medical students to express their views on abortion, euthanasia, physician-assisted suicide, etc., and seek ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Med-Peds Interest Group",
    "purposeStatement": "Our purpose is to provide medical students the opportunity to learn more about the Internal Medicine-Pediatrics career option and get them i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "MedConnect Alliance",
    "purposeStatement": "The purpose of MedConnect Alliance is to bridge healthcare disparities by facilitating the equitable distribution of medical supplies to und...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Medical Innovations",
    "purposeStatement": "This club allows students of all disciplines join or create projects to benefit medicine or healthcare in some way and pursue it with the in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Medical Outreach at The Ohio State University",
    "purposeStatement": "Our mission is to collaborate with local patient-centered organizations and build a dedicated volunteer network to support clinical endeavor...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Medical Scientist Student Organization",
    "purposeStatement": "The MSSO is a student founded and student led organization that acts as the primary liaison to the Medical Scientist Program at the Ohio Sta...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Medical Student Transplant Education Program and Interest Group",
    "purposeStatement": "The purpose of this organization is to facilitate preventative healthcare education for kidney, pancreas, and liver transplant patients. Eve...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Medical Students Advocating for Mental Health",
    "purposeStatement": "Medical Students Advocating for Mental Health strives to end the stigma against mental health, especially in the medical community.  This or...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Medicine, Education, and Development for Low Income Families Everywhere",
    "purposeStatement": "Our mission is to help families achieve greater freedom from the constraints of poverty, empowering them to live healthier lives. Our patien...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Medieval and Renaissance Graduate Student Association",
    "purposeStatement": "Graduate students in a number of departments have formed an association for those interested in Medieval and Renaissance fields. This associ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Medieval College of Saint Brutus",
    "purposeStatement": "To educate our members and others about the trades, skills, and professions of our medieval ancestors through hands on learning and reenactm...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Sports and Recreation"
    ]
  },
  {
    "name": "The Meditation Community",
    "purposeStatement": "The Meditation Community was created for students to have a safe place where they feel comfortable exploring meditation and so that they can...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Men's Club Ice Hockey at The Ohio State University - Sport Club",
    "purposeStatement": "We provide students the opportunity to continue to play ice hockey at a competitive level and be around other students with a similar passio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Men's Glee Club at Ohio State",
    "purposeStatement": "The Ohio State University Men’s Glee Club is an inclusive community committed to enhancing the lives of its singers by developing musiciansh...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Men's Health Club",
    "purposeStatement": "The purpose of the Men's Health Club will be to focus on all aspects of Men's Health, which includes but is not limited to: physical, mental...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Men's Powerlifting Club at The Ohio State University",
    "purposeStatement": "The purpose of the Ohio State University Men's Powerlifting Club is to provide the ability for male students to become as strong as physical...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Men's Soccer - Sport Club",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Mendoza-Norton-Scott & Blackburn-Haverfield Community Council",
    "purposeStatement": "The purpose of BHAMNS Community Council is to provide for the social, recreational, informational, educational, diversity, wellness and comm...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Special Interest"
    ]
  },
  {
    "name": "Mental Health Matters",
    "purposeStatement": "Our mission is to #EndTheStigma surrounding mental health through our pillars of awareness, education, and celebration to facilitate an envi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Mentor ME at The Ohio State University College of Medicine",
    "purposeStatement": "To provide longitudinal support, advice, and exposure to underrepresented high school students interested in medical careers through medical...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Meteorology Club at The Ohio State University",
    "purposeStatement": "The purpose of the Meteorology Club is to create enthusiasm for the various fields in meteorology through meetings and seminars held through...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Mexican Student Association",
    "purposeStatement": "The Mexican Student Association (MXSA) aims to educate, celebrate, and embrace Mexican culture in the broader OSU community. MXSA is designe...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Microbial Infection and Immunity Graduate Student Society",
    "purposeStatement": "MIIGSS strives to promote excellence in graduate research within the OSUCOM Department of Microbial Infection and Immunity by facilitating c...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Middle Eastern Law Students Association",
    "purposeStatement": "The Middle Eastern Law Student Association at Moritz works with the primary goal of fostering an inclusive environment for students of Middl...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Midwestern Citizen at The Ohio State University",
    "purposeStatement": "Midwestern Citizen is a nonpartisan undergraduate opinion publication present at universities across the Midwest, the Great Plains, and adja...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College"
    ]
  },
  {
    "name": "Military and Veteran Students at The Moritz College of Law",
    "purposeStatement": "This organization provides opportunities within the Moritz College of Law for Military affiliated students to find support and and camarader...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Military Medicine Interest Group",
    "purposeStatement": "The purpose of MMIG is to provide support and information for medical students moving toward a career as a military physician in any branch,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Mindfulness Meditation Interest Group",
    "purposeStatement": "The purpose of the Mindfulness Meditation Interest Group is to provide an atmosphere conducive to furthering the practice and learning of mi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "MindVersity at Ohio State",
    "purposeStatement": "MindVersity is a new student organization that focuses on bridging the gap between access to mental health care and students of color on col...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Minecraft Club",
    "purposeStatement": "At Minecraft club we are focused on creating, building, and exploring in order to promote newly developed relationships, expand our knowledg...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Minorities and Philosophy",
    "purposeStatement": "MAP is an inclusive group, providing philosophy students (grad and undergrad) and faculty with the opportunity to discuss topics concerning ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Minorities in Agriculture, Natural Resources, and Related Sciences",
    "purposeStatement": "MANRRS is the premier worldwide organization, partnered with academia, governmental agencies and industry, dedicated to career, personal and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "The Minority Association of Pre-Medical Students",
    "purposeStatement": "Our purpose as a student organization at the Ohio State University is to foster focus, motivation, insight, and cultivate a service based at...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Minority Collegiate Outreach and Support Team",
    "purposeStatement": "MCOST--Collegiate minority mentorship that seeks to promote scholarship, self-advocacy, STEAM exploration, and college preparation in the mi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Minority Organization Representing Excellence",
    "purposeStatement": "M.O.R.E. hopes to provide an educational space for underrepresented students in the College of Arts & Sciences. As a student-run organizatio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Minority Students in STEM",
    "purposeStatement": "To encourage, promote and retain minority students in STEM fields by hosting one social event and one service event per month for STEM schol...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Minority Students Learning Signs",
    "purposeStatement": "MSLS is an opportunity for Black students and POC to grow their American Sign Language skills while networking with students that look like ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Minority Students Pursuing Dentistry",
    "purposeStatement": "Our purpose as a student organization at The Ohio State University is to create an environment for minority pre-dental students allowing the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Mirrors Sophomore Class Honorary",
    "purposeStatement": "Mirrors has been founded for the purpose of honoring those Sophomore Class members who have and will continue to excel in leadership, schola...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Miscellaneous Metaphysics Mind Epistemology",
    "purposeStatement": "The purpose of Miscellaneous Metaphysics Mind Epistemology is to create a forum for contemporary analytic dialogue about metaphysics, philos...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "The Mitre eCTF Club",
    "purposeStatement": "Our organization aims to provide a platform for Ohio State students to represent the university on a team for the Mitre Corporation's annual...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Mixed Heritage Buckeyes",
    "purposeStatement": "Our purpose is to provide a place for students of mixed heritage to gather and unite and cultivate dialogue to understand what it means to b...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Mock Trial at Ohio State",
    "purposeStatement": "The purpose of the Undergraduate student Mock Trial is to replicate all aspects of the legal process. Student will learn how to prepare witn...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "The Molecular Biophysics Student Organization",
    "purposeStatement": "The Molecular Biophysics Student Organization aims to promote collaboration based on the interdisciplinary nature of scientific backgrounds ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Molecular Genetics Club",
    "purposeStatement": "The Ohio State University Molecular Genetics Club provides undergraduate students majoring in the biological sciences or students with an in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Molecular Genetics Graduate Union",
    "purposeStatement": "The Molecular Genetics Graduate Union is dedicated to serve the professional and academic interests of graduate students through connection ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Molecular, Cellular and Developmental Biology Graduate Student Organization",
    "purposeStatement": "We the members of MCDB GSO hereby associate ourselves to: A. Provide for the members a voice in matters affecting them in the Molecular, Cel...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations"
    ]
  },
  {
    "name": "Moments of Action",
    "purposeStatement": "\"Moa\" means \"gather\" in Korean. It is also an abbreviation of \"Moments of Action\", which means emphasizing the importance of taking action i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Momentum Contemporary Ballet",
    "purposeStatement": "Momentum Contemporary Ballet makes ballet and contemporary dance more accessible and inclusive by offering weekly classes that enable all st...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Monopoly Deal Club",
    "purposeStatement": "Monopoly Deal Club provides students with an opportunity to engage and interact with others through the simple, yet strategic and entertaini...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Morgan’s Message",
    "purposeStatement": "Amplify stories, resources, and expertise to confront student-athlete mental health, build a community by and for athletes, and provide a pl...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Moritz College of Law Criminal Law Society",
    "purposeStatement": "The purpose of the Criminal Law Society is to provide law students at the Ohio State University Moritz College of Law with an apolitical for...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "The Moritz Conservatives",
    "purposeStatement": "The Moritz Conservatives provides a forum for discussion of a broad range of conservative ideals. We sponsor speaker events and academic eve...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Moritz Education Law Society",
    "purposeStatement": "The Education Law Society (ELS) is a space for the discussion and promotion of education amongst members of the Moritz College of Law commun...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Moritz Law Students for Justice in Palestine",
    "purposeStatement": "Stand in solidarity with, not on behalf of, the Palestinian people in their struggle against the colonial-apartheid Israeli regime; educate ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Morrison/Siebert Community Council",
    "purposeStatement": "The residents of Morrison Tower & Siebert Hall hereby associate into an organization called the Morrison and Siebert Community Council (S'Mo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations"
    ]
  },
  {
    "name": "Mortar Board National College Senior Honor Society- Mabel G. Freeman Chapter",
    "purposeStatement": "Mortar Board is a national honor society recognizing college seniors for their exemplary scholarship, leadership and service.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Mosaic Undergraduate Art & Literature Magazine",
    "purposeStatement": "Mosaic Magazine publishes the art and literature of Ohio State undergraduate students. Ohio State undergrads of all majors are welcome to su...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Mount Leadership Society",
    "purposeStatement": "Named after Ruth Weimer Mount, the Mount Leadership Society focuses on students committed to leadership and service. Students further develo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Mountain Biking Club at The Ohio State University",
    "purposeStatement": "The Mountain Biking Club at OSU is new organization with the goal of connect individuals with a common interest in mountain biking and the o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Mountaineers at Ohio State",
    "purposeStatement": "Mountaineers at Ohio State is dedicated in its mission:  To provide all levels of outdoor enthusiasts the opportunity to meet and pool their...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Movement Variations",
    "purposeStatement": "Movement Variations is a completely student run organization comprised of dancers with previous training and experience. We aim to foster a ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "MOXIE ROBOTICS",
    "purposeStatement": "MOXIE ROBOTICS designs, builds and tests contraptions that extend the capabilities of humans. More specifically the club aims to construct r...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Sports and Recreation"
    ]
  },
  {
    "name": "MSK Ultrasound COP Interest Group",
    "purposeStatement": "The MSK Ultrasound COP Interest Group hopes to unite medical students, residents, fellows, and faculty within a single Community of Practice...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Mu Delta Alpha Sorority, Inc.",
    "purposeStatement": "Our mission is to establish a sense of community and sisterhood for Muslim women by providing mentorship, service opportunities, networking,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Muay Thai at Ohio State",
    "purposeStatement": "With the massive growth of mixed martial arts and combat sports, along with competitive organizations such as the UFC, kickboxing sports, in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Multicultural Greek Council",
    "purposeStatement": "The purpose of this organization shall be primarily to inspire, spread cultural awareness, and unite the diverse organizations affiliated wi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Ethnic/Cultural",
      "Social Fraternities/Sororities",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Multicultural Public Health Student Association",
    "purposeStatement": "The mission of Multicultural Public Health Student Association is to bring public health students together to create an environment in which...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Multicultural Understanding Through Non-Traditional Discovery Opportunities at The Ohio State University",
    "purposeStatement": "MUNDO at Ohio State’s educational priority is to create hands-on ways for active participants to become self-aware, collaborative community...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Muscle Movement Foundation at Ohio State",
    "purposeStatement": "The Muscle Movement Foundation at Ohio State will raise awareness and finances for individuals and families affected by neuromuscular diseas...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Music & Science Colloquium and Teaching Series (MASCATS)",
    "purposeStatement": "MASCATS is a student organization that aims to foster interdisciplinary research in music among scholars across the OSU campus and at other ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Music Industry Club",
    "purposeStatement": "We are passionate about music and careers in the music industry. Through discussions, guest webinars, and workshops for cover letters, resum...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Musical Memories: Day By Day Project",
    "purposeStatement": "We are a student organization with 3 missions: Music, Education, and Memories. We are proud to have worked with lead physicians and research...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Musicians' Collective",
    "purposeStatement": "To support and provide a social medium for musical expression within the Ohio State community.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Muslim Pharmacy Student Association",
    "purposeStatement": "Dedicated to bridging the pharmacy practice with the Muslim community",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Muslim Students In Healthcare",
    "purposeStatement": "MSH aims to create a supportive and inclusive community for Muslim students pursuing careers in healthcare. Our mission is to empower Muslim...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Muslim Students' Association",
    "purposeStatement": "MSA-OSU aims to aid in the fulfillment of the religious obligations of Muslims at The Ohio State University, to provide a home on campus to ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Muslim Women in Fitness",
    "purposeStatement": "We believe that there is a disconnect between Muslim women and maintaining physical well-being. Modesty is an important facet of Islam and m...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Muslima in Medicine",
    "purposeStatement": "MMA is a fun opportunity for students to broaden their knowledge of medicine and interact with other students who have a shared passion for ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Religious/Spiritual",
      "Special Interest"
    ]
  },
  {
    "name": "Mwanafunzi",
    "purposeStatement": "MWANAFUNZI, Swahili for “Student” strives for unity and cohesiveness among black students and the professional community.  MWANAFUNZI provid...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "The Mycology Club at The Ohio State University",
    "purposeStatement": "We are here to explore the many aspects of the world of Mycology. We want to give students the opportunity to explore the fascinating world ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "National Alzheimer's Buddies",
    "purposeStatement": "Making sense of the past and present; understanding our emotions; recognizing and connecting with those around us. Alzheimer's Disease makes...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "National Association for the Advancement of Colored People",
    "purposeStatement": "The purpose and aims of The Ohio State University College Chapter of the NAACP is to inform students of the problems affecting African Ameri...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "National Association of Black Accountants",
    "purposeStatement": "Since 1969, the National Association of Black Accountants, Inc. has been the leader in expanding the influence of minority professionals in ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "National Association of Minority Landscape Architects",
    "purposeStatement": "The Ohio State chapter of The National Association of Minority Landscape Architects (NAMLA) is intended to unify the minority students in th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "National Community Oncology Dispensing Association, Inc. Professional Student Organization Chapter at The Ohio State University",
    "purposeStatement": "The OSU NCODA Professional Student Organization Chapter is dedicated to enhancing students’ understanding of oncology by raising awareness o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Honoraries/Honor Societies",
      "Special Interest"
    ]
  },
  {
    "name": "National Lawyers Guild",
    "purposeStatement": "The National Lawyers Guild is the nation’s oldest and largest progressive bar association and was the first one in the US to be racially int...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "National Optometric Student Association",
    "purposeStatement": "To increase the quality of eye care in under-served populations while supporting the recruitment and success of minority optometrists.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "National Organization for the Professional Advancement of Black Chemists and Chemical Engineers at The Ohio State University",
    "purposeStatement": "NOBCChE at The Ohio State University (OSU) is committed to the discovery, transmittal, and application of knowledge in the fields of science...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "National Organization of Minority Architecture Students",
    "purposeStatement": "To champion diversity within the design professions by promoting the excellence, community engagement, and professional development of its m...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "National Pan-Hellenic Council",
    "purposeStatement": "The purpose of the NPHC is to foster cooperative actions of its member organizations in dealing with matters of mutual concern. To this end,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Ethnic/Cultural",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "National Residence Hall Honorary",
    "purposeStatement": "The purpose of this Organization shall be to provide recognition for students, staff, administrators, and faculty living, working, or servin...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "National Retail Federation Student Association at The Ohio State University",
    "purposeStatement": "The purpose of the NRFSA is to provide students with opportunities within the professional retail community. The organization has the resour...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "National Society of Black Engineers",
    "purposeStatement": "NSBE's mission is \"to increase the number of culturally responsible Black engineers who excel academically, succeed professionally and posit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "National Society of Black Women in Medicine",
    "purposeStatement": "The National Society of Black Women in Medicine is a multi-disciplined organization that works to increase the recruitment and retention of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "National Society of Leadership and Success",
    "purposeStatement": "The NSLS is a national organization that helps people discover and achieve their goals. The NSLS offers life-changing lectures from the nati...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "National Student Speech Language Hearing Association",
    "purposeStatement": "The mission of the National Student Speech Language Hearing Association (NSSLHA) is to benefit its members by continually improving its supp...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Native American and Indigenous Peoples Cohort",
    "purposeStatement": "Provide support through fellowship for Native American students, Indigenous students from around the world, and any other student wishing to...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Natural and Prosperous Society",
    "purposeStatement": "The Natural and Prosperous Society will educate the Ohio State community about natural hair. We will address various topics and taboos cente...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Natural History Collections Club",
    "purposeStatement": "The Natural History Collections Club is a student-led organization that acts as a hub for students interested in natural history and museum ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Nepalese Student Association",
    "purposeStatement": "The club will facilitate the history of unrepresented South Asians, focusing on the Nepali community in America. The club will hold meetings...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Net Impact - Undergraduate Chapter",
    "purposeStatement": "The purpose of Net Impact is to introduce our members to sustainability in business through various speakers, events, and networking opportu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "The NeuroLaw Group",
    "purposeStatement": "The NeuroLaw Group is an interdisciplinary club for undergraduates that explores the intersections of neuroscience in law, ethics, policy, a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Neuropsychology Network",
    "purposeStatement": "The Neuropsychology Network aims to connect graduate students interested in careers in clinical neuropsychology in order to share informatio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Neuroscience Graduate Student Organization",
    "purposeStatement": "The Neuroscience Graduate Student organization is a student organization whose primary purpose is to promote the advancement of its members ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Neurosurgery Interest Group",
    "purposeStatement": "To further expose medical students to the field of neurosurgery.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "The NeuroTech Club",
    "purposeStatement": "The NeuroTech club is aimed at developing new technologies related to neuroscience applications such as medical devices or virtual reality s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Never Let Your Pen Dry",
    "purposeStatement": "The purpose of Never Let Your Pen Dry is to provide a forum of individual artistic expression through writing and speech, showcase member ta...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Never Walk Alone",
    "purposeStatement": "C.A.R.E  Connect students with others struggling with mental illnesses or ones looking to support and create a support network that they can...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "New Life Free Clinic",
    "purposeStatement": "The New Life Community Outreach Health and Wellness Center welcomes anyone who would like to see a physician at no cost. Medical students vo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The New Music Collective",
    "purposeStatement": "The mission of The New Music Collective is to engage in all aspects of the performance of a wide variety of Twentieth and Twenty-First Centu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Next Crew",
    "purposeStatement": "Next Crew is devoted to give novice and intermediate dancers a place to expand their dance styles and talents. It is an audition based organ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "NGPA at The Ohio State University",
    "purposeStatement": "The NGPA at The Ohio State university will build, support and unite the LGBTQ+ aviation community and its affiliates. Through education, soc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "North African Student Society",
    "purposeStatement": "The North African Student Society, or NASS, is a student organization aimed at highlighting an often under-represented culture here on the O...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "North and South Sudanese Association",
    "purposeStatement": "The purpose of this organization is to increase awareness about issues regarding North and South Sudan. To represent Sudan via collaboration...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Nourish International",
    "purposeStatement": "OSU Nourish allows students to make a stand against food insecurity in a tangible way. Nourish partners with the Charles Madison Nabrit Memo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest",
      "Awareness/Activism",
      "Technology"
    ]
  },
  {
    "name": "Nu Rho Psi: Epsilon Chapter",
    "purposeStatement": "The purpose of Nu Rho Psi shall be to: (1) encourage professional interest and excellence in scholarship, particularly in neuroscience; (2) ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Nurses For Sexual and Reproductive Health at The Ohio State University",
    "purposeStatement": "To advocate for the inclusion of sexual and reproductive health, rights, and justice within nursing education. With support and resources fr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Nursing Students of Color",
    "purposeStatement": "Nursing Students of Color (NSC) serves as a support network that is committed to developing a safe space for the underrepresented students o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Nursing Students Promoting Initiatives to Reinforce Equality",
    "purposeStatement": "The mission of NSPIRE is to raise public awareness and provide education about healthcare inequities and disparities in underserved populati...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Academic/College"
    ]
  },
  {
    "name": "O.A.S.I.S",
    "purposeStatement": "The mission of O.A.S.I.S. (Ohio State, Adventures, Sightseeing, International Seeking) is to provide Ohio State students with opportunities ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "OB/GYN Interest Group",
    "purposeStatement": "The goal of this organization is to increase awareness of issues pertaining to Obstetrics and Gynecology among students of the OSU College o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "OB/GYN Ultrasound Community of Practice",
    "purposeStatement": "We define an Ultrasound Community of Practice (COP) as a team of students and physicians dedicated to advancing point of care ultrasound wit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "OChemTALKS",
    "purposeStatement": "OChemTALKS is a student-run organization devoted to planning seminars focused on organic chemistry and providing opportunities for students ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Ocular Club of Disease",
    "purposeStatement": "To raise awareness of the opportunities available to optometry students in the field of ocular disease and neuro-optometry.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "Off Campus Community Ambassadors",
    "purposeStatement": "For internal student staff use to be charged to Off Campus Community Ambassadors leadership at the end of each semester.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Off the Lake Productions",
    "purposeStatement": "Off the Lake Productions is The Ohio State University's only student-run, service-based theatre organization. Every year we have FOUR major ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Community Service/Service Learning",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Office of Diversity & Inclusion Undergraduate Recruitment Society",
    "purposeStatement": "The purpose for this organization is to be a group of dynamic students that represent different ethnic and cultural backgrounds who assist i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Ethnic/Cultural",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "OHI/O",
    "purposeStatement": "We host HackOHI/O and MakeOHI/O, annual 24-hour hackathons where students spend a weekend working as teams to solve problems and learn more ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Ohio Air Mobility Symposium",
    "purposeStatement": "The purpose of the Ohio Air Mobility Symposium is to foster collaboration, innovation, and knowledge exchange within the field of air mobili...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Technology"
    ]
  },
  {
    "name": "Ohio Collegiate Music Education Association",
    "purposeStatement": "It shall be the purpose of this organization to make available to members opportunities for professional development; to acquaint students w...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Ohio Education Association Aspiring Educators",
    "purposeStatement": "Mission Statement: Ohio Education Association Aspiring Educators is a professional organization of undergraduate students preparing for or i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Ohio Innocence Project - Collegiate Chapter",
    "purposeStatement": "-Prevent Wrongful Conviction by promoting awareness of its existence on College Campuses and to generate student and community support for t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Ohio National Black Association for Speech-Language and Hearing Student Affiliate Chapter",
    "purposeStatement": "The purpose of CO-NBASLH is to provide a space and opportunity with a focus on Black students at Ohio State University and Central Ohio univ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Ohio State Business Law Journal",
    "purposeStatement": "The Ohio State Business Law Journal (“Journal\") is a student-managed publication of scholarly research and commentary exploring the legal is...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Ohio State Equestrian Team-Western - Sport Club",
    "purposeStatement": "The purpose of the OSU Equestrian Club is to provide all currently enrolled students the opportunity to develop riding skills and to provide...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Ohio State Journal on Dispute Resolution",
    "purposeStatement": "Now in its thirty-ninth year of publication, the Ohio State Journal on Dispute Resolution (\"JDR\") is a student-run publication of The Ohio S...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College"
    ]
  },
  {
    "name": "Ohio State Law Journal",
    "purposeStatement": "Started in 1935, the Ohio State Law Journal is a nationally renowned publication of the highest quality legal scholarship, managed and staff...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College"
    ]
  },
  {
    "name": "Ohio State Men's Basketball Club - Sport Club",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "The Ohio State Oyster Club",
    "purposeStatement": "At the Oyster Club, we will discover different types of oysters from various waters (salt, brinkish, fresh) and regions. With the Oyster Clu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Ohio State Technology Law Journal",
    "purposeStatement": "The Mission of Ohio State Technology Law Journal (hereinafter “OSTLJ”) is to publish an interdisciplinary journal of research and commentary...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "The Ohio State University College of Veterinary Medicine Honey Bee Veterinary Club: Student Chapter of The Honey Bee Veterinary Consortium",
    "purposeStatement": "We aim to increase the experience and knowledge of apiary healthcare and management for OSU veterinary students, thereby allowing them to ef...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Ohio State Women's Basketball Club - Sport Club",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Ohio Staters, Inc.",
    "purposeStatement": "Ohio Staters, Inc. strives to improve the University through unique voluntary service. We help the University envision its future, facilitat...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Ohio Student Association",
    "purposeStatement": "To give buckeyes from every walk of life a platform where they can come together in an intergenerational movement for racial, social, econom...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Ohio Union Activities Board",
    "purposeStatement": "The mission of the Ohio Union Activities Board is to be the main student programming organization at The Ohio State University, to provide d...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Ohio Virology Association",
    "purposeStatement": "We would like to foster collaboration and fellowship with virologists at Ohio State and the surrounding community.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "OhioMOD Biomolecular Design Team",
    "purposeStatement": "We are a group of undergraduate engineering students that participates in DNA nanotechnology based molecular design for an annual Internatio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Olympic Weightlifting Club at The Ohio State University",
    "purposeStatement": "The Olympic Weightlifting Club at Ohio State seeks to create a supportive environment of weightlifters who train as a team with the goal of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Omani Student Association",
    "purposeStatement": "The Omani Student Association aims to celebrate and share the rich heritage of Oman with OSU's community. Through cultural events, education...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Omega Gamma at The Ohio State University",
    "purposeStatement": "The Omega Gamma Fraternity at the Ohio State University hopes to encourage and facilitate a welcoming, unbiased social interaction between u...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Omega Psi Phi Fraternity Incorporated, Iota Psi Chapter",
    "purposeStatement": "Omega Psi Phi Fraternity, Inc. purpose is to bring about union of college men of similar high ideals of scholarship, and manhood in order to...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Omega Tau Sigma Veterinary Fraternity",
    "purposeStatement": "To foster and further the relationship between veterinary students and alumni, and to facilitate service and social involvement by members o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Oncology Interest Group",
    "purposeStatement": "1) Introduce the fields of radiation oncology, medical oncology, and  surgical oncology to students of The Ohio State University College of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "One for the World at Ohio State",
    "purposeStatement": "One for the World at Ohio State (OFTW) is a student-run philanthropy group, functioning as a constituent part of the international One for t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "One for the World at Ohio State",
    "purposeStatement": "One for the World at Ohio State (OFTW) is a student-run philanthropy group, functioning as a constituent part of the international One for t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "One Health Club",
    "purposeStatement": "The purpose of the club is to increase awareness of the One Health approach, which is the interconnection of public health, veterinary scien...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "One:Twelve",
    "purposeStatement": "Purpose: One:Twelve becomes what the KSA student body wants it to be, and offers a progressive medium for the always changing worlds of desi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Op Notes: Surgery Journal Club",
    "purposeStatement": "The mission of Op Notes is to cultivate an inclusive academic space for women medical students interested in surgery to meet representative ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Open Source Club",
    "purposeStatement": "In a world where technology increases its reach into our personal lives, encroaching on our privacy, accessibility, and even our democracy, ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Technology"
    ]
  },
  {
    "name": "Operation Smile Club at The Ohio State University",
    "purposeStatement": "To create a community of Buckeyes committed to advocating for and supporting children born with cleft lips and cleft palates in regions of t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest",
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Ophthalmology Interest Group",
    "purposeStatement": "The purpose of the Ophthalmology Interest Group is to provide opportunities for current medical students to explore the field of ophthalmolo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Opthalmic Engineering Journal Club",
    "purposeStatement": "The Ophthalmic Engineering Journal Club is a group that meets weekly to present scientific papers in a journal club setting. Student members...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Optica Student Chapter",
    "purposeStatement": "The Chapter shall enrich its members through professional networking, and by providing career development and technical programming. The Cha...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Optometric Vision Development & Rehabilitation Association",
    "purposeStatement": "To increase awareness of binocular vision disorders, vision therapy and vision therapy practice management.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Optometry Ambassadors at The Ohio State University",
    "purposeStatement": "The organization will be known as Optometry Ambassadors at The Ohio State University, and will help prospective students make informed admis...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Optometry Student Council",
    "purposeStatement": "The Student Council shall be an official representative of the College of Optometry students in the following ways: 1.\tServe as a liaison be...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations",
      "Special Interest"
    ]
  },
  {
    "name": "Oral Surgery Interest Group",
    "purposeStatement": "The Oral Surgery Interest Group operates within the OSU College of Dentistry and strives to provide dental students with knowledge and exper...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Order Of The Cardinal",
    "purposeStatement": "To introduce and train students in the athletic role playing hobby that is Belegarth, a nationalized rule set of foam fighting and light rol...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Order of Omega",
    "purposeStatement": "We are an active Greek honorary pursuing new and innovative ways to serve the Greek and University communities. We are in a constant pursuit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Organization of Black Aerospace Professionals - The Ohio State University Student Chapter",
    "purposeStatement": "The purpose of the OBAP Ohio State University Chapter is to unify aerospace/aviation students, professionals, and members of the community i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Oriental Dance Troupe at Ohio State",
    "purposeStatement": "To enhance international cutural exchange through traditional Chinese dance.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Origins Dance Team",
    "purposeStatement": "To bring together students with talent and interest in the art of Bhangra, Hip-Hop, Bollywood, classical, contemporary, and many more styles...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Ornithology Club",
    "purposeStatement": "The Ornithology Club at OSU provides an opportunity for students to pursue their interest in birds and birdwatching, while also allowing stu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Orthodontic Interest Group",
    "purposeStatement": "The Orthodontic Interest Group will serve as a resource to dental students interested in orthodontics and provide them with opportunities to...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Orthodox Christian Fellowship",
    "purposeStatement": "To support fellowship on campus, to experience and witness the Orthodox Christian Church through community life, prayer, service to others a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Orthodox Tewahedo Club",
    "purposeStatement": "The purpose of OTC is to regularly congregate, fellowship and discuss the faith/theology/history of 1st century Christianity; the belief of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Orthopedic Surgery Interest Group",
    "purposeStatement": "Allowing students to obtain a first-hand glimpse into what the field of orthopedic surgery entails.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "OS3",
    "purposeStatement": "Our mission is to provide students with the opportunity to learn and communicate about the world of Web 3. We aim to learn more about these ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Special Interest"
    ]
  },
  {
    "name": "The OSEuchre Club",
    "purposeStatement": "The OSEuchre Club strives to teach students how to play euchre and to create a social environment for students to play euchre, have fun, and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "OSM a Cappella",
    "purposeStatement": "The Ohio State of Mind is a competitive a cappella musical group at The Ohio State University and offer students an opportunity to grow as m...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "OSU Votes",
    "purposeStatement": "The Office of Student Life’s OSU Votes is a student-led movement to register, educate and encourage other students to vote. This nonpartisan...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Otolaryngology Ultrasound Community of Practice",
    "purposeStatement": "To increase clinician use, accessibility, and knowledge of focused ultrasound within the field of Otolaryngology throughout the Wexner Medic...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Out in Science, Technology, Engineering and Mathematics",
    "purposeStatement": "oSTEM provides support for LGBTQ+ and ally students, faculty, and staff by educating peers, hosting social events, and connecting members wi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Out In Social Work",
    "purposeStatement": "Out in Social Work is an organization created to unify Lesbian, Gay, Bisexual, Transgender, Queer, Intersex, Asexual, Questioning individual...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Out of Office",
    "purposeStatement": "To have an organization of business professionals that openly accepts all. A community in the Fisher College of Business Graduate school tha...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "OUTdoors",
    "purposeStatement": "To provide access to nature and outdoor activities to underrepresented groups, with a focus on LGBTQ+ identities, people of color, women, pe...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Ethnic/Cultural",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "OutLaws at The Ohio State University Moritz College of Law",
    "purposeStatement": "The OutLaws are an organization of students, faculty, and staff of The Ohio State University Moritz College of Law. The Association promotes...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Oval Dogs",
    "purposeStatement": "This organization's primary focus will be to provide a solid support system of friends, canine-lovers, and puppy owners to all the dogs who ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "P1 PharmD Class Officers at The Ohio State University",
    "purposeStatement": "To present opinions on behalf of the College of Pharmacy student body in response to administrative and academic policies. To promote inclus...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "P3 PharmD Class Officers at The Ohio State University",
    "purposeStatement": "To present opinions on behalf of the College of Pharmacy student body in response to administrative and academic policies. To promote inclus...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "P4 PharmD Class Officers at The Ohio State University",
    "purposeStatement": "To present opinions on behalf of the College of Pharmacy student body in response to administrative and academic policies. To promote inclus...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College"
    ]
  },
  {
    "name": "Paintball Club - Sport Club",
    "purposeStatement": "The purpose of this club is to bring competitive paintball to OSU.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Pakistani American Students' Association",
    "purposeStatement": "The Pakistani American Students’ Association at The Ohio State University values preserving the Pakistani identity, traditions and its rich ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Palestine Children's Relief Fund at Ohio State",
    "purposeStatement": "PCRF - OSU plans to bring awareness and host fundraising events to support the medical humanitarian efforts of the PCRF organization. This o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Palestinian Women's Association",
    "purposeStatement": "Our purpose is to create a positive environment for our members to speak on politics, to appreciate Palestinian culture, and to engage in ac...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Palette Pals at The Ohio State University",
    "purposeStatement": "The purpose of this club is to provide a service that integrates Ohio State students with individuals with developmental disabilities and th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Palliative Medicine Interest Group",
    "purposeStatement": "The Palliative Medicine Interest Group exists to provide research opportunities, shadowing opportunities, and other events  for medical stud...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Panhellenic Association",
    "purposeStatement": "The Panhellenic Association is the governing body of all 17 nationally recognized sororities on campus.  We organize programs and institute ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Community Service/Service Learning",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Paranormal Club at The Ohio State University",
    "purposeStatement": "Paranormal club at The Ohio State University offers a diverse environment in which students of all backgrounds research paranormal phenomena...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Park-Stradley Community Council",
    "purposeStatement": "The purpose of this Community Council is to provide for the social, recreational, informational, educational, diversity, wellness, and commu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Parks and Recreation Society",
    "purposeStatement": "We are students interested in outdoor adventure, environmental education, park administration, community recreation, tourism planning and de...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Partners in Health Engage at The Ohio State University",
    "purposeStatement": "PIH Engage is a network of community organizers across the country working together to advance the right to health. We work to: 1.\tBring ess...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Partnership for Ongoing Development, Education, and Medical Outreach Solutions",
    "purposeStatement": "Our mission is the immersion of OSU College of Medicine students in the task of building a health centered relationship in El Progeso, Hondu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Pass the Class",
    "purposeStatement": "Our purpose is to aid in the development of homeless and at-risk youth from ages 14-24 of Columbus in all aspects of their life. We provide ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Pay It Forward",
    "purposeStatement": "Pay It Forward is a cohort program involving between 20 and 30 students who work closely with Center for Student Leadership and Service in t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Pediatric Pharmacy Association",
    "purposeStatement": "The purpose of this organization is to serve as pediatric pharmacy advocates within the greater Columbus community in order to promote safe ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Pediatrics Interest Group",
    "purposeStatement": "To introduce medical students to the pediatric specialty through panels and discussions about the field, networking with physicians, coordin...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "The Pediatrics Ultrasound Community of Practice at The Ohio State University College of Medicine",
    "purposeStatement": "The purpose of our organization is to increase clinician use, accessibility, and knowledge of focused ultrasound within the field of Pediatr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Peers Advancing Literacy in Students at The Ohio State University",
    "purposeStatement": "The mission of Pen PALS is to alleviate the challenges faced in the Columbus City School District through literacy and mentorship, while edu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "People In The Soil",
    "purposeStatement": "The People In The Soil (PITS) Club allows students to prepare and participate in soil judging contests with the competitive Ohio State Soil ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Percussion Club at Ohio State",
    "purposeStatement": "OSU Percussion Club will create events where students can perform for each other, bond, and discuss percussion-related activities. A member ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Perfect Pair at Ohio State",
    "purposeStatement": "Perfect Pair at Ohio State fosters one-on-one, intergenerational connections between older adults and college students. We strive to reinfor...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Performance Nutrition Club at Ohio State",
    "purposeStatement": "Educate and immerse nutrition focused students into a performance nutrition environment with Ohio State Athletics. Students will be given th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Performance Studies Working Group",
    "purposeStatement": "The Performance Studies Working Group's mission is to promote interdisciplinary discourse on Performance Studies among Ohio State's artists,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "PERIOD at The Ohio State University",
    "purposeStatement": "Our aim to destigmatize menstruation and make menstrual products more available through our three pillars of service, advocacy and education...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Pershing Rifles Company A-1",
    "purposeStatement": "The purpose of the National Society of Pershing Rifles is to develop, to the highest degree possible, outstanding traits of leadership, mili...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Social Fraternities/Sororities",
      "Special Interest"
    ]
  },
  {
    "name": "Persian Student Association",
    "purposeStatement": "The Persian Student Association (PSA) is a non-political, non-religious voluntary student organization whose objective is to sponsor Persian...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "The Peruvian Association",
    "purposeStatement": "The Peruvian Association at the Ohio State University (OSU) aims to promote Peruvian culture to anyone and everyone. As well as provide a sp...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "PGN- A Professional Development Organization",
    "purposeStatement": "PGN is a national professional development organization that produces leaders of outstanding value. We excel at encouraging entrepreneurship...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Pharmacy Club",
    "purposeStatement": "It shall be the purpose of Pharmacy Club to present its members with a variety of information about the various occupational and educational...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Phi Alpha Delta Pre-Law Fraternity",
    "purposeStatement": "The purpose of this Fraternity shall be to form a strong bond uniting students and teachers of the law with members of the Bench and Bar in ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Phi Alpha Theta",
    "purposeStatement": "Phi Alpha Theta is the History Honorary Society at Ohio State (Zeta Chapter) and exists primarily to recognize academic excellence among His...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Phi Beta Sigma Fraternity Incorporated Delta Omicron",
    "purposeStatement": "Culture For Service and Service For Humanity",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Phi Chi Theta - Co-Ed Professional Business & Economics Fraternity",
    "purposeStatement": "Phi Chi Theta, the leading professional business fraternity, provides an opportunity to develop and practice professional leadership skills ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Phi Delta Chi",
    "purposeStatement": "To advance the science of pharmacy and its allied interests and to foster and promote a fraternal spirit among its members",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Social Fraternities/Sororities",
      "Special Interest"
    ]
  },
  {
    "name": "Phi Delta Epsilon The Ohio State University OH Zeta Chapter",
    "purposeStatement": "\"Phi Delta Epsilon International Medical Fraternity creates physicians of integrity with a life-long commitment to our guiding principles of...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Phi Delta Epsilon, Chi Chapter",
    "purposeStatement": "Phi Delta Epsilon International Medical Fraternity creates physicians of integrity with a lifelong commitment to our guiding principles of p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Phi Gamma Delta",
    "purposeStatement": "Phi Gamma Delta exists to promote lifelong friendships, to reaffirm high ethical standards and values, and to foster personal development in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Phi Kappa Psi",
    "purposeStatement": "Phi Kappa Psi is a fraternity whose aim is to enhance the the undergraduate experience of both its members and the university at large throu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Phi Kappa Tau",
    "purposeStatement": "Our Mission: The mission of Phi Kappa Tau is to champion a lifelong commitment to brotherhood, learning, ethical leadership and exemplary ch...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Phi Kappa Theta Fraternity",
    "purposeStatement": "Phi Kappa Theta actively develops men to be effective leaders who passionately serve society, Fraternity and God.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Phi Lambda Sigma - Alpha Sigma chapter",
    "purposeStatement": "Phi Lambda Sigma is the national pharmacy leadership society, which recognizes students who are leaders. Student pharmacists are selected by...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College"
    ]
  },
  {
    "name": "Phi Mu Alpha Sinfonia Music Fraternity",
    "purposeStatement": "The Object of this Fraternity shall be for the development of the best and truest fraternal spirit, the mutual welfare and brotherhood of mu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Phi Sigma Kappa",
    "purposeStatement": "Phi Sigma Kappa is a lifelong brotherhood dedicated to the betterment of the individual, the university community, and our world, by giving ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Phi Sigma Pi National Honor Fraternity",
    "purposeStatement": "In carrying out the purpose of the National Fraternity, Phi Sigma Pi shall strive to personify and encourage three ideals: 1. The acquisitio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Community Service/Service Learning",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Phi Sigma Rho",
    "purposeStatement": "We are a social sorority for women in engineering, architecture, and engineering-related sciences.  Phi Sigma Rho enables women to stay acti...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Phi Tau Sigma - Buckeye Chapter",
    "purposeStatement": "The mission of Phi Tau Sigma is to raise the stature and recognize scholarly achievements in the Food Science and Technology profession.  Th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Phi Theta Epsilon",
    "purposeStatement": "A.\tTo recognize and encourage scholastic excellence of occupational therapy students.  B.\tTo contribute to the advancement of the field of o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College"
    ]
  },
  {
    "name": "Phi Upsilon Omicron",
    "purposeStatement": "Phi Upsilon Omicron is The National Honor Society of Family and Consumer Sciences. The Ohio State Gamma Chapter is for students eligible fro...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Photography Enthusiast Society",
    "purposeStatement": "The purpose of Photography Enthusiast Society is to be an organization for students interested in photography who want to share their experi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Photography, Images and Cinematography Organization",
    "purposeStatement": "Provide opportunities for people who are interested in photography.  Fuse the cultural diversities. Hold Discussion meetings with members. O...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Physical Medicine and Rehabilitation Interest Group",
    "purposeStatement": "This group’s purpose shall be to host events and provide information to Ohio State College of Medicine students that promote awareness and i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Physicians for Human Rights: The Ohio State University College of Medicine Student Chapter",
    "purposeStatement": "Physicians For Human Rights is a non-profit non-government organization that works with healthcare workers, scientists, lawyers and communit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Physiology and Cell Biology Graduate Student Organization",
    "purposeStatement": "The main goal of the Physiology and Cell Biology Graduate Student Organization (PCBGSO) is to function as the communications vehicle between...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Pi Alpha Xi",
    "purposeStatement": "Though an honor society, Pi Alpha Xi is more than a society. The organization was originally established to unify students, educators, and p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College"
    ]
  },
  {
    "name": "Pi Beta Phi",
    "purposeStatement": "Pi Beta Phi provides women the opportunity to grow and enhance their collegiate experience through leadership development, academic enrichme...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Pi Kappa Phi Fraternity",
    "purposeStatement": "Mission Statement: To create an uncommon and lifelong brotherhood that develops leaders and encourages service to others for the betterment ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Social Fraternities/Sororities",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Pi Lambda Phi Fraternity",
    "purposeStatement": "Eliminating Prejudice since 1895",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Pi Sigma Alpha",
    "purposeStatement": "Our mission is to foster a strong sense of community within the political science department at Ohio State. We plan to do this through essay...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College"
    ]
  },
  {
    "name": "Pi Sigma Epsilon",
    "purposeStatement": "Our mission is to provide our members with unique programming and leadership opportunities that will create professional growth for both the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Piano Club at The Ohio State University",
    "purposeStatement": "A casual club for any and all who enjoy playing or listening to piano.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Pickle Club",
    "purposeStatement": "Our purpose is to involve those on campus who share a common liking for pickles.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Pilipino Student Association",
    "purposeStatement": "Pilipino Student Association (PSA) embraces Filipino and Filipino-American culture by coordinating annual culture shows, engaging with phila...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Pilot Dogs Club",
    "purposeStatement": "Our purpose is to provide a united group of Co-Pilots and volunteers to work with the outside organization Pilot Dogs in the raising and tra...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Pink Out at Ohio State",
    "purposeStatement": "Our purpose is to raise awareness for breast cancer through community service and to promote professional development. Our main focus is to ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism"
    ]
  },
  {
    "name": "Pistol Club",
    "purposeStatement": "The Ohio State University Pistol Club provides instruction on safe firearm handling and marksmanship to all students, faculty, staff, alumni...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Plant Futures Initiative--Ohio State",
    "purposeStatement": "Increasingly, young adults are recognizing the broad based potential of a plant-centric food system to (i) address the climate crisis direct...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College"
    ]
  },
  {
    "name": "Plant Pathology Graduate Students Association",
    "purposeStatement": "The Plant Pathology Graduate Student Association (PPGSA) is a non-profit organization, thus making profit is not the primary function of the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Plant Sciences Symposium of The Ohio State University",
    "purposeStatement": "The purpose of the organization is as follows:  1) To organize and execute an annual symposium hosted at The Ohio State University centered ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Plastic Surgery Interest Group",
    "purposeStatement": "The Plastic & Reconstructive Surgery Interest Group (PSIG) is an organization dedicated to providing its members with an avenue to learn mor...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Play For A Cause",
    "purposeStatement": "To fundraise for cancer research institutions through the use of engaging sports tournaments.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "POGO at Ohio State",
    "purposeStatement": "To bring together people, be active, and explore the outdoors with others, through the geolocation game Pokémon Go!",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "The Poker Club at Ohio State",
    "purposeStatement": "Offering all students, regardless of skill, a group with which to play poker and improve their game through play and open discussion.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Political Science Graduate Organization",
    "purposeStatement": "The purpose of the Political Science Graduate Organization is to represent and advocate for the graduate students in the Ohio State Universi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations"
    ]
  },
  {
    "name": "Portuguese Graduate Student Organization",
    "purposeStatement": "The purpose of this group is to provide a higher level of the Portuguese-speaking world cultures, history, and art awareness at the Universi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "The Positive Psychology Club at The Ohio State University",
    "purposeStatement": "The Positive Psychology Club spends time educating its members on the different topics of positive psychology and how those topics benefit p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "POTS Club",
    "purposeStatement": "The main purpose of this organization is to connect those who have POTS with each other, therefore, creating a support system. Additionally,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Poultry Science Club",
    "purposeStatement": "It shall be the purpose of the Poultry Science Club at The Ohio State University to create and further the interest of students in poultry s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Power in Neuroscience",
    "purposeStatement": "Power in Neuroscience (PIN) is an interdisciplinary organization of leaders that work to advocate for and support vulnerable populations wit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "POWER Skills Lab",
    "purposeStatement": "Lab Mission: To provide learners from marginalized communities high-quality research experience utilizing systematic review methodology to p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Ethnic/Cultural",
      "Technology"
    ]
  },
  {
    "name": "PPE Society at Ohio State",
    "purposeStatement": "To encourage and foster a community of students interested in examining current events and ethical issues from a wide variety of backgrounds...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Prayer Reaches Every Single Situation at Ohio State",
    "purposeStatement": "PRESS (Prayer Reaches Every Single Situation) at Ohio State is designed to motivate participants to know Christ in every situation through p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Pre-Dental Club of The Ohio State University",
    "purposeStatement": "2024-2025 Academic Year:  The purpose of Pre-Dental Club is to provide a place for all students with an interest in pursuing careers in the ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Pre-Med Asian Pacific American Medical Student Association",
    "purposeStatement": "The Asian Pacific American Medical Students Association (APAMSA) is a national organization of medical and pre-medical students committed to...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Ethnic/Cultural",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Pre-Medicine Club",
    "purposeStatement": "The purpose of Pre Med Club at The Ohio State University shall be: to offer support and encouragement to one another, hosting events to bett...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Pre-Optometry Club at Ohio State",
    "purposeStatement": "The purpose of this organization is to acquaint its members with the many aspects of the field of optometry, as well as to familiarize them ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Pre-Physical Therapy and Occupational Therapy Club",
    "purposeStatement": "The purposes of our organization are to share useful information with members about Physical Therapy and Occupational Therapy, provide a soc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Pre-Veterinary Medical Association",
    "purposeStatement": "To help, guide, and unite students interested in veterinary medicine by offering opportunities that include hands-on experience, community s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Prep Scholars Mentorship Club",
    "purposeStatement": "The Mission of Prep Scholars Mentorship Club (PSM) is to provide mentorship and resources to minority youth residing in underserved communit...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Prescription Fitness",
    "purposeStatement": "Prescription Fitness (Rx Fitness) is a non-profit organization which aims to promote an inclusive culture of optimal health, fitness, and nu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The Prismatic Effect",
    "purposeStatement": "To create a community for LGBTQ+ students and allies at The Ohio State University College of Optometry by organizing educational, social, an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Professional Golf Management Club",
    "purposeStatement": "The purpose of this organization shall be:  To provide guidance to Professional Golf Management students using University, College and outsi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Sports and Recreation",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Professional School Orchestra",
    "purposeStatement": "To allow inter-professional students and members of the medical community to have a musical outlet, to provide orchestral performances for t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Project HEAL at The Ohio State University",
    "purposeStatement": "Eating disorders are sadly becoming more and more prevalent, and treatment costs around $30,000 per month, while recovery takes on average 3...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Project Nicaragua at The Ohio State University",
    "purposeStatement": "Project Nicaragua is a 501(c)3 nonprofit organization that cultivates and advocates for sustainable projects in the fields of nutrition, soc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Project PEER",
    "purposeStatement": "Through open dialogue with incarcerated students, Project PEER hopes to support incarcerated individuals to achieve their educational goals ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Project Sunshine",
    "purposeStatement": "Project Sunshine is a service-based organization whose volunteers create and deliver free, in-hospital programs to pediatric patients and th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Psi Chi: The International Honor Society in Psychology",
    "purposeStatement": "Psi Chi is a national honor society whose purpose shall be to encourage, stimulate, and maintain excellence in scholarship of the individual...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Psi Omega Psi Dental Fraternity",
    "purposeStatement": "The objectives of this Fraternity are to maintain and advance the high standards of dentistry by instilling in its members the spirit of fra...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Psychedelic Association at The Ohio State University",
    "purposeStatement": "The Psychedelic Association is intended to bring people together with personal, social and/or academic experiences with psychedelic substanc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Psychiatry Student Interest Group",
    "purposeStatement": "The PsychSIG group strives to promote the field of psychiatry among medical students. We believe psychiatry is an important discipline becau...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Psychology Club",
    "purposeStatement": "Open to any major, Psychology Club seeks to deepen students’ understanding of the field, encourage networking with professors and other stud...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Psychology Department Graduate Student Committee for Diversity, Equity, & Inclusion",
    "purposeStatement": "The purpose of the organization shall be to enhance diversity at all levels of the department, with a particular focus on achieving a divers...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Psychology Graduate Students Organization",
    "purposeStatement": "The Psychology Graduate Student Association aims to provide opportunities for graduate students to both interact with other graduate student...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies",
      "Governance Organizations",
      "Special Interest"
    ]
  },
  {
    "name": "Public Affairs Multicultural Student Organization",
    "purposeStatement": "The purpose of the Public Affairs Minority Student Organization is to foster a safe, open, and welcoming community within the John Glenn Col...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Public Health Graduate Student Association",
    "purposeStatement": "This organization provides the opportunity for graduate students in the College of Public Health to network across divisions, learn about fa...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Public Health Student Leadership Council",
    "purposeStatement": "The Public Health Student Leadership Council (PHSLC) is a student organization that represents the general public health student body for in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Governance Organizations",
      "Special Interest"
    ]
  },
  {
    "name": "Public Interest Law Foundation at Ohio State",
    "purposeStatement": "The purpose of the Public Interest Law Foundation is to educate and increase awareness within the law school community of the many avenues t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Public Relations Student Society of America",
    "purposeStatement": "PRSSA bridges the gap between public relations professionals and Ohio State students interested in public relations by providing hands-on ex...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Puerto Rican Student Association",
    "purposeStatement": "The Puerto Rican Student Association at The Ohio State University mission shall be to meet the needs of the Puerto Rican undergraduate, grad...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Punjabi Students Association",
    "purposeStatement": "We hope to bring together Indian and Pakistani Punjabis on campus and to bridge the gap that was created in Punjab by the partition. We hope...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Puzzleology",
    "purposeStatement": "The biggest purpose of our organization is to allow students to relax while studying, not only for physical relaxation but also for mental r...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Quantitative Finance Club at Ohio State",
    "purposeStatement": "The Quantitative Finance Club combines the disciplines of computer science, math, and finance. We strive to provide an inclusive and engagin...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Quantitative Research, Evaluation, and Measurement (QREM) Student Organization",
    "purposeStatement": "The objectives of QREM-SO shall be: a.\tTo promote friendly relations between students in QREM section. b.\tTo hold functions, events, and soc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "The Quantum Club at Ohio State",
    "purposeStatement": "The OSU Quantum Club aims to create an inclusive and engaging community focused on the exploration of quantum information science and basic ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Quarter-Scale Tractor Student Design Team",
    "purposeStatement": "Through involvement in the Quarter-Scale Tractor Team, students gain practical experience in the design of drive train systems, tractor perf...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation",
      "Technology"
    ]
  },
  {
    "name": "The Queer Latine Community Pride Association",
    "purposeStatement": "The Queer Latine Community Pride Association at The Ohio State University centers the intersection of Latinidad and queerness. We are here t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Queer Pre-Med Alliance",
    "purposeStatement": "Queer Pre-Med Alliance (QPA) is an organization that provides a supportive environment for LGBTQ+ Pre-Med students. QPA aims to address heal...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "R&P: Rhythm and Paint",
    "purposeStatement": "R&P: Rhythm and Paint is an organization for students of all art levels to release stress in community by tapping into their creative outlet...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Raas at Ohio State",
    "purposeStatement": "To connect with students interested in performing Raas-Garba and compete with other collegiate teams around the nation, while creating long-...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Creative and Performing Arts",
      "Sports and Recreation",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Raas in the 614",
    "purposeStatement": "Raas in the 614 is a new raas competition at The Ohio State University. We wish to promote the art form of Garba-Raas by competing on stage....",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Racquetball - Sport Club",
    "purposeStatement": "The club is committed to the promotion of the game of racquetball, and the providing of opportunities for personal development through forma...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Radiation Oncology Interest Group",
    "purposeStatement": "The purpose of our organization is as follows: 1) to introduce the field of radiation oncology to students of The Ohio State University Coll...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Radiology Ultrasound Community of Practice",
    "purposeStatement": "The mission of the Radiology Ultrasound Community of Practice is to increase the use, accessibility, and knowledge of clinician performed fo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Rainbow Six at The Ohio State University",
    "purposeStatement": "Rainbow Six at The Ohio State University is an organization founded to cultivate a competitive and passionate community for those interested...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "RallyCap Sports",
    "purposeStatement": "To create positive sports environments fostering social integration, healthy living, and greater self-confidence for children and young adul...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Random Interactions",
    "purposeStatement": "The purpose of this organization will be to host and promote events involving Condensed Matter Physics students. This includes organizing a ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Raney/Bowen/Busch/Halloran Community Council",
    "purposeStatement": "The purpose of the Busch Halloran Hall Council is to foster community within the Busch Halloran Complex and provide opportunities for engage...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Rank The Vote Ohio State University",
    "purposeStatement": "Rank The Vote Ohio State University seeks to promote knowledge and support of Ranked Choice Voting with Ohio State students, as well as prov...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Governance Organizations"
    ]
  },
  {
    "name": "Ratio Christi",
    "purposeStatement": "To train Christians in apologetics to defend the Christian worldview.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Real Estate Law Association",
    "purposeStatement": "At the Real Estate Law Association (RELA), our purpose is to serve as a premier platform dedicated to advancing knowledge, fostering collabo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "RealLife Worship Band",
    "purposeStatement": "The RealLife band exists to shepherd students at Ohio State into worshiping God. We prompt students to acknowledge and honor God for who he ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Red Saree at Ohio State",
    "purposeStatement": "We're committed to providing healthcare awareness (focused, but not limited to, heart health) among South Asians both on Ohio State's campus...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Redefining-Athletic-Standards",
    "purposeStatement": "Redefining Athletic Standards (RAS) is more than a student organization; it's a movement that empowers Men of Color Student-Athletes, with a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Refuge",
    "purposeStatement": "To empower young adult New American (refugee, immigrant, asylee, etc) students and make higher level education more accessible through onlin...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Ethnic/Cultural",
      "Academic/College"
    ]
  },
  {
    "name": "Remote Area Medical at The Ohio State University",
    "purposeStatement": "Remote Area Medical (RAM) at The Ohio State University is a student organization dedicated to addressing health care issues in communities f...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Research Interest Group",
    "purposeStatement": "The Research Interest Group promotes medical student research by providing students with information and opportunities to participate in res...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Residence Halls Advisory Council",
    "purposeStatement": "The Residence Halls Advisory Council (RHAC) serves as the governing organization for all on-campus Ohio State students and community council...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Revive Students",
    "purposeStatement": "Revive Students is a Christian fellowship with a vision to create an Acts 2 community as described in the Bible, where OSU students from all...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Rhetoric Society at The Ohio State University",
    "purposeStatement": "The Ohio State University chapter of Rhetoric Society of America is a community of rhetoricians, providing support for rhetorical scholarshi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Rho Chi Society Upsilon Chapter",
    "purposeStatement": "The purpose of the Upsilon Chapter shall be to promote intellectual excellence, leadership, fellowship, critical inquiry and high attainment...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "Rhythm Games Club",
    "purposeStatement": "Our organization will help bring together students interested in rhythm games and organize competitive and casual events around these games.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Ride for World Health",
    "purposeStatement": "Ride for World Health brings together medical students, physicians, activists, and community members to produce a global health education pr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "The RNA Biology Student Organization",
    "purposeStatement": "The purpose of this organization is to provide opportunities to bring together individuals in labs belonging to the Ohio State University Ce...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Rock City On Campus",
    "purposeStatement": "Rock City On Campus at The Ohio State University provides opportunities for students to gather, learn, and grow together on campus, equippin...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Rock Climbing Club at Ohio State",
    "purposeStatement": "To better our climbing abilities as a team and train our members to climb outdoors and compete in local and regional competitions if they ch...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Rock Music Club",
    "purposeStatement": "The purpose of Rock Music Club shall be to cultivate discussion about rock music, spread overall awareness of the genre, and have an open fo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Roller Hockey Club at The Ohio State University - Sport Club",
    "purposeStatement": "To represent Ohio State at the highest level in collegiate roller hockey and compete every year for a national title.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Romanian Club at Ohio State",
    "purposeStatement": "We believe that it's important for students at OSU who are interested in Romanian culture to have a community that they can relate to. We wa...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Romophos: A Sophomore Class Honorary",
    "purposeStatement": "Romophos is a sophomore honorary organization founded on the principles of leadership, scholarship, and service.  Our purpose is to serve th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Rotaract Club",
    "purposeStatement": "Rotaract Club is a Rotary International-sponsored service club for young men and women focused on local and international service and profes...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "RUACH - Cultural Israel Programing",
    "purposeStatement": "The purpose of RUACH is to promote Jewish celebrations and learning in the Ohio State Jewish community and to advance cultural discussion an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual"
    ]
  },
  {
    "name": "The Rubik's Cube Club at Ohio State",
    "purposeStatement": "Purpose: To provide organization for a community of students interested in solving various twisty-puzzles (i.e. the Rubik’s Cube). The club ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Rugby - Women's - Sport Club",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Rugby Club - Sport Club",
    "purposeStatement": "The OSURFC was established to provide a competitive rugby experience to student athletes at The Ohio State University. The OSURFC is also de...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Running Club at The Ohio State University",
    "purposeStatement": "The Running Club at The Ohio State University gathers students who enjoy running any distance from the 60-meter dash to marathons (not to me...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "The Running Outreach Initiative",
    "purposeStatement": "The purpose of this student organization is as follows: (1) To expose elementary, middle, and/or high school students, especially those from...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Rural Health Initiative",
    "purposeStatement": "The Rural Health Initiative of the Ohio State University College of Medicine (“The Consortium”) shall serve to \tA.) Prepare the students of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Russian Language and Culture Club",
    "purposeStatement": "To create a community for students of Russian language and culture regardless of race or family history. To increase student engagement, inc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Russian Student Association",
    "purposeStatement": "To bring together Ohio State students who are interested in the culture, history and traditions of the former Soviet Union countries, to pro...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "SACNAS Chapter",
    "purposeStatement": "1)  To further the work of,  improve the effectiveness of, and enhance the public understanding of an appreciation for Hispanics, Chicanos, ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Saddle and Sirloin Club",
    "purposeStatement": "The purpose of this organization shall be to stimulate interest in the animal and meat industries with the perpetuation of the traditions an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Sahajan Dance Team",
    "purposeStatement": "The Sahajan dance team aims to blend diverse dance styles, cultures, and expressions through fusion dance, fostering artistic innovation, cu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Sailing - Sport Club",
    "purposeStatement": "To challenge Ohio State students to practice, compete, and sail at the highest level possible.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Saint Paul's Outreach Catholic Student Group",
    "purposeStatement": "Our purpose is to build Catholic community by forming young men and women into disciples of Christ through a life of sacraments, prayer, scr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Special Interest"
    ]
  },
  {
    "name": "Saint Thomas More Society",
    "purposeStatement": "Spiritual Growth and Moral Leadership. STMS will host faith formation, service, fellowship, and topical Catholic speaking events for the Mor...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Religious/Spiritual",
      "Special Interest"
    ]
  },
  {
    "name": "Salsa Club",
    "purposeStatement": "The purpose of this club is to create student interest and participation in salsa and other Latin dances, to create awareness of this aspect...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Sankalpa",
    "purposeStatement": "Sankalpa is a student movement started in Columbus, Ohio mostly by students of The Ohio State University.   The aim of Sankalpa is to undert...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "SAPS",
    "purposeStatement": "SAPS (Sexual Assault Prevention & Support) is a student organization at The Ohio State University dedicated to promoting sexual violence pre...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Saudi Students Organization",
    "purposeStatement": "Our purpose is to facilitate the development of social support networks among Saudi students attending OSU and/or other institutions in the ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Save the Children at The Ohio State University",
    "purposeStatement": "Save the Children's chapter will work to provide children in the U.S. and around the world the chance to grow up healthy, educated, and safe...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Scare Bears",
    "purposeStatement": "Scare Bears wishes to bring together people who love anything and everything spooky! From horror movies to ghost stories, this group partici...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Scarlet and Grace Notes",
    "purposeStatement": "Scarlet and Grace Notes is an entirely student-run a cappella group that strives to practice and perform a wide range of music for the stude...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Scarlet and Gray (Taylor's Version)",
    "purposeStatement": "Scarlet and Gray (Taylor’s Version) brings Swifties together to share in their love of all things Taylor Swift.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Scarlet and Gray Anime",
    "purposeStatement": "To foster an appreciation of Japanese popular culture through showings of Japanese animated films (\"Anime\") and related popular media.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Scarlet and Gray Campus Weather Forecasting Team",
    "purposeStatement": "We strive to help our members gain valuable experience by creating weather forecasts for the campus. This allows members to strengthen knowl...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Scarlet and Gray Sports Radio",
    "purposeStatement": "Mission Statement: Scarlet and Gray Sports Radio Department  The mission of Ohio State Student Sports Radio is to create beneficial opportun...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Sports and Recreation",
      "Technology"
    ]
  },
  {
    "name": "Scarlet and Guard",
    "purposeStatement": "Scarlet & Guard seeks to bring students together through the art of spinning. We want to help beginners, intermediates, and experts feel exc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Scarlet and Pick Guitarists",
    "purposeStatement": "Scarlet and Pick Guitarists (SPG) is THE premier guitar group at Ohio State. Any guitarist, pro or newbie, is welcome to join our armada (ev...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Scarlet Fever",
    "purposeStatement": "Scarlet Fever was created to provide a low-key outlet for a cappella musical expression.  It exists to provide the chance for students to ge...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Scarlet Investment Group",
    "purposeStatement": "The Scarlet Investment Group is focused on the intersection of finance & technology. With two teams, one targeted towards fundamental invest...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Scarlet Script",
    "purposeStatement": "Creating the opportunity to develop experiences with choral and dance performances, providing quality entertainment to the students and staf...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Scarlette Magazine",
    "purposeStatement": "Showcase Ohio State University's individuality through fashion, art, and words. Inspire our readers and deliver new perspectives of the fash...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "School of Communication Graduate Student Organization",
    "purposeStatement": "The purpose of the School of Communication Graduate Student Organization is to support the academic and professional development goals of gr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "School of Earth Sciences Graduate Student Club",
    "purposeStatement": "The purpose of this organization is to foster a positive and productive School of Earth Sciences (SES) graduate student experience by provid...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations"
    ]
  },
  {
    "name": "School of Health and Rehabilitation Sciences Diversity, Equity, and Inclusion Committee",
    "purposeStatement": "This committee is comprised of student leaders from many different divisions within the School of Health and Rehabilitation Sciences (HRS) t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "School of Music Double Major Alliance",
    "purposeStatement": "The School of Music Double Major Alliance at Ohio State is an association of Ohio State School of Music Double Major students created to edu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Schottenstein Student Center",
    "purposeStatement": "Schottenstein Student Center is a Jewish student organization that caters to all students regardless of background, affiliation or level of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "SciAccess Zenith Mentorship Program",
    "purposeStatement": "Our organization provides virtual mentorship for blind and low vision (BLV) students (grades 8-12) from Ohio, across the country, and around...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Science Fiction/Fantasy Creative Writing Group",
    "purposeStatement": "The purpose of this organization is to provide a safe and collaborative writing environment for those who like to write in the Science Ficti...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Science Olympiad at The Ohio State University",
    "purposeStatement": "We are a group of people who are passionate about Science Olympiad and want to continue our journey with this brilliant organization. Our in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Technology",
      "Special Interest"
    ]
  },
  {
    "name": "Scientific Journal Club",
    "purposeStatement": "To recommend and discuss scientific articles in a group setting, as well as get better at reading science based writing.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Scientific Thinkers Student Organization",
    "purposeStatement": "Scientific Thinkers serves as outreach to elementary schools within Columbus, OH, for the advancement and support of first generation and un...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Score Study Club",
    "purposeStatement": "The purpose of the Score Study Club is to practicing score studying and to improve our skills in score studying. We are also planning to hav...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Secular Student Alliance at The Ohio State University",
    "purposeStatement": "The object of this Society shall be to provide for secular students an open and supportive forum for topics important to the secular communi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Security & Intelligence Club",
    "purposeStatement": "Our mission is to foster networking and professional development for individuals interested in the Security and Intelligence field. In pursu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "SEDS Coalition",
    "purposeStatement": "The purpose of this organization is to act as Ohio State’s chapter of the national organization Students for the Exploration and Development...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Senior Social",
    "purposeStatement": "To combat social isolation in older adults through intergenerational activities that promote companionship and increased well-being",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Service, Education, and Activism in Dentistry",
    "purposeStatement": "The purpose of SEAD shall be to aid the effort of increasing the number of minority and underrepresented individuals that have the ability t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "SERVitecture",
    "purposeStatement": "It shall be the purpose of SERVitecture to encourage and promote Knowlton School of Architecture student and faculty involvement through com...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest",
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "The Sexual Health and Reproductive Education Organization",
    "purposeStatement": "To advocate for and promote comprehensive, inclusive, and medically accurate sexual health education for students in grades K-12, The Ohio S...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "SHADES (Buckeye Chapter)",
    "purposeStatement": "SHADES is dedicated to fostering connections among Same-Gender Loving (SGL), Lesbian, Gay, Bisexual, Trans*, Queer/Questioning (LGBTQ), and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Shades Of Animal Sciences",
    "purposeStatement": "It shall be the purpose of Shades of Animal Sciences to serve as a meeting place for the diverse paths of Animal Sciences and as a casual co...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "SHEROS at The Ohio State University",
    "purposeStatement": "The purpose of this organization is to provide a safe space where female student-athletes can learn and develop the essential skills that wi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Shining Like Stars Astronomy Interest Organization",
    "purposeStatement": "Shining Like Stars Astronomy Interest Organization is committed to providing an environment where all students who are interested in celesti...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Shining Like Stars Astronomy Interest Organization",
    "purposeStatement": "Shining Like Stars Astronomy Interest Organization is committed to providing an environment where all students who are interested in celesti...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Technology",
      "Academic/College"
    ]
  },
  {
    "name": "SIAM Student Chapter",
    "purposeStatement": "To meet the needs of students interested in finding out how math can cross multiple disciplines, departments, and careers.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "The Sierra Student Coalition",
    "purposeStatement": "The Sierra Student Coalition works to bring the mission of the Sierra Club, \"Explore, Enjoy, and Protect the Planet,\" to our campus. We purs...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Sigma Alpha Epsilon",
    "purposeStatement": "The mission of Sigma Alpha Epsilon is to promote the highest standards of friendship, scholarship, and service for our members based upon th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Sigma Alpha Iota",
    "purposeStatement": "TO FORM chapters of women college students and alumnae who have a sincere interest in music.  TO UPHOLD the highest standards of music.  TO ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Sigma Chi Fraternity",
    "purposeStatement": "The spirit of Sigma Chi, as conceived by the Founders more than 100 years ago yet visible and alive today, is based on the theory that frien...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Sigma Delta Pi National Collegiate Hispanic Honor Society",
    "purposeStatement": "The purposes of this society are:  1. To honor those who attain excellence in the study of the Spanish language and in the study of the lite...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Ethnic/Cultural",
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Sigma Epsilon Phi - The Greek and Orthodox Students of The Ohio State University",
    "purposeStatement": "Sigma Epsilon Phi is a co-ed social \"fratority\" that promotes the principles of brotherhood and sisterhood in order to create an outlet for ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Sigma Gamma Rho Sorority Inc., Delta Phi Chapter",
    "purposeStatement": "Sigma Gamma Rho Sorority's aim is to enhance the quality of life within the community. Public service, leadership development and education ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Sigma Gamma Tau Aerospace Engineering Honorary",
    "purposeStatement": "Sigma Gamma Tau is established to recognize and honor those individuals in the field of aeronautics and astronautics who have through schola...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College"
    ]
  },
  {
    "name": "Sigma Lambda Gamma National Sorority Inc.",
    "purposeStatement": "The purpose of Sigma Lambda Gamma sorority shall be primarily one of promoting standards of excellence in morality ethics and education. Fur...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Sigma Phi Epsilon Fraternity",
    "purposeStatement": "Sigma Phi Epsilon is not a typical fraternity. Our brothers are leaders, athletes, scholars, and gentlemen on campus and in the community. W...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Sigma Phi Lambda",
    "purposeStatement": "Sigma Phi Lambda (SF?) is a Christian sorority that strives to glorify God by providing a source of fellowship for college women who sincere...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Sigma Pi Sigma: The Physics Honor Society",
    "purposeStatement": "Sigma Pi Sigma exists to honor outstanding scholarship in physics; to encourage interest in physics among all students; to promote an attitu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College"
    ]
  },
  {
    "name": "Sigma Tau Delta, International English Honor Society",
    "purposeStatement": "As an international organization, \"Sigma Tau Delta's central purpose is to confer distinction upon students of the English language and lite...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Honoraries/Honor Societies",
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Silver Wings - Col. Francis J. McGouldrick Chapter",
    "purposeStatement": "Silver Wings (SW) is a national, co-ed, professional organization dedicated to creating proactive, knowledgeable, and effective civic leader...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Simply Green",
    "purposeStatement": "The purpose for this club is to create a larger awareness on composting and sustainability at an individual and larger level. This includes ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Sister Accord at The Ohio State University",
    "purposeStatement": "The goals of the Sister Accord are:  1. to educate women for career success  Through workshops and biweekly meetings 2. foster the POWER o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Ski & Board Team - Sport Club",
    "purposeStatement": "Alpine Ski and Snowboard Team at the Ohio State University Mission Statement:  \tThe Alpine Ski and Snowboard Team at the Ohio State Universi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Skills4Good",
    "purposeStatement": "Skills4Good is an upcoming organization that intends to tackle the issues of lack of access for underprivileged children via a different asp...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "SKY at The Ohio State University",
    "purposeStatement": "Our purpose is to see every Buckeye smile! SKY @ OSU is dedicated to creating a stress-free zone for students of all backgrounds!   We sprea...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "SKY Engineering",
    "purposeStatement": "To promote mental wellness practices including breathwork, meditation, and yoga within the College of Engineering. To reach out to engineeri...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Sky Sports Club at The Ohio State University",
    "purposeStatement": "Sky Sports Club at the Ohio State University strives to provide unique opportunities for students who want to participate in skydiving, zipl...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Slash Coding Club",
    "purposeStatement": "SCC is dedicated to fostering a collaborative environment for Chinese students aspiring to embark on careers in Computer Science and Softwar...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Slavic and East European Literature and Culture Forum",
    "purposeStatement": "This organization promotes scholarship on topics pertaining to Slavic and East European literature and culture and strives to advance schola...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Smiles for Schools",
    "purposeStatement": "Smiles for Schools is a non-profit organization consisting of dental professional students from The Ohio State University College of Dentist...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Smith-Steeb Community Council (Board of Activities for Smith-Steeb)",
    "purposeStatement": "Our purpose is to incorporate the four pillars of Residence Life into continued programming so that students may grow in a community that th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Snehalaya at The Ohio State University",
    "purposeStatement": "Snehalaya (which means Home of Love in Hindi) is an Indian-based organization that provides relief to the country’s most marginalized groups...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Soccer - Women's - Sport Club",
    "purposeStatement": "The Ohio State Women's Soccer Club fills the gap between recreational and Varsity soccer.  We are a competitive and dedicated team playing i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The Soccer Indoor Club at The Ohio State University",
    "purposeStatement": "The purpose of this club is to provide an experience for those looking for something more competitive than intramurals, but less competitive...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Social Behavior Interest Group",
    "purposeStatement": "Social Behavior Interest Group (SBIG)’s goal is to broadly disseminate the latest social psychological research from across the nation to th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Social Cognition Research Group",
    "purposeStatement": "The purpose of the organization shall be to serve as a dissemination point for current research in the area of social cognition. In addition...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Social Reading Club",
    "purposeStatement": "We are here to provide a laidback environment for avid readers, those looking to get back into reading, and everyone in between. We want to ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Special Interest"
    ]
  },
  {
    "name": "Society for Biological Engineering",
    "purposeStatement": "Connecting people...  With the launch of the Society for Biological Engineering, AIChE endeavors to be the professional association of choic...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Society for Ecological Restoration at The Ohio State University",
    "purposeStatement": "Our mission is to enhance ecosystem functioning within the central Ohio landscape by promoting the return of ecosystems to a more natural st...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Society for Mathematical Logic and Foundational Studies",
    "purposeStatement": "The purpose of The Society for Mathematical Logic and Foundational Studies is to create a forum for dialogue amongst graduate students on th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Society for Philosophy of Science",
    "purposeStatement": "The purpose of the Society for Philosophy of Science is to create a forum for discussing issues in philosophy of science. Philosophy of scie...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Society for the History of Analytic Philosophy",
    "purposeStatement": "The purpose of the Society for the History of Analytic Philosophy is to create a forum for discussing issues salient in the fertile period o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Society of Asian Scientists and Engineers",
    "purposeStatement": "SASE as an organization strives to achieve 3 goals: 1)  Preparing students for success and leadership globally 2) Raising cultural awareness...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Society of Environmental Engineers",
    "purposeStatement": "The Society of Environmental Engineers is a professional organization committed to bringing together students with a common interest in envi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Society of Hispanic Professional Engineers",
    "purposeStatement": "The Society of Hispanic Professional Engineers was founded in 1974 in Los Angeles, California by a group of engineers who made it their obje...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Society of Physics Students",
    "purposeStatement": "The Society of Physics Students at Ohio State exists to build a stronger community among students who are interested in the physical science...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Society of Sisters",
    "purposeStatement": "Society of Sisters functions to unite young women on The Ohio State University’s campus, promote a collaborative sense of sisterhood, and fo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Society of Women Engineers",
    "purposeStatement": "Empower women to achieve their full potential in careers as engineers and leaders; expand the image of the engineering and technology profes...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Technology"
    ]
  },
  {
    "name": "Sociology and Criminology Club",
    "purposeStatement": "Sociology and Criminology Club is a club for students majoring in Sociology and/or Criminology or those simply interested in the field. Our ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Softball Club at Ohio State - Sport Club",
    "purposeStatement": "The Sport Club program at Ohio State is designed to serve individual interests in sports and recreational activities. Participation in the p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Software Engineering Club",
    "purposeStatement": "The purpose of the Software Engineering Club (DEV) is to foster an inclusive and engaging community of aspiring Computer Science students th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Soil Water Environmental Lab Student Association",
    "purposeStatement": "To foster a greater sense of community and support within the School of Environment and Natural Resources distributed lab network by providi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Solar Education & Outreach",
    "purposeStatement": "We aim to educate ourselves, fellow students, and the community about sustainable energy and introduce the latest solar initiatives emerging...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Special Interest",
      "Technology",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Somali Health Initiative for Nutrition Education",
    "purposeStatement": "SHINE strives to provide fun health classes in the fall to eighth graders at Focus Learning North Academy in Columbus which has a large Soma...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Somali Students' Association",
    "purposeStatement": "The purpose of this organization is to meet the academic, social, and cultural needs of the Somali students at OSU. It is also to promote un...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Sound of Science",
    "purposeStatement": "Sound of Science is an auditioned a cappella ensemble of OSU students.  The name originated from the first members of the group, who were al...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "South Asia Graduate Study Association",
    "purposeStatement": "Our group aims to foster an intellectual space for graduate students working on South Asia to discuss their research, coursework, and writin...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "South Asian Men's Health Organization",
    "purposeStatement": "SAMHO is an organization dedicated to the health and wellness of South Asian men. We look to educate and reduce stigmas surrounding men's he...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "South Asians in Cognitive Science",
    "purposeStatement": "SAICS's mission is to empower South Asians in cognitive science, fostering a community among current professionals and students. We aim to i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Spanish and Portuguese Club",
    "purposeStatement": "The purpose of the organization is to promote and practice the Spanish and Portuguese languages, appreciating the cultures associated.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Spanish and Portuguese Creative Writing Group",
    "purposeStatement": "1.\tTo boost a creative space within the SPPO Department open to all students at OSU who want to write in Spanish and/or Portuguese.  2.\tTo p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Awareness/Activism",
      "Creative and Performing Arts",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Spanish and Portuguese Graduate Student Organization of The Ohio State University",
    "purposeStatement": "The purpose of this group is to provide a higher level of Spanish and Portuguese culture, history, and art awareness at the University as we...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Special Care Dentistry Association",
    "purposeStatement": "The purpose of this organization is to increase awareness, promotion, and education to students regarding Special Care Dentistry. The goal i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Special Olympics-The Ohio State University",
    "purposeStatement": "The Special Olympics OSU group is an organization whose purpose is to spread awareness about the Special Olympics national organization- spe...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Speech and Debate Team at The Ohio State University",
    "purposeStatement": "The Speech and Debate Team at the Ohio State University comprises both the school's competitive speech and debate teams. We represent the un...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "SPHINX Senior Class Honorary",
    "purposeStatement": "To foster a spirit which will ever remind us of the loyalty we owe our university and serve to preserve inviolate our friendship during our ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "Spirit for All",
    "purposeStatement": "This is a spirit team of students with and without disabilities that shine the light on the importance of inclusion. This team goal is to pr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Spongebob Squarepants Club",
    "purposeStatement": "Our organization will create a sense of community among Spongebob lovers. We want to analyze the cultural impacts the show has made on our g...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Community Service/Service Learning",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Sport and Exercise Psychology Club",
    "purposeStatement": "To educate and promote ways to develop healthier mindsets in both sports and everyday life. The club also expects to lend a helping hand to ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Honoraries/Honor Societies",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Sport Management Association",
    "purposeStatement": "The purpose of the Sport Management Association shall be to provide professional development opportunities as well as to enhance the educati...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Sports Analytics Association",
    "purposeStatement": "We aim to foster student interest in the application of analytical methods to sports, to widen the scope of sports analysis, and to provide ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Sports and Recreation",
      "Technology",
      "Academic/College"
    ]
  },
  {
    "name": "Sports and Entertainment Law Association",
    "purposeStatement": "To foster an atmosphere of networking and education, in the areas of Sports and Entertainment, among law students who want to pursue careers...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Special Interest",
      "Sports and Recreation",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Sports and Society Initiative: Student Chapter",
    "purposeStatement": "The Sports and Society-Student Chapter aims to provide students who are interested in pursuing a career in sports with the opportunity to me...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Sports Ball?",
    "purposeStatement": "We are an accepting space for people to learn about and attend sporting events at OSU. It can be difficult for minorities to get involved in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Sports Card Club at Ohio State",
    "purposeStatement": "The purpose of the Sports Card Club at Ohio State is to educate its members about the growing hobby of sports cards.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Sports Dentistry Club at Ohio State",
    "purposeStatement": "To educate The Ohio State College of Dentistry’s students on the presence of sports dentistry as a component of the dental field, furthering...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Sports Investors",
    "purposeStatement": "Sports Investors purpose is to provide a community for all who are interested in the Sportsbook industry to bring the analytics and sports c...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Sports Medicine Interest Group",
    "purposeStatement": "The purpose of this group is to provide sports medicine scholarship, mentorship, and fellowship opportunities to Ohio State College of Medic...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Sports Vision Club",
    "purposeStatement": "The Ohio State Sports Vision Club exists to provide students extra-curricular enrichment in the Sport Vision aspect of optometry; specifical...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Sports and Recreation",
      "Technology"
    ]
  },
  {
    "name": "Sportsmanship Council at The Ohio State University",
    "purposeStatement": "The Mission of Sportsmanship Council at The Ohio State University, or SpoCo, is to establish good sportsmanship as a continuing tradition at...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Spread the Love Projects at Ohio State",
    "purposeStatement": "Our club focuses on advocating for families struggling with pediatric medical expenses. We understand the enormous stress parents and famili...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Sri Lankan Association",
    "purposeStatement": "The purpose of the Sri Lankan Association is to provide a support system to Sri Lankan students and the community, to create a network and r...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The Star Wars Club at The Ohio State University",
    "purposeStatement": "The purpose of The Star Wars Club at The Ohio State University is to create a dynamic and safe environment for all fans of Star Wars alike t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Statistics and Biostatistics Graduate Student Association",
    "purposeStatement": "The purpose of this organization is to advocate on behalf of graduate students in the Statistics department and Biostatistics division and o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Steel Bridge Team",
    "purposeStatement": "The design and fabrication of a steel bridge to meet standards established by The American Institute of Steel Construction which will be use...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts",
      "Technology",
      "Special Interest"
    ]
  },
  {
    "name": "STEM in Medicine",
    "purposeStatement": "To provide support and resources for students and clinicians who are interested in STEM in medicine. Our primary goal is to help students de...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "STEM2TORS at Ohio State",
    "purposeStatement": "STEM2TORS strives to make the goals of all Ohio State students in the STEM fields of medicine and engineering more attainable. STEM2TORS’s c...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Street Medicine at Ohio State",
    "purposeStatement": "We are a student organization that aims to increase quality healthcare services and resources for local unhoused individuals. Our goal is to...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Structural Engineers Association of Ohio",
    "purposeStatement": "To advance and advocate excellence in structural engineering and provide direct links to the industry of Structural Engineering.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Student Academy of Audiology",
    "purposeStatement": "The mission of The Ohio State University Chapter of SAA is to serve as a collective voice for students within the chapter area and to advanc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Student Advocates for Sexual Health Awareness",
    "purposeStatement": "SASHA's goal is to educate the student body about sexual health in all its forms. We provide comprehensive, inclusive, and medically accurat...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Student Affiliates in School Psychology - The Ohio State University Chapter",
    "purposeStatement": "The purpose of the Ohio State Chapter of SASP is to develop in prospective members an understanding of the organization; provide for the mem...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Student Association of Specialty Pharmacy",
    "purposeStatement": "The purpose of Chapter is to serve as a presence of NASP at The Ohio State University. Chapter shall promote student engagement in specialty...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Student Bar Association",
    "purposeStatement": "The purpose of this organization shall be: 1.\tTo represent the issues, opinions, and ideas of all SBA members to the faculty, staff and admi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations",
      "Academic/College"
    ]
  },
  {
    "name": "The Student Chapter of the American Academy of Pediatric Dentistry at The Ohio State University",
    "purposeStatement": "The purpose of this organization is to initiate and promote a better understanding and appreciation of dentistry for children among dental s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Student Chapter of The American Academy of Optometry at The Ohio State University",
    "purposeStatement": "The purpose of this organization is to serve as an extension of The American Academy of Optometry to the students at The Ohio State Universi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Student Chapter of the American Association of Equine Practitioners",
    "purposeStatement": "SCAAEP of The Ohio State University is associated with the AAEP (American Association of Equine Practitioners). With its many members in all...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Student Chapter of the American Association of Feline Practitioners",
    "purposeStatement": "To introduce veterinary students to the goals and objectives of the AAFP and help interested students augment their learning in feline medic...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Student Chapter of the American College of Veterinary Internal Medicine",
    "purposeStatement": "The OSU SCACVIM organization is dedicated to helping students explore the world of veterinary internal medicine. SCACVIM offers veterinary s...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Student Chapter of the American College of Veterinary Pathologists at The Ohio State University",
    "purposeStatement": "To educate veterinary medical professional students about the field of veterinary pathology and the opportunities within it.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Student Chapter of the American Society of Heating, Refrigerating, and Air-Conditioning Engineers, INC.",
    "purposeStatement": "The objectives of Student Chapter of the American Society of Heating, Refrigerating, and Air-Conditioning Engineers (ASHRAE) are exclusively...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Student Chapter of the American Society of Laboratory Animal Practitioners at The Ohio State University",
    "purposeStatement": "The purpose of the Student Chapter of the American Society of Laboratory Animal Practitioners is to foster educational activities in the vet...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Student Chapter of the American Society of Landscape Architects",
    "purposeStatement": "The mission of SCASLA, the Student Chapter of the American Society of Landscape Architects, is to provide extracurricular activities for lan...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Student Chapter of the Association of Shelter Veterinarians",
    "purposeStatement": "The objectives of this organization shall be: To facilitate extracuricular activities designed for students interested in pursuing a career ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Student Chapter of the Dental Hygienists' Association at The Ohio State University",
    "purposeStatement": "The objectives of this Organization shall be to cultivate, promote, and sustain the art and science of dental hygiene, to represent and safe...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Student Chapter of the Foundation for Veterinary Dentistry",
    "purposeStatement": "Our purpose is to provide students an opportunity to further explore the field of veterinary dentistry through wet labs, educational lecture...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Student Chapter of the Pride Veterinary Medical Community",
    "purposeStatement": "To foster acceptance and inclusivity for people of all sexual orientations and gender identities within the veterinary profession.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College"
    ]
  },
  {
    "name": "Student Christian Fellowship",
    "purposeStatement": "To prepare leaders and followers to learn, love, and lead The Ohio State University and surrounding community in light of the Gospel of Jesu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Student Council of the College of Veterinary Medicine",
    "purposeStatement": "The purpose of student council is to serve as a liason between the students and faculty as well as acting as a judiciary body as specified i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations"
    ]
  },
  {
    "name": "Student Dietetic Association",
    "purposeStatement": "The purpose of this organization is to promote the dietetic profession through meetings, community involvement, and organizational unity rel...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Student Financial Planning Association at The Ohio State University®",
    "purposeStatement": "The purpose of the Student Financial Planning Association is to provide an environment that allows for the development and enhancement of sk...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Student Growing Collaborative",
    "purposeStatement": "This group will serve as the student face and organizational foundation of Ohio State's Student Farm, making decisions related to farm manag...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Student Interest Group in Neurology",
    "purposeStatement": "The purpose of this organization is to increase medical students’ knowledge about neurology, increase medical students’ level of interest in...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Student Leadership Advocates",
    "purposeStatement": "The Student Leadership Advocates are a group of Ohio State student leaders who work together to positively impact and empower student life a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Student League of Independent Ceramists",
    "purposeStatement": "Our purpose is to educate ourselves and any interested persons within the university in the ceramic arts. We intend to hold events, support ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Academic/College"
    ]
  },
  {
    "name": "Student Linguistic Association",
    "purposeStatement": "The Student Linguistic Association is an association of graduate students in linguistics.  The association is designed to serve the academic...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations"
    ]
  },
  {
    "name": "Student National Dental Association",
    "purposeStatement": "Minority populations in America, namely African American and Hispanic, are growing faster than any other population group. However, this gro...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Student National Medical Association",
    "purposeStatement": "The Student National Medical Association is committed to supporting current and future underrepresented minority medical students, addressin...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Student National Pharmaceutical Association",
    "purposeStatement": "SNPhA shall have the following purposes: A.\tTo offer student members the opportunity to develop leadership and professional skills. B.\tTo ed...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Student Nurse Midwives",
    "purposeStatement": "As future nurse midwives we have an exciting career ahead of us serving birthing people and their families. To prepare us for this challengi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Student Occupational Therapy Association at Ohio State",
    "purposeStatement": "The purposes of this organization shall be to foster the spirit of professional unity among students; to provide awareness of an affiliation...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Student Organization for Neuropsychology in Clinical Science",
    "purposeStatement": "The Student Organization for Neuropsychology in Clinical Science (SONICS) provides a forum for the discussion of topics related to clinical ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Student Organization Success Coaches",
    "purposeStatement": "Student Organization Success Coaches provide direct support to the student organization community by consulting with student leaders, provid...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Student Philanthropy Council at The Ohio State University",
    "purposeStatement": "The mission of the Student Philanthropy Council at the Ohio State University is to ensure that every student at The Ohio State University is...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Governance Organizations",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Student Printmakers' Association",
    "purposeStatement": "The SPA is an organization that supplies students with opportunities to explore diverse printmaking techniques via guest lectures, workshops...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Student Professional Development Association",
    "purposeStatement": "The purpose of the Student Professional Development Association is to engage graduate students working in the Department of Recreational Spo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Student Professionalism and Ethics Association in Dentistry",
    "purposeStatement": "The Student Professionalism and Ethics Association in Dentistry is a national, student driven association that was established to promote an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Student Society of Health-System Pharmacists",
    "purposeStatement": "The Student Society of Health-System Pharmacists (SSHP) strives to educate pharmacy students about career opportunities for pharmacists in h...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Student Veterans Association at The Ohio State University",
    "purposeStatement": "SVAOSU is the premier student organization leading service, research, programs, and advocacy for veterans at the Ohio State University. The ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Student Volunteer Optometric Services to Humanity",
    "purposeStatement": "The primary mission of SVOSH is to facilitate the provision of vision care worldwide to people who can neither afford nor obtain such care.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Student-Alumni Council",
    "purposeStatement": "Student-Alumni Council is dedicated to enhancing the connection among Buckeyes past, present and future. We work to create a university that...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Governance Organizations"
    ]
  },
  {
    "name": "Student-Athletes in Business at The Ohio State University",
    "purposeStatement": "Student-Athletes in Business aims to bridge the gap between the Ohio State student-athlete community and the Fisher College of Business comm...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations"
    ]
  },
  {
    "name": "Students Advocating for Food Equity",
    "purposeStatement": "To address and take action against food inequity through service, education, and advocacy. SAFE will give students the opportunity to help t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Students Consulting for Non-Profit Organizations",
    "purposeStatement": "Students Consulting for Non-Profit Organizations (SCNO) is a national organization of undergraduate students committed to developing communi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Students Demand Action at The Ohio State University",
    "purposeStatement": "Students Demand Action at The Ohio State University is an organization that was born out of the wave of civic engagement among young adults ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Students for a Democratic Society at The Ohio State University",
    "purposeStatement": "SDS at Ohio State is a progressive, multi-issue organization of student activists that leads and supports initiatives to win social change. ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest",
      "Community Service/Service Learning",
      "Governance Organizations"
    ]
  },
  {
    "name": "Students for Better Schools and Futures",
    "purposeStatement": "Students for Better Schools & Futures aims to advance student development in the fields of advocacy and education policy, as well as promote...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Students for Bhopal",
    "purposeStatement": "To educate the OSU community about the Bhopal Gas Tragedy and work with the survivors to get justice.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism"
    ]
  },
  {
    "name": "Students for Diversity in Education through Service",
    "purposeStatement": "Students for Diversity in Education through Service (SDES) is committed to providing service and networking opportunities for LGBTQ students...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Students for Integrative Medicine",
    "purposeStatement": "This group exists to promote medical student awareness of complementary and alternative medicine (CAM) beyond what is normally taught in the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Students for Justice in Palestine",
    "purposeStatement": "The Ohio State University Student’s for Justice in Palestine is a democratic student organization, whose main focus is the liberation and se...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Ethnic/Cultural",
      "Governance Organizations",
      "Special Interest"
    ]
  },
  {
    "name": "Students for Life at Ohio State",
    "purposeStatement": "The mission of Ohio State Students for Life is to promote the dignity of the human person from the moment of conception to natural death, su...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Students for Recycling",
    "purposeStatement": "It shall be the purpose of Students for Recycling to build a coalition of student organizations to promote recycling, to raise awareness abo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Students for Salt",
    "purposeStatement": "Students for Salt is a group of students who work together to help Salt Company reach, serve, and influence Ohio State University. The Salt ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Students for Sustainable Fashion",
    "purposeStatement": "Sustainable Fashion at The Ohio State University serves as a way for students interested in environmental science and fashion to focus on ed...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Students for the Advancement of Microbiology",
    "purposeStatement": "The Students for the Advancement of Microbiology is a student organization whose primary purpose is to promote the advancement of its member...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations"
    ]
  },
  {
    "name": "Students Interested in Student Affairs",
    "purposeStatement": "The mission and purpose of the Students Interested in Student Affairs (SISA) organization is to support the mission of higher education with...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Students of the American Academy of Veterinary Nutrition",
    "purposeStatement": "1. To provide a forum of discussion and exchange of information on matters of common interest as applied to the field of nutrition and its r...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Students of the American Veterinary Medical Association",
    "purposeStatement": "The Students of the American Veterinary Medical Association (SAVMA) represents the American Veterinary Medical Association’s presence on the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Students of The Library",
    "purposeStatement": "To use The OSU community to gather funds, donations, and other things in order to help the Columbus Public Libraries and the community that ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Students Supporting People with Down Syndrome",
    "purposeStatement": "Students Supporting People with Down Syndrome strives to heighten awareness, educate students, and advocate on behalf of individuals with Do...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Students With Children at The Ohio State University",
    "purposeStatement": "The purpose of Students with Children (SWC) at the Ohio State University is to bring awareness and provide advocacy to the litany of barrier...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Studio Dance at Ohio State",
    "purposeStatement": "Studio Dance will offer dance classes multiple days a week, like a dance studio. Members will be able to pick and choose the classes they wo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Stylez Dance Group",
    "purposeStatement": "Stylez Dance Group is a group of students with diverse dance training and experience who seek to push the boundaries of hip-hop by incorpora...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "The Sundial Humor Magazine",
    "purposeStatement": "Our purpose is to bring laughter to The Ohio State University through written comedy and improve the comedy writing skills of our membership...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Sunny Side Up",
    "purposeStatement": "Our main message “is that it is okay not to be okay” and we emphasize diversity and how mental health is stigmatized across cultures with a ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Sunrise Movement at The Ohio State University",
    "purposeStatement": "The Sunrise movement seeks to spread awareness of climate change issues and how to fix them.  These corrective actions are based on the ideo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Surgery Interest Group",
    "purposeStatement": "The main objectives of SIG are to (1) encourage interaction between medical students and the Department of Surgery faculty/staff, (2) provid...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Surgery Ultrasound Community of Practice",
    "purposeStatement": "The purpose of the Surgery Ultrasound COP is to foster increased interest in both General Surgery and Ultrasound and as it applies to the fi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Surgical Student Association",
    "purposeStatement": "The purpose of the Surgical Student Association is: -To arrange meetings with undergraduate students to gain more understanding of pre-healt...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Honoraries/Honor Societies",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Survivor: Time & Change",
    "purposeStatement": "We aim to strategically create, develop, and facilitate a campus-scale, semester-long competition based on the CBS reality television compet...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Sustainability in Medicine at The Ohio State University: An Affiliate of Medical Students for a Sustainable Future",
    "purposeStatement": "Given the growing impact of climate change on human health and the tremendous size of the healthcare industry, Sustainability in Medicine is...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Sustainable Steps",
    "purposeStatement": "To take active steps towards a greener planet. Doing community service work to aid in Ohio State and the city of Columbus’ efforts to be mor...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Awareness/Activism",
      "Technology",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Swing Dance Club",
    "purposeStatement": "To provide students of The Ohio State University and community members the opportunity to learn, practice, and participate in the art and fu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Symphonic Band",
    "purposeStatement": "The overarching goal of this university concert band is to assimilate individual artistic elements into a collective musical expression of o...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Symphonic Pioneers",
    "purposeStatement": "Symphonic Pioneers aims to provide underprivileged youth with free musical education, unlocking their creative potential and fostering a lif...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "Tabletop Gaming Association",
    "purposeStatement": "The Tabletops and Gaming Association at the Ohio State University (TGA-OSU), is a recreational student organization for those who enjoy Role...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Taekwondo - Sport Club",
    "purposeStatement": "The Ohio State University Taekwondo Club strives to give members a holistic martial arts education. We dedicate ourselves to providing an en...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Taiwanese American Student Association",
    "purposeStatement": "The purpose of this organization is to provide a means through which Ohio State University students may examine the many facets of the Taiwa...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Taiwanese Student Association",
    "purposeStatement": "Maintaining and improving quality of life and education for Taiwanese students here at the Ohio State University. Promote cultural exchange ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Academic/College"
    ]
  },
  {
    "name": "Taiwanese Undergraduate Networking Association",
    "purposeStatement": "To facilitate networking opportunities among Taiwanese undergraduate students as well as international students from other countries, and pr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Talking is Medicine",
    "purposeStatement": "The group Talking is Medicine (TiM) is meant to promote the broader use of psychotherapy techniques in fields of medicine beyond psychiatry....",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "TAMID Group at Ohio State",
    "purposeStatement": "TAMID at OSU (TAMID) is an organization designed to align the professional aspirations of business-minded students with the Israeli business...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Tamil Sangam",
    "purposeStatement": "Our mission is to unite the Tamil diaspora on campus and facilitate free cultural expression.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Creative and Performing Arts",
      "Special Interest"
    ]
  },
  {
    "name": "The Task of the Curator",
    "purposeStatement": "The Task of the Curator group plans and hosts a variety of arts-related programming including art exhibitions, artist lectures, guest curato...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Tau Beta Pi Engineering Honor Society- Ohio Gamma Chapter",
    "purposeStatement": "Tau Beta Pi is the only engineering honor society representing the entire engineering profession. It is the nation's second-oldest honor soc...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies",
      "Academic/College",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Tau Beta Sigma National Honorary Band Sorority",
    "purposeStatement": "Be it known that Tau Beta Sigma, National Honorary Sorority for members of the college band, is an organization operating exclusively in the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Creative and Performing Arts",
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "Tau Epsilon Phi",
    "purposeStatement": "The organization's creed asserts its governing ideals as \"friendship, chivalry, service.\" TEP attracts and accepts brothers of all religions...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Tau Kappa Epsilon Fraternity",
    "purposeStatement": "Our mission is to aid men in their mental, moral, and social development for life.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Community Service/Service Learning",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Tea Club",
    "purposeStatement": "The purpose of Tea Club is to promote the understanding and appreciation of tea, its consumption, its history, and its culture. Tea club ser...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Ethnic/Cultural",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Team Handball Club - Sport Club",
    "purposeStatement": "The purpose of this club is to promote and introduce the sport of Team Handball to the student body of The Ohio State University while compe...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "TED Discussion Club",
    "purposeStatement": "To provide OSU students with an outlet for discussing new or interesting topics covered in the TED community and gain new perspectives on th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "TEDxOhioStateUniversity",
    "purposeStatement": "To spread the mission and initiative of the International organization, TED, to The Ohio State University. TEDxOhioStateUniversity is an ind...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Telugu Tamasha",
    "purposeStatement": "The purpose of this club is to celebrate and promote the rich culture, language, traditions, and heritage of the Telugu-speaking community. ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Religious/Spiritual",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Tennis Club at The Ohio State University - Sport Club",
    "purposeStatement": "The purpose of Ohio State Club Tennis is to provide a competitive tennis atmosphere while also giving student athletes a positive social out...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Texnikoi",
    "purposeStatement": "Texnikoi has been a distinguished engineering honorary since its founding in 1924. TNK is committed to recognizing engineering students that...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "Thai Student Association",
    "purposeStatement": "The goals are: 1. To organize social activities among its members and others who are interested in Thai cultures. 2. To advocate its members...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Religious/Spiritual",
      "Special Interest"
    ]
  },
  {
    "name": "Theme Park Engineering Group",
    "purposeStatement": "The purpose of this Organization is to enhance the technical knowledge gained by members in the classroom through applications in the theme ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Theriogenology Club",
    "purposeStatement": "The Ohio State University College of Veterinary Medicine's Theriogenology Club is affiliated with the Society for Theriogenology (SFT). The ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Theta Chi Fraternity",
    "purposeStatement": "Theta Chi strives for the highest standards of brotherhood by guaranteeing involvement, philanthropy, community service, and high academic a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities"
    ]
  },
  {
    "name": "Theta Tau Fraternity",
    "purposeStatement": "The purpose of Theta Tau is to develop and maintain a high standard of professional interest among its members, and to unite them in a stron...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Theta Xi Fraternity Chi Chapter",
    "purposeStatement": "The Purpose of Theta Xi is to provide a college home environment for its active members in which fellowship and alumni guidance lead to whol...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Thomistic Institute at The Ohio State University",
    "purposeStatement": "The Thomistic Institute at the Ohio State University aims to foster intellectual and theological discussion on the teachings of the Catholic...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Time for Change at The Ohio State University",
    "purposeStatement": "Time for Change aims to transform The Ohio State University into a model of modern global citizenship by mobilizing the community to activel...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Toastmasters",
    "purposeStatement": "We provide a supportive and positive learning experience in which members are empowered to develop communication and leadership skills, resu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Torres, Drackett, Lawrence Community Council",
    "purposeStatement": "The purpose of Torres, Drackett, Lawrence CC is to provide for the social, recreational, informational, educational diversity, wellness and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations"
    ]
  },
  {
    "name": "Towers Agricultural Honorary",
    "purposeStatement": "The purpose of this honorary shall be to further the prestige of and interest in agriculture, serve as a goal for all students and act as a ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "Towers Community Council",
    "purposeStatement": "The purpose of the Towers Community Council is to provide for the social, recreational, informational, educational, diversity, wellness, and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations"
    ]
  },
  {
    "name": "Trans*Mission",
    "purposeStatement": "Trans*Mission is a group for transgender and gender non-conforming students and allies. Trans*Mission’s aim is to provide individuals of all...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Transracial Adoptees at Ohio State",
    "purposeStatement": "We aim to bring together an identity-based community of transracial adoptees to carve out a space within the Ohio State University for discu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Tri Delta",
    "purposeStatement": "The purpose of Delta Delta Delta shall be to establish a perpetual bond of friendship among its members, to develop a stronger and more woma...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Triangle Fraternity",
    "purposeStatement": "A social fraternity for engineers, scientists, and architecture majors. Dedicated to building better men.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Technology"
    ]
  },
  {
    "name": "Triathlon Club - Sport Club",
    "purposeStatement": "The Triathlon Club at The Ohio State University serves multi-sport athletes of all abilities affiliated with The Ohio State University, enab...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Triota",
    "purposeStatement": "Triota strives to maintain values central to Women's, Gender, and Sexuality Studies: egalitarianism, inclusiveness and celebration of the di...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Honoraries/Honor Societies"
    ]
  },
  {
    "name": "True Crime Club at Ohio State",
    "purposeStatement": "The purpose of this organization shall be to provide an engaging environment for both students and community members to discuss true crime p...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Special Interest"
    ]
  },
  {
    "name": "Turf Club",
    "purposeStatement": "To bring Turfgrass management students together to discuss events, networking, the current state of the industry, and provide additional edu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Turning Point USA",
    "purposeStatement": "Turning Point USA members join together to help educate students about the importance of fiscal responsibility, free markets, and limited go...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Twilight Club",
    "purposeStatement": "The purpose of our organization is to bring together students who share a love for the Twilight movies and/or books. Students can discuss th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Tzu Chi Collegiate Association at Ohio State",
    "purposeStatement": "To carry out Master Cheng Yen’s teaching of compassion and wisdom from the humanitarian service, philanthropy, bonding and interaction among...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Religious/Spiritual"
    ]
  },
  {
    "name": "UFO/UAP Club",
    "purposeStatement": "The purpose of the UFO/UAP Club at Ohio State is to bring awareness and to explore the unidentified aerial phenomena that occur on our plane...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "UHA Columbus",
    "purposeStatement": "UHA Columbus is an innovative and progressive organization dedicated to improving universal health through preventive medicine, health educa...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "UKAN Dance Crew",
    "purposeStatement": "Our organization provides an opportunity of learning, practice, and built a community to students who interested in hiphop dance. In order t...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Special Interest",
      "Sports and Recreation",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "The Ukrainian Society of The Ohio State University",
    "purposeStatement": "To provide an opportunity for students to express their Ukrainian heritage and increase awareness of Ukraine.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Ukulele Club",
    "purposeStatement": "The Ukulele Club exists in order to further appreciation of the ukulele. We welcome all people will all types of playing experience to come ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Ultimate Disc - Men's - Sport Club",
    "purposeStatement": "The Mens Ultimate disc team is commited to introducing and teaching the game of Ultimate Frisbee. It is our main goal to spread the word of ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Ultimate Disc - Women's - Sport Club",
    "purposeStatement": "The purpose of the Women's Ultimate Disc club is to provide a place for women's and non-binary ultimate frisbee players of all levels to pla...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "UltraSound A Cappella at The Ohio State University College of Medicine",
    "purposeStatement": "The UltraSound Choir exists to provide professional students a fun and relaxed environment to sing together and the opportunities to perform...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Ultrasound in Ophthalmology Community of Practice",
    "purposeStatement": "The Ultrasound in Ophthalmology Community of Practice hopes to unite medical students, residents, fellows, and faculty within a single Commu...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Ultrasound Interest Group",
    "purposeStatement": "USIG is a program designed to build leadership and understanding of ultrasound technology and how to properly use this in the clinical setti...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Ultrasound Research Interest Group",
    "purposeStatement": "USRIG is a program designed to facilitate ultrasound research among medical professionals interested in clinician performed ultrasound.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Unchained at Ohio State",
    "purposeStatement": "The purpose of Unchained OSU is to raise awareness of human trafficking by utilizing fashion and other forms of artistic expression. We also...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Creative and Performing Arts",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Under the Sea: Marine Biology at Ohio State",
    "purposeStatement": "Under the S.E.A. wishes to create awareness and interest in marine biology through education, service, and hands-on experience. We focus on ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Undergraduate Anthropology Club",
    "purposeStatement": "The Undergraduate Anthropology Club is designed for all students, especially those interested in any aspect of the field of anthropology, to...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Undergraduate Black Law Student Association",
    "purposeStatement": "The purpose of the Undergraduate Black Law Student Association is to cultivate and foster the needs and interests of the diverse pre-law com...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Undergraduate Business Council",
    "purposeStatement": "UBC serves as the primary student governing body for undergraduate business majors, and as the umbrella group for Fisher College of Business...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Governance Organizations",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Undergraduate Chinese Student Organization",
    "purposeStatement": "Our organization is a non-political, and non-religious student organization founded in 2004 by Chinese undergraduates from mainland of China...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College"
    ]
  },
  {
    "name": "Undergraduate Economics Society",
    "purposeStatement": "The Undergraduate Economics Society serves all undergraduate students at The Ohio State University with a direct or indirect interest in eco...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Honoraries/Honor Societies",
      "Technology"
    ]
  },
  {
    "name": "Undergraduate Finance Association",
    "purposeStatement": "The Undergraduate Finance Association is a student-led organization founded with the mission to provide any student interested in finance th...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "The Undergraduate Genetic Counseling Club",
    "purposeStatement": "To offer a central place for undergraduate students interested in genetic counseling to learn more about the profession from peers and mento...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Undergraduate Neuroscience Outreach Organization",
    "purposeStatement": "Undergraduate Neuroscience Outreach Organization (UNOO) is dedicated to benefiting the students of The Ohio State University who share a pas...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Undergraduate Society of Black Leaders",
    "purposeStatement": "The Undergraduate Society Black Leaders (USBL) empowers and develops Black students through inclusive leadership development, mentorship, ne...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Undergraduate Student Government",
    "purposeStatement": "Wherein students have both the right and the obligation to guide their university, and in the belief that a democratic student government is...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Governance Organizations"
    ]
  },
  {
    "name": "UnderLings",
    "purposeStatement": "The purpose of this organization shall be to promote connections between undergraduate Linguistics majors, minors, and those interested in l...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "UndertheDock at The Ohio State University",
    "purposeStatement": "We are looking to create a community where students can find everyday people with a common love for the outdoors. We are a no pressure, low ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Underwater Robotics Team",
    "purposeStatement": "UWRT is an engineering student project team which designs, manufactures, and programs autonomous underwater vehicles. The team is currently ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Community Service/Service Learning",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Unhoused Community Advocacy and Networking",
    "purposeStatement": "The U-CAN organization aims to utilize community engagement to empower homeless women and children in the Columbus community through collabo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "UNICEF at Ohio State",
    "purposeStatement": "UNICEF at Ohio State encourages students to understand the needs and rights of children around the world, and realize that every person can ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Universities Allied for Essential Medicines",
    "purposeStatement": "As a non-profit organization rooted in a global movement of university students, UAEM aims to  (1) promote access to medicines and medical i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "University Ambassadors",
    "purposeStatement": "University Ambassadors give tours of campus. Please visit http://ambassadors.osu.edu/ for more information.",
    "campuses": [
      "Columbus"
    ],
    "categories": null
  },
  {
    "name": "University Student Consultants",
    "purposeStatement": "Cognizant of our responsibility towards the enrichment of The Ohio State University, our organization is steadfast in its commitment to elev...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "University-wide Council of Latinx Organizations",
    "purposeStatement": "The goal of UCLO is to foster communications among various social, professional, and educational Latino/ Hispanic organizations, advocate fo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest",
      "Governance Organizations"
    ]
  },
  {
    "name": "Unofficial Women's Basketball Association",
    "purposeStatement": "The Unofficial Women’s Basketball Association aims to provide a comfortable and judgment-free environment for students to play basketball no...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Uplift Youth Volunteers",
    "purposeStatement": "Our mission is to uplift and serve underprivileged children in the Columbus community by providing them with bags which include food, books,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Urdu Club",
    "purposeStatement": "The vision of Urdu Club at The Ohio State University shall be to bring recognition to the Urdu language by providing language instruction an...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College",
      "Awareness/Activism",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "The User Experience Club at The Ohio State University.",
    "purposeStatement": "The purpose of the UX Club at The Ohio State University is to uplift the UX community here at Ohio State, by teaching design and research as...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Community Service/Service Learning",
      "Academic/College"
    ]
  },
  {
    "name": "Valuing Our Identities, Cultivating Empowerment",
    "purposeStatement": "Our mission is to create a safe and supportive space for counseling students of color, including First Nations, Asian, Black or African Amer...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Academic/College"
    ]
  },
  {
    "name": "VAW Global Health Alliances: Ohio State Medical Chapter",
    "purposeStatement": "VAW Global Health Alliances is global health and development organization that partners with local professionals to develop sustainable and ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "VAW—Veterinary Outreach OSU",
    "purposeStatement": "VAW Global is a student run organization that serves to advance interests in the field of veterinary medicine and international volunteer wo...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Veteran Companion Animal Services",
    "purposeStatement": "To support the organization VCAS, a 501(c)(3), via fundraising and providing volunteer opportunities for students interested in the cause.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Veterinarians as One Inclusive Community for Empowerment",
    "purposeStatement": "Our club has two main purposes:  1) Expose those already in the profession to other cultures, lifestyles, socioeconomic groups, etc. We inte...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Veterinary Anesthesia and Pain Management Club",
    "purposeStatement": "The Veterinary Anesthesia and Pain Management Club at The Ohio State University College of Veterinary Medicine is intended to provide supple...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Veterinary Business Management Association",
    "purposeStatement": "The mission of the VBMA is to accompany and enhance the veterinary curriculum by increasing student awareness and knowledge regarding the to...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Veterinary Dermatology Club",
    "purposeStatement": "Dermatological disease is one of the most ubiquitous patient problems and obtaining clinical skills in this field is imperative for any gene...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Veterinary Jewish Student Association",
    "purposeStatement": "The purpose of the Veterinary Jewish Association is to provide a safe and inclusive association through which to practice and promote Jewish...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Veterinary Ophthalmology Club",
    "purposeStatement": "The primary purpose of this organization is to expose students to ophthalmology earlier in the veterinary curriculum. We achieve this by fre...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Veterinary Pharmacy Alliance",
    "purposeStatement": "The missions of the Veterinary Pharmacy Alliance are as follows: 1) Educate each other on each profession's training and abilities as it per...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Veterinary Public Health Club",
    "purposeStatement": "All veterinarians, from small animal practitioners to government officials will be involve in public health through out their career. Veteri...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Veterinary Radiology Club",
    "purposeStatement": "The purpose of the Veterinary Radiology Club is to promote and encourage the study of radiology and other diagnostic imaging modalities by e...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Veterinary Surgery Club",
    "purposeStatement": "The main purposes of the Veterinary Surgery Club are to further the students’ knowledge in the area of veterinary surgery specialization and...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "VEX U Robotics at The Ohio State University",
    "purposeStatement": "This organization is a competitive and result-focused VEX U team, intended primarily for those interested in honing their skills in any part...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Special Interest"
    ]
  },
  {
    "name": "Victims' Rights Ambassadors",
    "purposeStatement": "Victims’ Rights Ambassadors is an outreach program that represents the Ohio Crime Victim Justice Center (OCVJC), the only organization in Oh...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Video Essay Club",
    "purposeStatement": "The Video Essay Club (VEC) aims to provide a safe and open space for any and all students to creatively explore their academic interests thr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Creative and Performing Arts",
      "Special Interest",
      "Technology"
    ]
  },
  {
    "name": "Vietnamese Student Association",
    "purposeStatement": "The Vietnamese Student Association at The Ohio State University is a cultural, non-profit organization dedicated to the general development ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Special Interest"
    ]
  },
  {
    "name": "Village Mentors at Ohio State",
    "purposeStatement": "We empower underprivileged children and communities globally through building impactful, scalable learning hubs sustained with virtual mento...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Vineyard Columbus InterVarsity",
    "purposeStatement": "We are a “both-and” Christian student org rather than “either or.” We are contemplative and charismatic. We value unity and strive for diver...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Vinyl Club",
    "purposeStatement": "Vinyl Club aims to introduce people to the vinyl medium, teach people how to work with vinyl related equipment, form friendships, and to lis...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Virtual Reality Flight Simulation at The Ohio State University",
    "purposeStatement": "The purpose of this organization is to create, provide, and maintain the equipment necessary to supplement student flight training with virt...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Vocalize",
    "purposeStatement": "The mission of Vocalize Columbus is to improve patient experience & health outcomes for limited English proficiency individuals by remotely ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Voice In Sport Ohio State",
    "purposeStatement": "To build a strong community of women who feel confident in athletic environments. We strive to promote visibility and representation in coll...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Voices of the Black Academy",
    "purposeStatement": "Voices of the Black Academy is an organization composed of undergraduate, graduate, and professional students with a mission to promote acad...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Volleyball - Men's - Sport Club",
    "purposeStatement": "The Men's Volleyball Club at Ohio State provides students of all skill levels with the opportunity to participate in competitive volleyball ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Volleyball - Women's - Sport Club",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Volunteer Income Tax Assistance Program",
    "purposeStatement": "The purpose of the Volunteer Income Tax Assistance Program is to provide income tax preparation assistance to low income taxpayers.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Voyage",
    "purposeStatement": "Empower young people with disabilities through mentorship and guide them through important life milestones.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College"
    ]
  },
  {
    "name": "Waffle House Club at The Ohio State University",
    "purposeStatement": "Waffle House Club at The Ohio State University is a social club dedicated to creating a sense of community among students that enjoy Waffle ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest"
    ]
  },
  {
    "name": "Water Polo - Men's - Sport Club",
    "purposeStatement": "The Men’s Water Polo Club at Ohio State acts to promote physical and mental well-being for its members by providing an environment of comrad...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Water Polo - Women's - Sport Club",
    "purposeStatement": "The purpose of the team will be to provide water polo workouts, competitions, clinics, social functions, education and any other activities ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Water Ski Team - Sport Club",
    "purposeStatement": "The Ohio State University Water Ski Team is an organization for those interested in improving skills and competing in water sports. Everyone...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation"
    ]
  },
  {
    "name": "Water Symposium Committee",
    "purposeStatement": "To bring together researchers across The Ohio State University focusing on water in different disciplinaries to foster collaboration.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Waterski Club",
    "purposeStatement": "The Waterski Club is composed of recreational skiers of all skill levels. It’s objective is to promote collegiate water skiing and provide i...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "WAVMA at The Ohio State University College of Veterinary Medicine",
    "purposeStatement": "The Mission of WAVMA-Ohio State is to provide Ohio State-CVM students and other Ohio State students with graduate standing with educational,...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Wellness Advocacy at Ohio State",
    "purposeStatement": "Promote and advocate for the Ten Dimensions of Wellness to be a centralized part of the student experience as well as create a space for wel...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Governance Organizations",
      "Special Interest"
    ]
  },
  {
    "name": "Western Sahel Student Association",
    "purposeStatement": "Western Sahel Student Association aims to provide a space where students of Mauritanian, Senegalese, Gambian, Malian, and Guinean descent (W...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Wholesome Activities Club",
    "purposeStatement": "Bringing together those who enjoy doing simple and fun activities in the presence of like-minded individuals.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Community Service/Service Learning",
      "Creative and Performing Arts",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Wigs for Kids at Ohio State",
    "purposeStatement": "Wigs for Kids at Ohio State is a student-run collegiate subsection of the non-profit Wigs for Kids. The club/organization’s purpose is to ra...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Wilderness Medicine Interest Group",
    "purposeStatement": "The Wilderness Medicine Interest Group is dedicated to providing resources to medical students interested in career opportunities related to...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Sports and Recreation"
    ]
  },
  {
    "name": "Women and Gender Minorities in Physics",
    "purposeStatement": "The purpose of the WaGMiP is to promote involvement of, career and academic development for, and sense of community among the graduate and u...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Women Founders at The Ohio State University",
    "purposeStatement": "To create a lifelong network of support and resources for women founders to develop mutually-beneficial relationships, inspire each other, a...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Women in Business",
    "purposeStatement": "To foster a community of students interested in empowering women by encouraging personal and professional growth in supportive environments ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Women in Cybersecurity",
    "purposeStatement": "Women in CyberSecurity (WiCyS) is the premier organization with national reach dedicated to bringing together women in cybersecurity from ac...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Technology",
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Women in Economics",
    "purposeStatement": "The primary focus of Women in Economics is to empower women by increasing their representation at all levels in the economics field, while f...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Women in Flight at The Ohio State University",
    "purposeStatement": "Women in Flight at The Ohio State University is a student organization dedicated to the encouragement and advancement of women in all aviati...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "Women in Gaming",
    "purposeStatement": "Women In Gaming's mission is to provide a welcoming and empowering place for women, and other gender minorities, who play and love video gam...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Special Interest",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Women In Law",
    "purposeStatement": "The purpose of the Women in Law undergraduate organization is to provide a supportive and inclusive community for undergraduate women intere...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Women in Math and Science",
    "purposeStatement": "Established in 2006, the Women in Math and Science Club at The Ohio State University was created to unite women with similar interests, prom...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Women in Medicine",
    "purposeStatement": "WIM is dedicated to increasing the representation, visibility, and unity of women in academic and clinical medicine.  Medicine is in a time ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Women in Real Estate",
    "purposeStatement": "To empower women in the real estate industry by providing a platform for networking, education, and professional development.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Women In Surgery Empowerment Club",
    "purposeStatement": "The Women In Surgery Empowerment Club aims to empower women to become Surgeons.  As minorities in the surgical field, many women are swayed ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning",
      "Special Interest",
      "Academic/College"
    ]
  },
  {
    "name": "Women of Knowlton",
    "purposeStatement": "Women of Knowlton is an advocacy group for the advancement of gender-equity within architecture, landscape architecture, and city and region...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Academic/College",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Women's Glee Club at The Ohio State University",
    "purposeStatement": "The Women’s Glee Club at The Ohio State University strives to connect and empower women through music-making and sisterhood, emphasizing the...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Creative and Performing Arts",
      "Social Fraternities/Sororities",
      "Special Interest",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Women's Legal Society",
    "purposeStatement": "Women's Legal Society is committed to providing a common ground for women of all viewpoints and backgrounds to communicate about their exper...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "The Women's Network at The Ohio State University",
    "purposeStatement": "To create a community that celebrates women’s and nonbinary people’s desire to achieve, cultivating their ambition in order to prepare the n...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism",
      "Special Interest"
    ]
  },
  {
    "name": "Women's Powerlifting Club at The Ohio State University - Sport Club",
    "purposeStatement": "We are a community of women looking to find others to get stronger both in and out of the gym. This is fulfilled through private team practi...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Community Service/Service Learning",
      "Special Interest"
    ]
  },
  {
    "name": "The Women’s Team Handball Club at The Ohio State University - Sport Club",
    "purposeStatement": "The purpose of this club is to promote and introduce the sport of team handball to the women of The Ohio State University.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Women’s Veterinary Leadership Development Initiative",
    "purposeStatement": "WVLDI’s Mission is to support women in seeking and achieving leadership, policy, and decision-making positions within all areas of professio...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Working Professional MBA Council",
    "purposeStatement": "The Working Professional MBA Student Council is a student led governing body whose primary purpose is to represent the interests of Working ...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest",
      "Governance Organizations"
    ]
  },
  {
    "name": "The Wrestling Club at The Ohio State University - Sport Club",
    "purposeStatement": "The Sport Club program is designed to serve individual interests in different sports and recreational activities. Participation in the progr...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Sports and Recreation",
      "Special Interest"
    ]
  },
  {
    "name": "Writers Guild at The Ohio State University",
    "purposeStatement": "The Writers Guild was created to 1) allow a unified and more powerful voice in departmental decisions affecting the Creative Writing Program...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Media, Journalism, and Creative Writing",
      "Academic/College",
      "Creative and Performing Arts"
    ]
  },
  {
    "name": "Writing on the Wall at The Ohio State University",
    "purposeStatement": "The purpose of WOW is to unite the campus community, including students, faculty, staff, and organizations, by confronting human rights atro...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism"
    ]
  },
  {
    "name": "Young Adult Ministries",
    "purposeStatement": "Young Adult Ministries (YAMS) will offer the students of THE Ohio State University a place to study the Bible through an Episcopal lens...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual",
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Young Democratic Socialists at Ohio State",
    "purposeStatement": "Building power in our community to fight for the immediate needs of workers and students, Equality, Justice and Democratic Socialism.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Awareness/Activism",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Young Life",
    "purposeStatement": "Our Vision A community where every student will have the opportunity to meet Jesus Christ and follow Him.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Religious/Spiritual"
    ]
  },
  {
    "name": "Youth for STEM Equity at The Ohio State University",
    "purposeStatement": "Youth for STEM Equity (YSE) at The Ohio State University is directed to be a chapter of YSE based in OSU that works towards proliferating ac...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Community Service/Service Learning",
      "Academic/College",
      "Awareness/Activism"
    ]
  },
  {
    "name": "Zamobuckeyes",
    "purposeStatement": "There is a rich history of collaboration between Zamorano University in Honduras and The Ohio State University (OSU) that includes exchanges...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning",
      "Ethnic/Cultural"
    ]
  },
  {
    "name": "Zebrafish Research Student Organization",
    "purposeStatement": "The Zebrafish Student Organization focuses on incorporating students involved in zebrafish research at OSU to be a part of outreach and enga...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Zeta Phi Beta Sorority, Incorporated",
    "purposeStatement": "To foster the ideas of service, charity, scholarship, civil and cultural endeavors, sisterhood and finer womanhood.",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Ethnic/Cultural",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Zeta Tau Alpha",
    "purposeStatement": "The purpose of Zeta Tau Alpha is the intensifying of friendship, the fostering of a spirit of love, the creating of such sentiments, the per...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Social Fraternities/Sororities",
      "Academic/College",
      "Community Service/Service Learning"
    ]
  },
  {
    "name": "Zoo, Wildlife, and Conservation Medicine Club",
    "purposeStatement": "The purpose of the OSU CVM Zoo, Wildlife, and Conservation Medicine Club is to provide educational and hands-on experiences to students inte...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Zoology Club at The Ohio State University",
    "purposeStatement": "The purpose of Zoology Club is to enhance the academic experience of Ohio State University students, faculty, and staff interested in Zoolog...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Academic/College",
      "Special Interest"
    ]
  },
  {
    "name": "Zuvaa Afro-Caribbean Dancers",
    "purposeStatement": "Through a range of different dances from different regions of both Africa and the Caribbean, our dance group works to bring light and expres...",
    "campuses": [
      "Columbus"
    ],
    "categories": [
      "Ethnic/Cultural",
      "Creative and Performing Arts",
      "Sports and Recreation"
    ]
  }
];
